export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A type representing BigDecimal */
  BigDecimal: { input: any; output: any; }
  /** A type representing a formatted an instantaneous point on the timeline */
  Instant: { input: any; output: any; }
  /** A type representing local date */
  LocalDate: { input: any; output: any; }
  /** A type representing local time */
  LocalTime: { input: any; output: any; }
  /** A type representing long */
  Long: { input: any; output: any; }
  /** A type representing a string identifier */
  UUID: { input: any; output: any; }
  /** A type representing uploaded file */
  Upload: { input: any; output: any; }
};

export type ActionItemFilterInput = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  dueDateRange?: InputMaybe<DateRangeInput>;
};

export type ActionItemInput = {
  assigneeAgentId?: InputMaybe<Scalars['UUID']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  done: Scalars['Boolean']['input'];
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
};

export type ActionItemOutput = {
  __typename?: 'ActionItemOutput';
  aiGenerated?: Maybe<Scalars['Boolean']['output']>;
  assigneeAgentId?: Maybe<Scalars['UUID']['output']>;
  assigneeAgentName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientNoteId?: Maybe<Scalars['UUID']['output']>;
  completedAt?: Maybe<Scalars['Instant']['output']>;
  completionMethod?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Instant']['output'];
  done: Scalars['Boolean']['output'];
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['UUID']['output'];
  managerApprovalStatus?: Maybe<Scalars['String']['output']>;
  photoVerificationAttemptsRemaining?: Maybe<Scalars['Int']['output']>;
  photoVerificationStatus?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
  verificationResolution?: Maybe<Scalars['String']['output']>;
};

export enum ActionItemSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum ActionItemSortField {
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE'
}

export type ActionItemSortInput = {
  direction: ActionItemSortDirection;
  field: ActionItemSortField;
};

export type Address = {
  __typename?: 'Address';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressDto = {
  __typename?: 'AddressDto';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressDtoInput = {
  aptNumber: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AdminRingState = {
  __typename?: 'AdminRingState';
  closed: Scalars['Boolean']['output'];
  done: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminTaskResult = {
  __typename?: 'AdminTaskResult';
  confirmation?: Maybe<Scalars['String']['output']>;
  credited: Scalars['Boolean']['output'];
  guard?: Maybe<GuardResult>;
  ring: AdminRingState;
};

export type AdvisorDetailsInput = {
  phone: Scalars['String']['input'];
};

export type AdvisorDetailsOutput = {
  __typename?: 'AdvisorDetailsOutput';
  phone?: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
};

export type AffiliationPartnershipOutput = {
  __typename?: 'AffiliationPartnershipOutput';
  campaign: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
};

export type AgentAvailabilityOutput = {
  __typename?: 'AgentAvailabilityOutput';
  agentEmail: Scalars['String']['output'];
  availableSlotCount: Scalars['Int']['output'];
  busyPeriods: Array<BusyPeriod>;
  freeBlocks: Array<FreeBlock>;
  isWorkingDay: Scalars['Boolean']['output'];
  nextAvailableSlot?: Maybe<FreeBlock>;
  workingEnd?: Maybe<Scalars['Instant']['output']>;
  workingStart?: Maybe<Scalars['Instant']['output']>;
};

export type AgentAvailabilityStateCallDetails = {
  __typename?: 'AgentAvailabilityStateCallDetails';
  clientEmail: Scalars['String']['output'];
  clientId: Scalars['UUID']['output'];
  clientName: Scalars['String']['output'];
};

export type AgentAvailabilityStateOutput = {
  __typename?: 'AgentAvailabilityStateOutput';
  agentEmail: Scalars['String']['output'];
  agentId: Scalars['UUID']['output'];
  agentName: Scalars['String']['output'];
  airCallAvailabilityStatus?: Maybe<Scalars['String']['output']>;
  availabilityIsUpdatedAt?: Maybe<Scalars['Instant']['output']>;
  csr: Scalars['Boolean']['output'];
  dontDisturb: Scalars['Boolean']['output'];
  excludedFromRoundRobin: Scalars['Boolean']['output'];
  isAvailableForNewLeads: Scalars['Boolean']['output'];
  licensedStates?: Maybe<Scalars['String']['output']>;
  onCall: Scalars['Boolean']['output'];
  onCallWithClient?: Maybe<AgentAvailabilityStateCallDetails>;
  online: Scalars['Boolean']['output'];
  picUrl?: Maybe<Scalars['String']['output']>;
};

export type AgentCallAgendaOutput = {
  __typename?: 'AgentCallAgendaOutput';
  agentsOnline: Array<AgentsOnline>;
  assignedClientsCallTasks: Array<Scalars['UUID']['output']>;
  dontDisturb: Scalars['Boolean']['output'];
  scheduledReassignAt?: Maybe<Scalars['Instant']['output']>;
};

export enum AgentCallAgendaTaskAssignmentTypeOutput {
  Agent = 'AGENT',
  Csr = 'CSR'
}

export type AgentCallAgendaTaskCurrentAssignmentOutput = {
  __typename?: 'AgentCallAgendaTaskCurrentAssignmentOutput';
  assignedAgentEmail?: Maybe<Scalars['String']['output']>;
  assignedAgentId?: Maybe<Scalars['UUID']['output']>;
  assignedAgentName?: Maybe<Scalars['String']['output']>;
  assignedUntil?: Maybe<Scalars['Instant']['output']>;
  scheduledReassignAt?: Maybe<Scalars['Instant']['output']>;
  type: AgentCallAgendaTaskAssignmentTypeOutput;
};

export type AgentCallAgendaTaskHistoryItemOutput = {
  __typename?: 'AgentCallAgendaTaskHistoryItemOutput';
  agentEmail?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  type: AgentCallAgendaTaskAssignmentTypeOutput;
};

export type AgentCallAgendaTaskInPoolOutput = {
  __typename?: 'AgentCallAgendaTaskInPoolOutput';
  clientId: Scalars['UUID']['output'];
  inPoolUntil: Scalars['Instant']['output'];
};

export type AgentCallAgendaTaskOutput = {
  __typename?: 'AgentCallAgendaTaskOutput';
  assignmentHistory: Array<AgentCallAgendaTaskHistoryItemOutput>;
  clientEmail: Scalars['String']['output'];
  clientId: Scalars['UUID']['output'];
  clientName: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['Instant']['output'];
  currentAssignment?: Maybe<AgentCallAgendaTaskCurrentAssignmentOutput>;
  isNew: Scalars['Boolean']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  priorityReason?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AgentCommissionMonthOutput = {
  __typename?: 'AgentCommissionMonthOutput';
  closeMonth: Scalars['LocalDate']['output'];
  currentTier: Scalars['Int']['output'];
  hospitalIndemnityCloseCount: Scalars['Int']['output'];
  hospitalIndemnityCommission: Scalars['BigDecimal']['output'];
  maMedigapCloseCount: Scalars['Int']['output'];
  maMedigapCommission: Scalars['BigDecimal']['output'];
  pdpCloseCount: Scalars['Int']['output'];
  pdpCommission: Scalars['BigDecimal']['output'];
  totalCommission: Scalars['BigDecimal']['output'];
};

export type AgentCurrentClientsMetricsFilterInput = {
  agentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type AgentCurrentClientsMetricsOutput = {
  __typename?: 'AgentCurrentClientsMetricsOutput';
  agentEmail: Scalars['String']['output'];
  agentEnabled: Scalars['Boolean']['output'];
  agentId: Scalars['UUID']['output'];
  agentName: Scalars['String']['output'];
  followUpFuture: Scalars['Int']['output'];
  followUpNotFuture: Scalars['Int']['output'];
  followUpOutdated: Scalars['Int']['output'];
  sqlNotFuture: Scalars['Int']['output'];
  sqlOutdated: Scalars['Int']['output'];
  sqlUpFuture: Scalars['Int']['output'];
};

export type AgentEmailAttachmentOutput = {
  __typename?: 'AgentEmailAttachmentOutput';
  attachmentId?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type AgentEmailOutput = {
  __typename?: 'AgentEmailOutput';
  agentId: Scalars['UUID']['output'];
  attachments: Array<AgentEmailAttachmentOutput>;
  bcc?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  gmailLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type AgentEmailPageOutput = {
  __typename?: 'AgentEmailPageOutput';
  data: Array<AgentEmailOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AgentEnrollmentBucketOutput = {
  __typename?: 'AgentEnrollmentBucketOutput';
  clientCount: Scalars['Int']['output'];
  closeMonth: Scalars['LocalDate']['output'];
  productBucket?: Maybe<Scalars['String']['output']>;
};

export enum AgentField {
  Email = 'EMAIL',
  Enabled = 'ENABLED',
  Name = 'NAME'
}

export type AgentFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgentFuToSqlConversionOutput = {
  __typename?: 'AgentFuToSqlConversionOutput';
  agentConversionPct: Scalars['Float']['output'];
  benchmarkPct: Scalars['Float']['output'];
  fuCount: Scalars['Int']['output'];
  fuMonth: Scalars['LocalDate']['output'];
  fuToSqlCount: Scalars['Int']['output'];
  topAgentPct: Scalars['Float']['output'];
};

export type AgentInput = {
  b2bMeetingUrl?: InputMaybe<Scalars['String']['input']>;
  consultationUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  enrollmentMeetingUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picUrl?: InputMaybe<Scalars['String']['input']>;
  planReviewUrl?: InputMaybe<Scalars['String']['input']>;
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgentRoleInput>;
};

export type AgentOutput = {
  __typename?: 'AgentOutput';
  b2bMeetingUrl?: Maybe<Scalars['String']['output']>;
  consultationUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  enabledForRoundRobin?: Maybe<Scalars['Boolean']['output']>;
  enrollmentMeetingUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isCSR: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  licensedStates: Array<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  picUrl?: Maybe<Scalars['String']['output']>;
  planReviewUrl?: Maybe<Scalars['String']['output']>;
  receiveEmails: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
};

export type AgentOvertimeOutput = {
  __typename?: 'AgentOvertimeOutput';
  agentId: Scalars['UUID']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  openHours: Scalars['BigDecimal']['output'];
  overtimeHours: Scalars['BigDecimal']['output'];
  paidSoFar: Scalars['BigDecimal']['output'];
  projectedHours: Scalars['BigDecimal']['output'];
  remainingScheduledHours: Scalars['BigDecimal']['output'];
  scheduledHours: Scalars['BigDecimal']['output'];
};

export type AgentPerformanceMetricOutput = {
  __typename?: 'AgentPerformanceMetricOutput';
  primaryKey: Scalars['String']['output'];
  secondaryKey?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['BigDecimal']['output']>;
};

export type AgentPriorityPoolStandingOutput = {
  __typename?: 'AgentPriorityPoolStandingOutput';
  agent: Scalars['String']['output'];
  agentId: Scalars['UUID']['output'];
  nextTier?: Maybe<PriorityPoolNextTierOutput>;
  priorityClosesMtd: Scalars['Int']['output'];
  priorityPoolPayoutUsd: Scalars['Int']['output'];
  progressPct: Scalars['Float']['output'];
  tags: Array<PriorityPoolTagOutput>;
  tierLadder: Array<PriorityPoolTierOutput>;
  tierReached?: Maybe<Scalars['Int']['output']>;
};

export type AgentProjectedClosesCohortOutput = {
  __typename?: 'AgentProjectedClosesCohortOutput';
  cohortStartDate: Scalars['LocalDate']['output'];
  expectedClosesHigh: Scalars['Int']['output'];
  expectedClosesLow: Scalars['Int']['output'];
  expectedClosesWarm: Scalars['Int']['output'];
  rawHigh: Scalars['Int']['output'];
  rawLow: Scalars['Int']['output'];
  rawTotalSql: Scalars['Int']['output'];
  rawUnclassified: Scalars['Int']['output'];
  rawWarm: Scalars['Int']['output'];
  totalExpectedCloses: Scalars['Int']['output'];
};

export type AgentQaReportOutput = {
  __typename?: 'AgentQaReportOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  mostFailedQuestions: Array<QaQuestionStatOutput>;
  pointsLostByCategory: Array<QaCategoryStatOutput>;
  recentCalls: Array<QaCallRowOutput>;
  summary: QaSummaryOutput;
};

export type AgentRankingLeaderboardOutput = {
  __typename?: 'AgentRankingLeaderboardOutput';
  agentId: Scalars['UUID']['output'];
  agentName?: Maybe<Scalars['String']['output']>;
  closes: Scalars['Int']['output'];
  commission: Scalars['BigDecimal']['output'];
  currentRank: Scalars['Int']['output'];
  fuToSqlPct: Scalars['Float']['output'];
  previousRank?: Maybe<Scalars['Int']['output']>;
  rankChange?: Maybe<Scalars['Int']['output']>;
  sqlToAppPct: Scalars['Float']['output'];
};

export enum AgentRoleInput {
  RoleAdmin = 'ROLE_ADMIN',
  RoleAgentManager = 'ROLE_AGENT_MANAGER',
  RoleCsr = 'ROLE_CSR',
  RoleCsrManager = 'ROLE_CSR_MANAGER',
  RoleSuperAdmin = 'ROLE_SUPER_ADMIN',
  RoleTechStaff = 'ROLE_TECH_STAFF'
}

export enum AgentSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AgentSortInput = {
  direction: AgentSortDirection;
  field: AgentField;
};

export type AgentSqlMonthOutput = {
  __typename?: 'AgentSqlMonthOutput';
  activeHighCount: Scalars['Int']['output'];
  activeLowCount: Scalars['Int']['output'];
  activeTotal: Scalars['Int']['output'];
  activeUnclassifiedCount: Scalars['Int']['output'];
  activeWarmCount: Scalars['Int']['output'];
  highCount: Scalars['Int']['output'];
  lowCount: Scalars['Int']['output'];
  month: Scalars['LocalDate']['output'];
  total: Scalars['Int']['output'];
  unclassifiedCount: Scalars['Int']['output'];
  warmCount: Scalars['Int']['output'];
};

export type AgentSqlToAppConversionOutput = {
  __typename?: 'AgentSqlToAppConversionOutput';
  agentConversionPct: Scalars['Float']['output'];
  benchmarkPct: Scalars['Float']['output'];
  sqlCount: Scalars['Int']['output'];
  sqlMonth: Scalars['LocalDate']['output'];
  sqlToAppCount: Scalars['Int']['output'];
  topAgentPct: Scalars['Float']['output'];
};

export type AgentTimelineOutput = {
  __typename?: 'AgentTimelineOutput';
  agentId: Scalars['UUID']['output'];
  departmentId?: Maybe<Scalars['UUID']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  plannedSegments: Array<ScheduleSegmentOutput>;
  scheduledEnd?: Maybe<Scalars['Instant']['output']>;
  scheduledStart?: Maybe<Scalars['Instant']['output']>;
  segments: Array<TimelineSegmentOutput>;
  status: TimelineStatus;
  unclosed: Scalars['Boolean']['output'];
};

export type AgentUpcomingFollowUpsOutput = {
  __typename?: 'AgentUpcomingFollowUpsOutput';
  laterCount: Scalars['Int']['output'];
  thisWeekCount: Scalars['Int']['output'];
  todayCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AgentViewOutput = {
  __typename?: 'AgentViewOutput';
  b2bMeetingUrl?: Maybe<Scalars['String']['output']>;
  consultationUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enrollmentMeetingUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  picUrl?: Maybe<Scalars['String']['output']>;
  planReviewUrl?: Maybe<Scalars['String']['output']>;
};

export type AgentWorkingHoursOutput = {
  __typename?: 'AgentWorkingHoursOutput';
  agentEmail: Scalars['String']['output'];
  calendarEventId?: Maybe<Scalars['String']['output']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['LocalTime']['output'];
  startTime: Scalars['LocalTime']['output'];
  timezone: Scalars['String']['output'];
};

export type AgentsOnline = {
  __typename?: 'AgentsOnline';
  agentId: Scalars['UUID']['output'];
  firstName: Scalars['String']['output'];
  isCsr: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
};

export type AllEnrollmentsFilterInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdByAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EnrollmentType>;
};

export type AppointmentInviteeOutput = {
  __typename?: 'AppointmentInviteeOutput';
  clientId?: Maybe<Scalars['UUID']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AppointmentOutput = {
  __typename?: 'AppointmentOutput';
  agent: AgentOutput;
  createdAt: Scalars['Instant']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Instant']['output']>;
  invitee: AppointmentInviteeOutput;
  name: Scalars['String']['output'];
  noShow?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['Instant']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
  url: Scalars['String']['output'];
};

export type AppointmentRequestOutput = {
  __typename?: 'AppointmentRequestOutput';
  clientId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['Instant']['output'];
  createdCalendlyId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  requestedAppointmentAt?: Maybe<Scalars['String']['output']>;
};

export type AriaCopilotOptionOutput = {
  __typename?: 'AriaCopilotOptionOutput';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AriaCopilotOutput = {
  __typename?: 'AriaCopilotOutput';
  agentId: Scalars['UUID']['output'];
  answer?: Maybe<Scalars['String']['output']>;
  blocksJson?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  missing: Array<Scalars['String']['output']>;
  optionType?: Maybe<Scalars['String']['output']>;
  options: Array<AriaCopilotOptionOutput>;
  progress?: Maybe<ProgressOutput>;
  prompt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: AriaCopilotOutputType;
};

export enum AriaCopilotOutputType {
  Message = 'MESSAGE',
  Progress = 'PROGRESS'
}

export type AssignedTagViewOutput = {
  __typename?: 'AssignedTagViewOutput';
  aiGenerated?: Maybe<Scalars['Boolean']['output']>;
  expiresAt?: Maybe<Scalars['Instant']['output']>;
  tag: TagViewOutput;
};

export type AssignmentHistoryOutput = {
  __typename?: 'AssignmentHistoryOutput';
  agentName: Scalars['String']['output'];
  assignmentDate: Scalars['Instant']['output'];
  assignmentType: AssignmentHistoryType;
};

export enum AssignmentHistoryType {
  Assign = 'ASSIGN',
  ClearAssign = 'CLEAR_ASSIGN',
  Unwatch = 'UNWATCH',
  Watch = 'WATCH'
}

export type AttemptedLeadFilterInput = {
  badNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  excludeAiCalledToday?: InputMaybe<Scalars['Boolean']['input']>;
  excludeBadNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCalledToday?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDoNotCall?: InputMaybe<Scalars['Boolean']['input']>;
  excludedTags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  iep?: InputMaybe<Scalars['Boolean']['input']>;
  includedTags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  leadGroup?: InputMaybe<AttemptedLeadGroupDto>;
  range?: InputMaybe<DateRangeInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<StatusDto>>;
  timeZone?: InputMaybe<ClientViewTimeZone>;
};

export enum AttemptedLeadGroupDto {
  CalledToday = 'CALLED_TODAY',
  Group_1 = 'GROUP_1',
  Group_2 = 'GROUP_2',
  Group_3 = 'GROUP_3',
  Group_4 = 'GROUP_4',
  Group_5 = 'GROUP_5',
  Group_6 = 'GROUP_6',
  Group_7 = 'GROUP_7'
}

export type AttemptedLeadOutput = {
  __typename?: 'AttemptedLeadOutput';
  birthDate?: Maybe<Scalars['Instant']['output']>;
  callsCount: Scalars['Int']['output'];
  clientId: Scalars['UUID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  iepFlag?: Maybe<Scalars['Boolean']['output']>;
  lastCallAgentFullName?: Maybe<Scalars['String']['output']>;
  lastCallDate?: Maybe<Scalars['Instant']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadDate: Scalars['Instant']['output'];
  leadGroup?: Maybe<AttemptedLeadGroupDto>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: Status;
  tags: Array<AssignedTagViewOutput>;
  urgent: Scalars['Boolean']['output'];
};

export enum AttemptedLeadSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum AttemptedLeadSortField {
  Birthdate = 'BIRTHDATE',
  LeadDate = 'LEAD_DATE'
}

export type AttemptedLeadSortInput = {
  direction: AttemptedLeadSortDirection;
  field: AttemptedLeadSortField;
};

export type BulkReconnectResult = {
  __typename?: 'BulkReconnectResult';
  creditedCount: Scalars['Int']['output'];
  results: Array<ReconnectActionResult>;
  summary?: Maybe<GuardResult>;
  totalCount: Scalars['Int']['output'];
};

export type BulkScheduleAiCallResult = {
  __typename?: 'BulkScheduleAiCallResult';
  results: Array<ScheduleAiCallResult>;
  scheduledCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type BulkScheduleEntryError = {
  __typename?: 'BulkScheduleEntryError';
  agentId: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  workDate: Scalars['LocalDate']['output'];
};

export type BulkScheduleEntryInput = {
  agentId: Scalars['UUID']['input'];
  breakMinutes?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  workDate: Scalars['LocalDate']['input'];
};

export type BulkSetScheduleOutput = {
  __typename?: 'BulkSetScheduleOutput';
  approvedDaysKept: Scalars['Int']['output'];
  daysSkipped: Scalars['Int']['output'];
  daysWritten: Scalars['Int']['output'];
  errors: Array<BulkScheduleEntryError>;
};

export type BusyPeriod = {
  __typename?: 'BusyPeriod';
  end: Scalars['Instant']['output'];
  start: Scalars['Instant']['output'];
};

export enum CalcDrugFrequencyPeriodInput {
  Daily = 'DAILY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum CalcDrugFrequencyPeriodViewOutput {
  Daily = 'DAILY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type CalendarEventAttendeeOutput = {
  __typename?: 'CalendarEventAttendeeOutput';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export enum CalendarEventChangeType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type CalendarEventOutput = {
  __typename?: 'CalendarEventOutput';
  attendeeEmails: Array<Scalars['String']['output']>;
  attendees?: Maybe<Array<CalendarEventAttendeeOutput>>;
  colorId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Instant']['output']>;
  creatorEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dialInPhone?: Maybe<Scalars['String']['output']>;
  dialInPin?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Instant']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  htmlLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  meetLink?: Maybe<Scalars['String']['output']>;
  morePhoneNumbersUrl?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  recurrence?: Maybe<Array<Scalars['String']['output']>>;
  reminderMinutes?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['Instant']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Instant']['output']>;
};

export enum CalendarEventResponse {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Tentative = 'TENTATIVE'
}

export type CalendarEventUpdateOutput = {
  __typename?: 'CalendarEventUpdateOutput';
  agentEmail: Scalars['String']['output'];
  changeType: CalendarEventChangeType;
  event?: Maybe<CalendarEventOutput>;
  eventId: Scalars['String']['output'];
};

export type CalendarEventsOutput = {
  __typename?: 'CalendarEventsOutput';
  events: Array<CalendarEventOutput>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CalendlyAppointmentsFilterInput = {
  startFrom?: InputMaybe<Scalars['Instant']['input']>;
  startTo?: InputMaybe<Scalars['Instant']['input']>;
};

export enum CalendlyAppointmentsSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum CalendlyAppointmentsSortField {
  StartTime = 'startTime'
}

export type CalendlyAppointmentsSortInput = {
  direction: CalendlyAppointmentsSortDirection;
  field: CalendlyAppointmentsSortField;
};

export type CallHistoryAiAnalysisOutput = {
  __typename?: 'CallHistoryAIAnalysisOutput';
  aiAnalysis: Scalars['String']['output'];
  airCallTimeline?: Maybe<Scalars['String']['output']>;
  callHistoryId: Scalars['UUID']['output'];
};

export type CallHistoryAnalysisOutput = {
  __typename?: 'CallHistoryAnalysisOutput';
  sentiment?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CallHistoryCallType {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type CallHistoryInput = {
  callType?: InputMaybe<CallHistoryCallType>;
  clientId: Scalars['UUID']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber: Scalars['String']['input'];
  result?: InputMaybe<CallHistoryResultInput>;
};

export type CallHistoryOutput = {
  __typename?: 'CallHistoryOutput';
  agent?: Maybe<AgentViewOutput>;
  airCallId?: Maybe<Scalars['Long']['output']>;
  audioRecordId?: Maybe<Scalars['Long']['output']>;
  callHistoryAnalysis?: Maybe<CallHistoryAnalysisOutput>;
  callQa?: Maybe<CallQaOutput>;
  callType?: Maybe<CallHistoryCallType>;
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  handledByVoiceAi: Scalars['Boolean']['output'];
  hasAIAnalysis: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['UUID']['output']>;
  maskedTranscript?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  voiceRecordingId?: Maybe<Scalars['String']['output']>;
};

export enum CallHistoryResultInput {
  SuccessfulAiBookedCall = 'SUCCESSFUL_AI_BOOKED_CALL',
  SuccessfulAiSeeNotesForCallDetails = 'SUCCESSFUL_AI_SEE_NOTES_FOR_CALL_DETAILS',
  SuccessfulAiTransferredOnError = 'SUCCESSFUL_AI_TRANSFERRED_ON_ERROR',
  SuccessfulAiTransferredToAgent = 'SUCCESSFUL_AI_TRANSFERRED_TO_AGENT',
  SuccessfulBookedCall = 'SUCCESSFUL_BOOKED_CALL',
  SuccessfulSeeNotesForCallDetails = 'SUCCESSFUL_SEE_NOTES_FOR_CALL_DETAILS',
  SuccessfulWarmTransfer = 'SUCCESSFUL_WARM_TRANSFER',
  UnsuccessfulAiEndedOnVoicemail = 'UNSUCCESSFUL_AI_ENDED_ON_VOICEMAIL',
  UnsuccessfulAiError = 'UNSUCCESSFUL_AI_ERROR',
  UnsuccessfulAiNoAnswer = 'UNSUCCESSFUL_AI_NO_ANSWER',
  UnsuccessfulInvalidNumber = 'UNSUCCESSFUL_INVALID_NUMBER',
  UnsuccessfulLeftEmail = 'UNSUCCESSFUL_LEFT_EMAIL',
  UnsuccessfulLeftText = 'UNSUCCESSFUL_LEFT_TEXT',
  UnsuccessfulLeftVm = 'UNSUCCESSFUL_LEFT_VM'
}

export type CallQaFilterInput = {
  agentIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  answer?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  isEnrollmentCall?: InputMaybe<Scalars['Boolean']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DateRangeInput>;
  scoreMax?: InputMaybe<Scalars['Int']['input']>;
  scoreMin?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusDto>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CallQaOutput = {
  __typename?: 'CallQaOutput';
  applicableMax?: Maybe<Scalars['Int']['output']>;
  coachingRecommendations?: Maybe<Scalars['String']['output']>;
  dispositionClass: Scalars['String']['output'];
  effectiveScore?: Maybe<Scalars['Int']['output']>;
  isEnrollmentCall: Scalars['Boolean']['output'];
  overallAssessment?: Maybe<Scalars['String']['output']>;
  overriddenScore?: Maybe<Scalars['Int']['output']>;
  pointsLost?: Maybe<Scalars['Int']['output']>;
  qaScore?: Maybe<Scalars['Int']['output']>;
  questions: Array<QaQuestionOutput>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['Instant']['output']>;
  reviewedBy?: Maybe<Scalars['UUID']['output']>;
  rubricVersion?: Maybe<Scalars['String']['output']>;
  scoredAt?: Maybe<Scalars['Instant']['output']>;
  wasOverridden: Scalars['Boolean']['output'];
};

export enum CallType {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type CallbackDayOutput = {
  __typename?: 'CallbackDayOutput';
  rows: Array<CallbackRowOutput>;
  summary: CallbackDaySummaryOutput;
};

export type CallbackDaySummaryOutput = {
  __typename?: 'CallbackDaySummaryOutput';
  allocated: Scalars['Int']['output'];
  avgClaimSeconds?: Maybe<Scalars['Long']['output']>;
  callbacks: Scalars['Int']['output'];
  called: Scalars['Int']['output'];
  futureScheduled: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  successful: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type CallbackRowOutput = {
  __typename?: 'CallbackRowOutput';
  callbackStatus: CallbackStatus;
  channelIds: Array<Scalars['UUID']['output']>;
  clientAgentId?: Maybe<Scalars['UUID']['output']>;
  clientStatus?: Maybe<Scalars['String']['output']>;
  connected?: Maybe<Scalars['Boolean']['output']>;
  request: LeadTransferRequestOutput;
  tagIds: Array<Scalars['UUID']['output']>;
  windowEnd: Scalars['Instant']['output'];
  windowStart: Scalars['Instant']['output'];
};

export enum CallbackStatus {
  Done = 'DONE',
  InWindow = 'IN_WINDOW',
  Missed = 'MISSED',
  Upcoming = 'UPCOMING'
}

export type CallingDay = {
  __typename?: 'CallingDay';
  day: DayOfWeek;
  endMinute: Scalars['Int']['output'];
  startMinute: Scalars['Int']['output'];
};

export type CallingDayInput = {
  day: DayOfWeek;
  endMinute: Scalars['Int']['input'];
  startMinute: Scalars['Int']['input'];
};

export type CallingHours = {
  __typename?: 'CallingHours';
  defaultDays: Array<CallingDay>;
  rules: Array<CallingRule>;
};

export type CallingHoursInput = {
  defaultDays: Array<CallingDayInput>;
  rules: Array<CallingRuleInput>;
};

export type CallingRule = {
  __typename?: 'CallingRule';
  days: Array<CallingDay>;
  name: Scalars['String']['output'];
  states: Array<Scalars['String']['output']>;
};

export type CallingRuleInput = {
  days: Array<CallingDayInput>;
  name: Scalars['String']['input'];
  states: Array<Scalars['String']['input']>;
};

export type CallsRingState = {
  __typename?: 'CallsRingState';
  closed: Scalars['Boolean']['output'];
  done: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ChannelInput = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  planTypes: Array<LeadTransferPlanType>;
  slackChannelId: Scalars['String']['input'];
  states: Array<Scalars['String']['input']>;
  tagAnyIds: Array<Scalars['UUID']['input']>;
  tagNoneIds: Array<Scalars['UUID']['input']>;
  transferTypes: Array<TransferType>;
};

export enum ChannelOutcomeCode {
  ChannelInactive = 'CHANNEL_INACTIVE',
  DuplicateSlackChannelId = 'DUPLICATE_SLACK_CHANNEL_ID',
  HasHistory = 'HAS_HISTORY',
  NotFound = 'NOT_FOUND',
  RequiresFallbackConfirmation = 'REQUIRES_FALLBACK_CONFIRMATION',
  SlackChannelArchived = 'SLACK_CHANNEL_ARCHIVED',
  SlackChannelIdFrozen = 'SLACK_CHANNEL_ID_FROZEN',
  SlackChannelNotFound = 'SLACK_CHANNEL_NOT_FOUND',
  Success = 'SUCCESS'
}

export type ChannelOutput = {
  __typename?: 'ChannelOutput';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Instant']['output'];
  id: Scalars['UUID']['output'];
  isFallback: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  planTypes: Array<LeadTransferPlanType>;
  slackChannelHealth: SlackChannelHealth;
  slackChannelId: Scalars['String']['output'];
  slackDeepLink: Scalars['String']['output'];
  states: Array<Scalars['String']['output']>;
  tagAnyIds: Array<Scalars['UUID']['output']>;
  tagNoneIds: Array<Scalars['UUID']['output']>;
  transferTypes: Array<TransferType>;
  updatedAt: Scalars['Instant']['output'];
};

export type ChannelResultOutput = {
  __typename?: 'ChannelResultOutput';
  channel?: Maybe<ChannelOutput>;
  code: ChannelOutcomeCode;
};

export type ClaimAttemptEventOutput = {
  __typename?: 'ClaimAttemptEventOutput';
  agentId: Scalars['UUID']['output'];
  called?: Maybe<Scalars['Boolean']['output']>;
  clientId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  occurredAt: Scalars['Instant']['output'];
};

export type ClaimAttemptEventPageOutput = {
  __typename?: 'ClaimAttemptEventPageOutput';
  data: Array<ClaimAttemptEventOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum ClaimAttemptOutcomeCode {
  AlreadyAttempted = 'ALREADY_ATTEMPTED',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type ClaimAttemptReportFilterInput = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  occurredFrom?: InputMaybe<Scalars['Instant']['input']>;
  occurredTo?: InputMaybe<Scalars['Instant']['input']>;
};

export type ClaimAttemptResultOutput = {
  __typename?: 'ClaimAttemptResultOutput';
  clientId?: Maybe<Scalars['UUID']['output']>;
  code: ClaimAttemptOutcomeCode;
  status?: Maybe<StatusDto>;
};

export type ClaimEventOutput = {
  __typename?: 'ClaimEventOutput';
  actorAgentId?: Maybe<Scalars['UUID']['output']>;
  eventType: EventType;
  generation: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['Instant']['output'];
};

export enum ClaimSource {
  Agent = 'AGENT',
  Calendly = 'CALENDLY',
  StatusProgressed = 'STATUS_PROGRESSED'
}

export type ClientAdminItemOutput = {
  __typename?: 'ClientAdminItemOutput';
  aiGenerated: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['UUID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientNoteId?: Maybe<Scalars['UUID']['output']>;
  completionMethod?: Maybe<Scalars['String']['output']>;
  done: Scalars['Boolean']['output'];
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastVerificationReasoning?: Maybe<Scalars['String']['output']>;
  managerApprovalRejectionReason?: Maybe<Scalars['String']['output']>;
  managerApprovalStatus?: Maybe<Scalars['String']['output']>;
  photoVerificationAttemptCount: Scalars['Int']['output'];
  photoVerificationAttemptsRemaining?: Maybe<Scalars['Int']['output']>;
  photoVerificationStatus?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  sla?: Maybe<Scalars['String']['output']>;
  sourceNote?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  verificationResolution?: Maybe<Scalars['String']['output']>;
};

export type ClientAdminPhotoVerificationResult = {
  __typename?: 'ClientAdminPhotoVerificationResult';
  actionItemId: Scalars['UUID']['output'];
  attemptCount: Scalars['Int']['output'];
  attemptsRemaining: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  verificationId: Scalars['UUID']['output'];
};

export type ClientAttributeChange = {
  __typename?: 'ClientAttributeChange';
  actorId?: Maybe<Scalars['UUID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Instant']['output'];
  fromStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  kind: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tagId?: Maybe<Scalars['UUID']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<Scalars['String']['output']>;
};

export type ClientDetailsSubscriptionInput = {
  clientId: Scalars['UUID']['input'];
};

export type ClientDocumentOutput = {
  __typename?: 'ClientDocumentOutput';
  clientId: Scalars['UUID']['output'];
  documentType: Scalars['String']['output'];
  driveSyncStatus: Scalars['String']['output'];
  driveViewLink?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  reviewedAt?: Maybe<Scalars['Instant']['output']>;
  reviewedByProfileId?: Maybe<Scalars['UUID']['output']>;
  uploadedAt: Scalars['Instant']['output'];
  uploadedByProfileId: Scalars['UUID']['output'];
  verificationConfidence?: Maybe<Scalars['Float']['output']>;
  verificationReasoning?: Maybe<Scalars['String']['output']>;
  verificationStatus: Scalars['String']['output'];
};

export type ClientDocumentPreviewOutput = {
  __typename?: 'ClientDocumentPreviewOutput';
  base64: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
};

export enum ClientDrugDeliveryType {
  Both = 'BOTH',
  Mail = 'MAIL',
  Pharmacy = 'PHARMACY'
}

export type ClientFileInput = {
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ClientFileOutput = {
  __typename?: 'ClientFileOutput';
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ClientGroupItemOutput = {
  __typename?: 'ClientGroupItemOutput';
  clientId: Scalars['UUID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ClientGroupOutput = {
  __typename?: 'ClientGroupOutput';
  clients: Array<ClientGroupItemOutput>;
  id: Scalars['UUID']['output'];
};

export type ClientNoteOutput = {
  __typename?: 'ClientNoteOutput';
  clientId: Scalars['UUID']['output'];
  createdAt: Scalars['Instant']['output'];
  createdByAgent?: Maybe<AgentViewOutput>;
  id: Scalars['UUID']['output'];
  isManagerNote: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export type ClientPlatformSyncOutput = {
  __typename?: 'ClientPlatformSyncOutput';
  agentId: Scalars['UUID']['output'];
  blockedReason?: Maybe<Scalars['String']['output']>;
  credentialsStatus?: Maybe<PlatformCredentialsStatus>;
  drugs?: Maybe<PlatformDrugsSyncOutput>;
  member?: Maybe<PlatformSyncScenarioOutput>;
  platform: SyncPlatform;
};

export type ClientQaReportOutput = {
  __typename?: 'ClientQaReportOutput';
  aggregate: AgentQaReportOutput;
  calls: Array<QaCallRowOutput>;
};

export type ClientSmsOutput = {
  __typename?: 'ClientSmsOutput';
  agent?: Maybe<AgentViewOutput>;
  aircallNumber?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  direction: SmsDirection;
  id: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Instant']['output']>;
  sentByAi: Scalars['Boolean']['output'];
};

export type ClientTagInput = {
  clientId: Scalars['UUID']['input'];
  tags: Array<TagAssignedToClientInput>;
};

export type ClientTrackingIdDtoInput = {
  trackingId: Scalars['String']['input'];
  type: TrackingIdTypeDto;
};

export type ClientViewCountersOutput = {
  __typename?: 'ClientViewCountersOutput';
  allClientsCount: Scalars['Long']['output'];
  myClientsCount: Scalars['Long']['output'];
  newLeadsCount: Scalars['Long']['output'];
};

export type ClientViewFilterInput = {
  adviserEmail?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  aiGeneratedTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated The Pipeline Overview's Submitted Apps now uses enrolledByAgentId + enrollmentDate */
  applicationSubmitted?: InputMaybe<DateRangeInput>;
  birthDate?: InputMaybe<DateRangeInput>;
  enrolledByAgentId?: InputMaybe<Scalars['UUID']['input']>;
  enrollmentDate?: InputMaybe<DateRangeInput>;
  excludedTags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  followUpDate?: InputMaybe<DateRangeInput>;
  includedTags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  justNerdWallet?: InputMaybe<Scalars['Boolean']['input']>;
  marketingCampaign?: InputMaybe<Scalars['String']['input']>;
  marketingSource?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DateRangeInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sqlIntentTiers?: InputMaybe<Array<SqlIntentTier>>;
  /** @deprecated Use states instead */
  state?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use statuses instead */
  status?: InputMaybe<StatusDto>;
  statuses?: InputMaybe<Array<StatusDto>>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  timeZone?: InputMaybe<ClientViewTimeZone>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type ClientViewForAdviserOutput = {
  __typename?: 'ClientViewForAdviserOutput';
  agentCalendlyUrl?: Maybe<Scalars['String']['output']>;
  appointmentAttended?: Maybe<Scalars['Boolean']['output']>;
  appointmentStartAt?: Maybe<Scalars['Instant']['output']>;
  assignedAgentEmail?: Maybe<Scalars['String']['output']>;
  assignedAgentName?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  callScheduled?: Maybe<Scalars['Boolean']['output']>;
  clientId: Scalars['UUID']['output'];
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollmentCarrier?: Maybe<Scalars['String']['output']>;
  enrollmentEffectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  enrollmentPlanName?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<Scalars['String']['output']>;
  enrollmentWritingAgentEmail?: Maybe<Scalars['String']['output']>;
  enrollments?: Maybe<Array<EnrollmentAdvisorViewOutput>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasAppointment: Scalars['Boolean']['output'];
  hasEnrollment: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  medigapQuoteId?: Maybe<Scalars['UUID']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  quoteCreated?: Maybe<Scalars['Boolean']['output']>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ClientViewListRepresentationOutput = {
  __typename?: 'ClientViewListRepresentationOutput';
  affiliationPartnershipSource?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  callsCount: Scalars['String']['output'];
  clientId?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expectedCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  followUpDate?: Maybe<Scalars['LocalDate']['output']>;
  lastCallDate?: Maybe<Scalars['Instant']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latestNote?: Maybe<Scalars['String']['output']>;
  latestNoteId?: Maybe<Scalars['UUID']['output']>;
  managerNote?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  profileSource?: Maybe<ProfileSource>;
  sqlIntentScore?: Maybe<Scalars['Float']['output']>;
  sqlIntentTier?: Maybe<SqlIntentTier>;
  state?: Maybe<Scalars['String']['output']>;
  status: StatusDto;
  tags: Array<AssignedTagViewOutput>;
  urgentCallType?: Maybe<UrgentCallTypeDto>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type ClientViewOutput = {
  __typename?: 'ClientViewOutput';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  adviserEmail?: Maybe<Scalars['String']['output']>;
  adviserName?: Maybe<Scalars['String']['output']>;
  adviserPhone?: Maybe<Scalars['String']['output']>;
  affiliationPartnershipSource?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<AgentViewOutput>;
  agentMedicareQuote?: Maybe<MedicareQuoteOutput>;
  agentMedigapQuote?: Maybe<MedigapQuoteViewOutput>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  bookingFor?: Maybe<Scalars['String']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  clientFiles: Array<ClientFileOutput>;
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customAnswers?: Maybe<Scalars['String']['output']>;
  disqualifiedReason?: Maybe<DisqualifiedReasonDto>;
  doctors: Array<DoctorViewOutput>;
  drugDeliveryType?: Maybe<DrugDeliveryTypeViewOutput>;
  drugs: Array<DrugViewOutput>;
  eligibleName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrolled?: Maybe<Scalars['String']['output']>;
  enrollment?: Maybe<EnrollmentViewOutput>;
  expectedCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  fbclid?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<FiltersOutput>;
  firstName?: Maybe<Scalars['String']['output']>;
  followUpDate?: Maybe<Scalars['LocalDate']['output']>;
  gbraid?: Maybe<Scalars['String']['output']>;
  gclid?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  healthInformationDisclosureCheck?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isDNC: Scalars['Boolean']['output'];
  isLitigator: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  leadSources?: Maybe<Array<LeadSourceOutput>>;
  managerNote?: Maybe<Scalars['String']['output']>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medicarePartAStartedAt?: Maybe<Scalars['String']['output']>;
  medicarePartBStartedAt?: Maybe<Scalars['String']['output']>;
  medigapEnrollment?: Maybe<MedigapEnrollmentViewOutput>;
  medigapQuote?: Maybe<MedigapQuoteViewOutput>;
  msclkid?: Maybe<Scalars['String']['output']>;
  noShow?: Maybe<Scalars['Boolean']['output']>;
  notes: Array<ClientNoteOutput>;
  oppref?: Maybe<Scalars['String']['output']>;
  originalClientId?: Maybe<Scalars['UUID']['output']>;
  ownHealthcareDecisionCheck?: Maybe<Scalars['Boolean']['output']>;
  pdpEnrollment?: Maybe<PdpEnrollmentViewOutput>;
  pdpQuote?: Maybe<PdpQuoteOutput>;
  personalInfoPlatformSyncs: Array<PersonalInfoPlatformSyncOutput>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  planTypes?: Maybe<Array<Scalars['String']['output']>>;
  preCallBriefing?: Maybe<PreCallBriefingOutput>;
  preCallBriefingProgress?: Maybe<ProgressOutput>;
  preferredContactEmail?: Maybe<Scalars['Boolean']['output']>;
  preferredContactPhone?: Maybe<Scalars['Boolean']['output']>;
  preferredContactText?: Maybe<Scalars['Boolean']['output']>;
  preferredDrugs: Array<PreferredDrugViewOutput>;
  preferredPharmacies: Array<Scalars['String']['output']>;
  productsClientAgreedToDiscuss?: Maybe<ProductsClientAgreedToDiscussOutput>;
  profileId?: Maybe<Scalars['UUID']['output']>;
  profileSource?: Maybe<ProfileSource>;
  purchasedProducts: Array<PurchasedProductOutput>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  recordedLineAgreementCheck?: Maybe<Scalars['Boolean']['output']>;
  retireIn3Months?: Maybe<Scalars['String']['output']>;
  scheduledAiCalls: Array<ScheduledAiCallOutput>;
  scheduledSms: Array<ScheduledSmsOutput>;
  scheduledTagPlacement?: Maybe<Scalars['Boolean']['output']>;
  scopeOfAppointmentStatus?: Maybe<ScopeOfAppointmentStatusDto>;
  soaAgreement?: Maybe<Scalars['Boolean']['output']>;
  soaAgreementCheck?: Maybe<Scalars['Boolean']['output']>;
  sqlIntent?: Maybe<SqlIntentOutput>;
  state?: Maybe<Scalars['String']['output']>;
  status: StatusDto;
  tags: Array<AssignedTagViewOutput>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  tpmoAgreementCheck?: Maybe<Scalars['Boolean']['output']>;
  uId?: Maybe<Scalars['String']['output']>;
  urgentCallRequested?: Maybe<Scalars['Boolean']['output']>;
  urgentCallType?: Maybe<UrgentCallTypeDto>;
  userId?: Maybe<Scalars['UUID']['output']>;
  utmBrand?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
  watchers: Array<AgentViewOutput>;
  wbraid?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ClientViewSortInput = {
  direction: SortDirection;
  field: Field;
};

export enum ClientViewTimeZone {
  Akst = 'AKST',
  Cst = 'CST',
  Est = 'EST',
  Hst = 'HST',
  Mst = 'MST',
  Pst = 'PST'
}

export type ClientWatcherInput = {
  agentIds: Array<Scalars['UUID']['input']>;
  clientId: Scalars['UUID']['input'];
};

export type CompareOfferHistoryInput = {
  clientId: Scalars['UUID']['input'];
  screenshotLink: Scalars['String']['input'];
};

export type CompareOfferHistoryOutput = {
  __typename?: 'CompareOfferHistoryOutput';
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['UUID']['output'];
  screenshotLink: Scalars['String']['output'];
};

export type ComplianceGapOutput = {
  __typename?: 'ComplianceGapOutput';
  clientId: Scalars['UUID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  consultedAt: Scalars['Instant']['output'];
  soaMissing: Scalars['Boolean']['output'];
  tpmoMissing: Scalars['Boolean']['output'];
};

export type CopilotClientContextInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CopilotConversationDetailOutput = {
  __typename?: 'CopilotConversationDetailOutput';
  conversationId?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  messages: Array<CopilotMessageOutput>;
};

export type CopilotConversationOutput = {
  __typename?: 'CopilotConversationOutput';
  conversationId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CopilotConversationPageOutput = {
  __typename?: 'CopilotConversationPageOutput';
  conversations: Array<CopilotConversationOutput>;
  hasMore: Scalars['Boolean']['output'];
};

export type CopilotMessageOutput = {
  __typename?: 'CopilotMessageOutput';
  blocksJson?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['String']['output'];
  role: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type CopilotPlanPickInput = {
  bidId?: InputMaybe<Scalars['String']['input']>;
  planLetter?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
};

export type CopilotSearchHitOutput = {
  __typename?: 'CopilotSearchHitOutput';
  conversation: CopilotConversationOutput;
  snippet: Scalars['String']['output'];
};

export type CopilotSearchPageOutput = {
  __typename?: 'CopilotSearchPageOutput';
  hasMore: Scalars['Boolean']['output'];
  hits: Array<CopilotSearchHitOutput>;
};

export type CopyScheduleWeekOutput = {
  __typename?: 'CopyScheduleWeekOutput';
  approvedDaysKept: Scalars['Int']['output'];
  daysSkipped: Scalars['Int']['output'];
  daysWritten: Scalars['Int']['output'];
};

export type CorrectTimesReviewItemOutput = {
  __typename?: 'CorrectTimesReviewItemOutput';
  actualShiftEndAt?: Maybe<Scalars['Instant']['output']>;
  actualShiftStartAt?: Maybe<Scalars['Instant']['output']>;
  agentFirstName: Scalars['String']['output'];
  agentId: Scalars['UUID']['output'];
  agentLastName: Scalars['String']['output'];
  dayPunchCount: Scalars['Int']['output'];
  flag: Scalars['String']['output'];
  proposedEndAt?: Maybe<Scalars['Instant']['output']>;
  proposedStartAt?: Maybe<Scalars['Instant']['output']>;
  reason: Scalars['String']['output'];
  requestId: Scalars['UUID']['output'];
  workDate: Scalars['LocalDate']['output'];
};

export enum CoverRightProductDto {
  Ma = 'MA',
  Mg = 'MG',
  Pdp = 'PDP'
}

export type CreateCalendarEventInput = {
  addMeetLink?: InputMaybe<Scalars['Boolean']['input']>;
  attendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  colorId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['Instant']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderMinutes?: InputMaybe<Scalars['Int']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['Instant']['input'];
  summary: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CsrTrackingReportOutput = {
  __typename?: 'CsrTrackingReportOutput';
  agentId: Scalars['UUID']['output'];
  bookedCallsCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  futureAppointmentsCount: Scalars['Int']['output'];
  nonWarmTransfersAttendedCount: Scalars['Int']['output'];
  nonWarmTransfersCount: Scalars['Int']['output'];
  nonWarmTransfersNotAttendedCount: Scalars['Int']['output'];
  undispositionedAppointmentsCount: Scalars['Int']['output'];
  warmTransfersCount: Scalars['Int']['output'];
};

export type CurrentAgentCallAgendaStateOutput = {
  __typename?: 'CurrentAgentCallAgendaStateOutput';
  agentsSorted: Array<AgentAvailabilityStateOutput>;
  rrView: RrViewOutput;
  tasks: Array<AgentCallAgendaTaskOutput>;
};

export type CutoverAgentResult = {
  __typename?: 'CutoverAgentResult';
  message?: Maybe<Scalars['String']['output']>;
  started: Scalars['Boolean']['output'];
};

export type DailyHoursOutput = {
  __typename?: 'DailyHoursOutput';
  breakHours: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  lunchHours: Scalars['BigDecimal']['output'];
  needsReview: Scalars['Boolean']['output'];
  paidHours: Scalars['BigDecimal']['output'];
  scheduledHours?: Maybe<Scalars['BigDecimal']['output']>;
};

export type DailyRingsState = {
  __typename?: 'DailyRingsState';
  adminRing: AdminRingState;
  agentId: Scalars['UUID']['output'];
  allRingsClosed: Scalars['Boolean']['output'];
  callsRing: CallsRingState;
  date: Scalars['LocalDate']['output'];
  integritySignals: IntegritySignals;
  notWorkingMessage?: Maybe<Scalars['String']['output']>;
  reconnectsRing: ReconnectsRingState;
  streak: Scalars['Int']['output'];
  workingToday: Scalars['Boolean']['output'];
};

export type DashboardSectionOutput = {
  __typename?: 'DashboardSectionOutput';
  agentId: Scalars['UUID']['output'];
  clientAdmin?: Maybe<Array<ClientAdminItemOutput>>;
  clientAdminTotal?: Maybe<Scalars['Int']['output']>;
  documentReview?: Maybe<Array<RejectedDocumentItemOutput>>;
  documentReviewTotal?: Maybe<Scalars['Int']['output']>;
  managerNotes?: Maybe<Array<ManagerNoteItemOutput>>;
  managerNotesTotal?: Maybe<Scalars['Int']['output']>;
  overdue?: Maybe<Array<OverdueItemOutput>>;
  overdueTotal?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<PlanSectionOutput>;
  progress?: Maybe<ProgressOutput>;
  reconnect?: Maybe<Array<ReconnectItemOutput>>;
  reconnectTotal?: Maybe<Scalars['Int']['output']>;
  rings?: Maybe<DailyRingsState>;
  type: DashboardSectionType;
  wrapUp?: Maybe<WrapUpSectionOutput>;
};

export enum DashboardSectionType {
  ClientAdmin = 'CLIENT_ADMIN',
  DocumentReview = 'DOCUMENT_REVIEW',
  ManagerNotes = 'MANAGER_NOTES',
  Overdue = 'OVERDUE',
  Plan = 'PLAN',
  Progress = 'PROGRESS',
  Reconnect = 'RECONNECT',
  Rings = 'RINGS',
  Schedule = 'SCHEDULE',
  WrapUp = 'WRAP_UP'
}

export type DateRangeInput = {
  from: Scalars['Instant']['input'];
  to: Scalars['Instant']['input'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeclinableDrugAnswerViewOutput = {
  __typename?: 'DeclinableDrugAnswerViewOutput';
  answeredAt?: Maybe<Scalars['Instant']['output']>;
  answeredByEmail?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Scalars['String']['output']>;
  carrierDisplayName?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  drugId: Scalars['UUID']['output'];
  drugName: Scalars['String']['output'];
  filterName?: Maybe<Scalars['String']['output']>;
  genericName?: Maybe<Scalars['String']['output']>;
  naic: Scalars['String']['output'];
};

export type DeferResult = {
  __typename?: 'DeferResult';
  accepted: Scalars['Boolean']['output'];
  guard?: Maybe<GuardResult>;
  ring: ReconnectsRingState;
};

export enum DeliveryStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type DepartmentOutput = {
  __typename?: 'DepartmentOutput';
  active: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  leadScope: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payrollExport: Scalars['Boolean']['output'];
  unpaidAfterHours: Scalars['BigDecimal']['output'];
};

export type DepartmentTimelineSummaryOutput = {
  __typename?: 'DepartmentTimelineSummaryOutput';
  absent: Scalars['Int']['output'];
  departmentId: Scalars['UUID']['output'];
  departmentName: Scalars['String']['output'];
  off: Scalars['Int']['output'];
  onShift: Scalars['Int']['output'];
  unclosed: Scalars['Int']['output'];
};

export enum DisqualifiedReasonDto {
  BadContact = 'BAD_CONTACT',
  CoveredElsewhere = 'COVERED_ELSEWHERE',
  DncOptOut = 'DNC_OPT_OUT',
  NotEligible = 'NOT_ELIGIBLE',
  NotInterested = 'NOT_INTERESTED',
  NotProvided = 'NOT_PROVIDED',
  NoLongerInterestedInSwitching = 'NO_LONGER_INTERESTED_IN_SWITCHING',
  Other = 'OTHER',
  UnableToConnect = 'UNABLE_TO_CONNECT',
  Unreachable = 'UNREACHABLE',
  WentToAnotherBroker = 'WENT_TO_ANOTHER_BROKER'
}

export type DoctorAddressViewOutput = {
  __typename?: 'DoctorAddressViewOutput';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPcp: Scalars['Boolean']['output'];
  specialty: Scalars['String']['output'];
};

export type DoctorPlatformSyncOutput = {
  __typename?: 'DoctorPlatformSyncOutput';
  message: Scalars['String']['output'];
  nextSyncAt?: Maybe<Scalars['Instant']['output']>;
  options: Array<Scalars['String']['output']>;
  platform: SyncPlatform;
  platformAddresses: Array<Scalars['String']['output']>;
  platformName?: Maybe<Scalars['String']['output']>;
  status: DrugPlatformSyncStatus;
  suggestion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type DoctorViewOutput = {
  __typename?: 'DoctorViewOutput';
  addresses: Array<DoctorAddressViewOutput>;
  addressesNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  npi: Scalars['String']['output'];
  pcpDetails: Array<PcpInfoViewOutput>;
  platformSyncs: Array<DoctorPlatformSyncOutput>;
};

export enum DrugDeliveryTypeViewOutput {
  Both = 'BOTH',
  Mail = 'MAIL',
  Pharmacy = 'PHARMACY'
}

export type DrugPlatformSyncOutput = {
  __typename?: 'DrugPlatformSyncOutput';
  canChoose: Scalars['Boolean']['output'];
  choiceOptions: Array<PlatformDrugOptionOutput>;
  message: Scalars['String']['output'];
  nextSyncAt?: Maybe<Scalars['Instant']['output']>;
  options: Array<Scalars['String']['output']>;
  platform: SyncPlatform;
  platformDrug?: Maybe<Scalars['String']['output']>;
  platformPackage?: Maybe<Scalars['String']['output']>;
  platformQuantity?: Maybe<Scalars['String']['output']>;
  status: DrugPlatformSyncStatus;
  suggestion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
  viaChoice: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export enum DrugPlatformSyncStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Synced = 'SYNCED'
}

export type DrugViewOutput = {
  __typename?: 'DrugViewOutput';
  frequency?: Maybe<Scalars['String']['output']>;
  genericName?: Maybe<Scalars['String']['output']>;
  genericRxcui?: Maybe<Scalars['String']['output']>;
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packName?: Maybe<Scalars['String']['output']>;
  packRxcui?: Maybe<Scalars['String']['output']>;
  platformSyncs: Array<DrugPlatformSyncOutput>;
  quantity?: Maybe<Scalars['BigDecimal']['output']>;
  rxcui?: Maybe<Scalars['String']['output']>;
};

export type EditLeadTransferRequestInput = {
  agreedOnConfirmed: Scalars['Boolean']['input'];
  callType: CallType;
  callbackDate?: InputMaybe<Scalars['LocalDate']['input']>;
  callbackTimeFrom?: InputMaybe<Scalars['String']['input']>;
  callbackTimeTo?: InputMaybe<Scalars['String']['input']>;
  concern: Scalars['String']['input'];
  currentPlanTypes: Array<LeadTransferPlanType>;
  requestId: Scalars['UUID']['input'];
  soaCompleted: Scalars['Boolean']['input'];
  transferType: TransferType;
};

export enum EmailMeMaPagePlanYear {
  Year2021 = 'YEAR2021',
  Year2022 = 'YEAR2022',
  Year2023 = 'YEAR2023'
}

export type EmailTemplateDto = {
  __typename?: 'EmailTemplateDto';
  id?: Maybe<Scalars['UUID']['output']>;
  template: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EmailTemplateDtoInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  template: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EnrollmentAddressOutput = {
  __typename?: 'EnrollmentAddressOutput';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type EnrollmentAdvisorViewOutput = {
  __typename?: 'EnrollmentAdvisorViewOutput';
  agentEmail?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  enrollmentType?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentFilterInput = {
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<EnrollmentStatusInput>>;
};

export type EnrollmentInput = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  applicationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  bidId?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  communicationPreference?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentType?: InputMaybe<MedicareEnrollmentType>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isElectronicallyCommunications?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<AddressDtoInput>;
  medicareNumber?: InputMaybe<Scalars['String']['input']>;
  medicarePartAStartedAt?: InputMaybe<Scalars['String']['input']>;
  medicarePartBStartedAt?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<AddressDtoInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  planYear?: InputMaybe<PlanYear>;
  preferredLanguage?: InputMaybe<PreferredLanguageDto>;
  quoteId?: InputMaybe<Scalars['UUID']['input']>;
  started?: InputMaybe<Scalars['Instant']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentListItemOutput = {
  __typename?: 'EnrollmentListItemOutput';
  age?: Maybe<Scalars['Int']['output']>;
  agentId?: Maybe<Scalars['UUID']['output']>;
  applicationDate?: Maybe<Scalars['LocalDate']['output']>;
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  bidId?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mgPlanKey?: Maybe<Scalars['String']['output']>;
  mgPlanName?: Maybe<Scalars['String']['output']>;
  naic?: Maybe<Scalars['String']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planYear?: Maybe<Scalars['String']['output']>;
  started?: Maybe<Scalars['Instant']['output']>;
  status: Scalars['String']['output'];
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  type: EnrollmentType;
  zip?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentOutput = {
  __typename?: 'EnrollmentOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  applicationDate?: Maybe<Scalars['LocalDate']['output']>;
  approvedAt?: Maybe<Scalars['String']['output']>;
  bidId?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  communicationPreference?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByAdmin: Scalars['Boolean']['output'];
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<MedicareEnrollmentType>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isElectronicallyCommunications?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<AddressDto>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medicarePartAStartedAt?: Maybe<Scalars['String']['output']>;
  medicarePartBStartedAt?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<AddressDto>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planYear?: Maybe<PlanYear>;
  preferredLanguage?: Maybe<PreferredLanguageDto>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  started?: Maybe<Scalars['Instant']['output']>;
  status: StatusOutput;
  userId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentPlanNameMigrationResult = {
  __typename?: 'EnrollmentPlanNameMigrationResult';
  maErrorCount: Scalars['Int']['output'];
  maSuccessfulCount: Scalars['Int']['output'];
  maTotalCount: Scalars['Int']['output'];
  medigapErrorCount: Scalars['Int']['output'];
  medigapSuccessfulCount: Scalars['Int']['output'];
  medigapTotalCount: Scalars['Int']['output'];
  pdpErrorCount: Scalars['Int']['output'];
  pdpSuccessfulCount: Scalars['Int']['output'];
  pdpTotalCount: Scalars['Int']['output'];
};

export enum EnrollmentPreferredLanguageDto {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  Spanish = 'SPANISH',
  Vietnamese = 'VIETNAMESE'
}

export enum EnrollmentStatusDto {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum EnrollmentStatusInput {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum EnrollmentType {
  Ma = 'MA',
  Mg = 'MG',
  Pdp = 'PDP'
}

export type EnrollmentViewOutput = {
  __typename?: 'EnrollmentViewOutput';
  approvedAt?: Maybe<Scalars['String']['output']>;
  bidId?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  communicationPreference?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isElectronicallyCommunications?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<EnrollmentAddressOutput>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medicarePartAStartedAt?: Maybe<Scalars['String']['output']>;
  medicarePartBStartedAt?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<EnrollmentAddressOutput>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<EnrollmentPreferredLanguageDto>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  status: EnrollmentStatusDto;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export enum EventName {
  FollowUp = 'FOLLOW_UP',
  Lead = 'LEAD',
  Sql = 'SQL'
}

export enum EventType {
  CallbackMissedFlagged = 'CALLBACK_MISSED_FLAGGED',
  CallCompleted = 'CALL_COMPLETED',
  Cancelled = 'CANCELLED',
  Claimed = 'CLAIMED',
  ClaimedWindowReminder = 'CLAIMED_WINDOW_REMINDER',
  Created = 'CREATED',
  Edited = 'EDITED',
  Escalated = 'ESCALATED',
  ManuallyResent = 'MANUALLY_RESENT',
  NoChannelMatch = 'NO_CHANNEL_MATCH',
  OverdueFlagged = 'OVERDUE_FLAGGED',
  Rerouted = 'REROUTED',
  Unclaimed = 'UNCLAIMED'
}

export enum ExtraBenefit {
  Dental = 'DENTAL',
  DrugCoverage = 'DRUG_COVERAGE',
  Fitness = 'FITNESS',
  Hearing = 'HEARING',
  InsulinSavings = 'INSULIN_SAVINGS',
  OverTheCounter = 'OVER_THE_COUNTER',
  PartBPremiumGiveback = 'PART_B_PREMIUM_GIVEBACK',
  Telehealth = 'TELEHEALTH',
  Transportation = 'TRANSPORTATION',
  Vision = 'VISION',
  WorldwideEmergency = 'WORLDWIDE_EMERGENCY'
}

export enum Field {
  BirthDate = 'birthDate',
  CreatedAt = 'createdAt',
  Email = 'email',
  ExpectedCloseDate = 'expectedCloseDate',
  FirstName = 'firstName',
  FollowUpDate = 'followUpDate',
  Gender = 'gender',
  LastCallDate = 'lastCallDate',
  LastName = 'lastName',
  Note = 'note',
  PhoneNumber = 'phoneNumber',
  ScopeOfAppointmentStatus = 'scopeOfAppointmentStatus',
  SqlIntentScore = 'sqlIntentScore',
  Status = 'status',
  Zip = 'zip'
}

export type FiltersOutput = {
  __typename?: 'FiltersOutput';
  SNPTypes?: Maybe<Array<SnpType>>;
  companies?: Maybe<Array<Scalars['String']['output']>>;
  extraBenefits: Array<ExtraBenefit>;
  maxCostRangeNames?: Maybe<Array<Scalars['String']['output']>>;
  maxOutOfPocketRangeNames?: Maybe<Array<Scalars['String']['output']>>;
  partBPremiumReduction?: Maybe<Scalars['Boolean']['output']>;
  partDDrugCoverage?: Maybe<Scalars['Boolean']['output']>;
  planTypes?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Array<Rating>>;
};

export type FollowUpSweepApplyOutput = {
  __typename?: 'FollowUpSweepApplyOutput';
  dryRun: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  resultUri: Scalars['String']['output'];
};

export type FollowUpSweepCountOutput = {
  __typename?: 'FollowUpSweepCountOutput';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type FollowUpSweepFileOutput = {
  __typename?: 'FollowUpSweepFileOutput';
  fileName: Scalars['String']['output'];
  gcsUri: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  resultCounts: Array<FollowUpSweepCountOutput>;
  state: FollowUpSweepFileState;
  xlsxBase64?: Maybe<Scalars['String']['output']>;
};

export enum FollowUpSweepFileState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY'
}

export type FollowUpSweepProblemOutput = {
  __typename?: 'FollowUpSweepProblemOutput';
  clientId?: Maybe<Scalars['String']['output']>;
  column?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row?: Maybe<Scalars['Int']['output']>;
  sheet?: Maybe<Scalars['String']['output']>;
};

export type FollowUpSweepStartOutput = {
  __typename?: 'FollowUpSweepStartOutput';
  message: Scalars['String']['output'];
  workbookUri: Scalars['String']['output'];
};

export type FollowUpSweepUploadOutput = {
  __typename?: 'FollowUpSweepUploadOutput';
  applyCounts: Array<FollowUpSweepCountOutput>;
  approvedUri?: Maybe<Scalars['String']['output']>;
  editedRows: Scalars['Int']['output'];
  leads: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  problems: Array<FollowUpSweepProblemOutput>;
  structureChanged: Scalars['Boolean']['output'];
  valid: Scalars['Boolean']['output'];
};

export enum FormName {
  BasicInfo = 'BASIC_INFO',
  Calendar = 'CALENDAR',
  ChronicIllness = 'CHRONIC_ILLNESS',
  Doctors = 'DOCTORS',
  Drugs = 'DRUGS',
  Enrolled = 'ENROLLED',
  GovernmentAssistant = 'GOVERNMENT_ASSISTANT',
  HomeAddress = 'HOME_ADDRESS',
  Medicaid = 'MEDICAID',
  MedicareOverview = 'MEDICARE_OVERVIEW',
  PersonalDetails = 'PERSONAL_DETAILS',
  Pharmacies = 'PHARMACIES',
  PhoneNumber = 'PHONE_NUMBER',
  ReceivingBenefits = 'RECEIVING_BENEFITS',
  SearchResults = 'SEARCH_RESULTS',
  WorkInfo = 'WORK_INFO'
}

export type FreeBlock = {
  __typename?: 'FreeBlock';
  durationMinutes: Scalars['Long']['output'];
  end: Scalars['Instant']['output'];
  start: Scalars['Instant']['output'];
};

export type FreeBusyOutput = {
  __typename?: 'FreeBusyOutput';
  agentEmail: Scalars['String']['output'];
  busyPeriods: Array<BusyPeriod>;
};

export enum FrequencyPeriodInput {
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum FrequencyPeriodViewOutput {
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum Gender {
  F = 'F',
  M = 'M'
}

export enum GuardCapType {
  PerClient = 'PER_CLIENT',
  PerDay = 'PER_DAY'
}

export enum GuardCode {
  G1NoCallOnRecord = 'G1_NO_CALL_ON_RECORD',
  G2QueueNoCredit = 'G2_QUEUE_NO_CREDIT',
  G3UnlinkedForwardDate = 'G3_UNLINKED_FORWARD_DATE',
  G4AlreadyCreditedToday = 'G4_ALREADY_CREDITED_TODAY',
  G5NotYetDue = 'G5_NOT_YET_DUE',
  G6BulkPartialCredit = 'G6_BULK_PARTIAL_CREDIT',
  G7DirectEditBlocked = 'G7_DIRECT_EDIT_BLOCKED',
  G9CallTooShort = 'G9_CALL_TOO_SHORT',
  G10StillOverdue = 'G10_STILL_OVERDUE',
  G11DeferCapReached = 'G11_DEFER_CAP_REACHED',
  G12OverdueStatusEscape = 'G12_OVERDUE_STATUS_ESCAPE',
  G13ClientUnavailable = 'G13_CLIENT_UNAVAILABLE',
  G14SecondChannelNeeded = 'G14_SECOND_CHANNEL_NEEDED',
  G15ContactRequired = 'G15_CONTACT_REQUIRED',
  G16SyncPending = 'G16_SYNC_PENDING',
  G17WrapUpNothingChanged = 'G17_WRAP_UP_NOTHING_CHANGED',
  G18WrapUpDateStillDue = 'G18_WRAP_UP_DATE_STILL_DUE'
}

export type GuardResult = {
  __typename?: 'GuardResult';
  capType?: Maybe<GuardCapType>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  code: GuardCode;
  message: Scalars['String']['output'];
};

export type IntegritySignals = {
  __typename?: 'IntegritySignals';
  bulkPartialCreditCount: Scalars['Int']['output'];
  deferCapHitCount: Scalars['Int']['output'];
  overdueStatusEscapeCount: Scalars['Int']['output'];
  reconnectBacklogOverflowCount: Scalars['Int']['output'];
  shortCallCount: Scalars['Int']['output'];
  unlinkedForwardDateCount: Scalars['Int']['output'];
};

export type InviteePersonalInfoOutput = {
  __typename?: 'InviteePersonalInfoOutput';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type KeycloakUserInput = {
  email: Scalars['String']['input'];
  enrollmentId?: InputMaybe<Scalars['UUID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['UUID']['input']>;
  quoteId?: InputMaybe<Scalars['UUID']['input']>;
};

export type KeycloakUserOutput = {
  __typename?: 'KeycloakUserOutput';
  enrollmentId: Scalars['UUID']['output'];
  userId: Scalars['UUID']['output'];
};

export type LeadActionOutput = {
  __typename?: 'LeadActionOutput';
  confirmation?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<LeadHistoryEntryOutput>;
  guard?: Maybe<GuardResult>;
  success: Scalars['Boolean']['output'];
};

export type LeadContactRequestOutput = {
  __typename?: 'LeadContactRequestOutput';
  callRequired: Scalars['Boolean']['output'];
  hint?: Maybe<Scalars['String']['output']>;
  overdue: Scalars['Boolean']['output'];
  requestedAt: Scalars['Instant']['output'];
  requestedByName?: Maybe<Scalars['String']['output']>;
  satisfiedAt?: Maybe<Scalars['Instant']['output']>;
  satisfiedBy?: Maybe<Scalars['String']['output']>;
};

export type LeadCountOutput = {
  __typename?: 'LeadCountOutput';
  current: Scalars['Int']['output'];
  expired: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum LeadDisposition {
  Contacted = 'CONTACTED',
  Disqualified = 'DISQUALIFIED',
  MissedApptCsr = 'MISSED_APPT_CSR',
  Sql = 'SQL',
  SubmittedApp = 'SUBMITTED_APP'
}

export type LeadEarningsOutput = {
  __typename?: 'LeadEarningsOutput';
  forecastCloses: Scalars['Float']['output'];
  forecastDollars: Scalars['Int']['output'];
  highRate: Scalars['Float']['output'];
  ifAllClose: Scalars['Int']['output'];
  openSqls: Scalars['Int']['output'];
  otherRate: Scalars['Float']['output'];
  payoutPerClose: Scalars['Int']['output'];
  warmRate: Scalars['Float']['output'];
  weeks: Array<LeadEarningsWeekOutput>;
};

export type LeadEarningsWeekOutput = {
  __typename?: 'LeadEarningsWeekOutput';
  forecastCloses: Scalars['Float']['output'];
  forecastDollars: Scalars['Int']['output'];
  high: Scalars['Int']['output'];
  ifAllCloseDollars: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
  sqls: Scalars['Int']['output'];
  warm: Scalars['Int']['output'];
  weekStart: Scalars['LocalDate']['output'];
};

export type LeadHistoryEntryOutput = {
  __typename?: 'LeadHistoryEntryOutput';
  actionStatus?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  actorRole: Scalars['String']['output'];
  at: Scalars['Instant']['output'];
  doneAt?: Maybe<Scalars['Instant']['output']>;
  doneBy?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  verification?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type LeadHistoryOutput = {
  __typename?: 'LeadHistoryOutput';
  clientId: Scalars['UUID']['output'];
  clientName: Scalars['String']['output'];
  entries: Array<LeadHistoryEntryOutput>;
};

export type LeadManagementEventOutput = {
  __typename?: 'LeadManagementEventOutput';
  actorName?: Maybe<Scalars['String']['output']>;
  agentId: Scalars['UUID']['output'];
  at: Scalars['Instant']['output'];
  clientId: Scalars['UUID']['output'];
  clientName: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type LeadManagementOutput = {
  __typename?: 'LeadManagementOutput';
  agentId: Scalars['UUID']['output'];
  asOfDate: Scalars['LocalDate']['output'];
  earnings: LeadEarningsOutput;
  followUps: Array<LeadRowOutput>;
  sqls: Array<LeadRowOutput>;
  tiles: LeadTilesOutput;
};

export type LeadManagerSummaryOutput = {
  __typename?: 'LeadManagerSummaryOutput';
  clientId: Scalars['UUID']['output'];
  contactRequest?: Maybe<LeadContactRequestOutput>;
  entries: Array<LeadHistoryEntryOutput>;
  priority?: Maybe<LeadPriorityOutput>;
};

export enum LeadPartnerKey {
  AlpineDigitalGroup = 'ALPINE_DIGITAL_GROUP',
  Astoria = 'ASTORIA',
  Healthcare = 'HEALTHCARE',
  LeadEconomy = 'LEAD_ECONOMY',
  Nerdwallet = 'NERDWALLET',
  Quinstreet = 'QUINSTREET',
  RevriseMedia = 'REVRISE_MEDIA',
  SmartFinancial = 'SMART_FINANCIAL',
  Spotower = 'SPOTOWER'
}

export type LeadPriorityOutput = {
  __typename?: 'LeadPriorityOutput';
  setAt: Scalars['Instant']['output'];
  setByName?: Maybe<Scalars['String']['output']>;
};

export enum LeadReportStatusFilter {
  Cancelled = 'CANCELLED',
  Claimed = 'CLAIMED',
  Overdue = 'OVERDUE',
  Pending = 'PENDING'
}

export type LeadRowOutput = {
  __typename?: 'LeadRowOutput';
  actionStatus: Scalars['String']['output'];
  affiliatesPool: Scalars['Boolean']['output'];
  callsConnected7d: Scalars['Int']['output'];
  callsDialed7d: Scalars['Int']['output'];
  clientId: Scalars['UUID']['output'];
  contactRequest?: Maybe<LeadContactRequestOutput>;
  contactedAt?: Maybe<Scalars['Instant']['output']>;
  contactedBy?: Maybe<Scalars['String']['output']>;
  doneAt?: Maybe<Scalars['Instant']['output']>;
  doneBy?: Maybe<Scalars['String']['output']>;
  doneToday: Scalars['Boolean']['output'];
  expectedCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  historyCount: Scalars['Int']['output'];
  intentTier?: Maybe<Scalars['String']['output']>;
  lastAgentUpdate?: Maybe<LeadHistoryEntryOutput>;
  lastCallAt?: Maybe<Scalars['Instant']['output']>;
  leadDate?: Maybe<Scalars['Instant']['output']>;
  leftAt?: Maybe<Scalars['Instant']['output']>;
  leftGroup?: Maybe<Scalars['String']['output']>;
  missedApptTagged: Scalars['Boolean']['output'];
  movedTo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextContact?: Maybe<Scalars['LocalDate']['output']>;
  nextContactExpired: Scalars['Boolean']['output'];
  partnerTag?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<LeadPriorityOutput>;
  recentHistory: Array<LeadHistoryEntryOutput>;
  source?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type LeadSourceOutput = {
  __typename?: 'LeadSourceOutput';
  campaign: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  eventDate: Scalars['LocalDate']['output'];
  medium: Scalars['String']['output'];
  source: Scalars['String']['output'];
  term?: Maybe<Scalars['String']['output']>;
};

export type LeadTilesOutput = {
  __typename?: 'LeadTilesOutput';
  followUps: LeadCountOutput;
  overdueCallbacks: Scalars['Int']['output'];
  pendingCallbacks: Scalars['Int']['output'];
  priorityMarked: Scalars['Int']['output'];
  priorityPoolLeads: Scalars['Int']['output'];
  sqls: LeadCountOutput;
  submittedAppsMtd: Scalars['Int']['output'];
};

export type LeadTransferAgentNotificationOutput = {
  __typename?: 'LeadTransferAgentNotificationOutput';
  agentId: Scalars['UUID']['output'];
  callbackTimeFrom?: Maybe<Scalars['String']['output']>;
  callbackTimeTo?: Maybe<Scalars['String']['output']>;
  clientAggregateId?: Maybe<Scalars['UUID']['output']>;
  clientName: Scalars['String']['output'];
  requestId: Scalars['UUID']['output'];
};

export type LeadTransferCancelResultOutput = {
  __typename?: 'LeadTransferCancelResultOutput';
  code: LeadTransferOutcomeCode;
  request?: Maybe<LeadTransferRequestOutput>;
};

export type LeadTransferChannelDeliveryOutput = {
  __typename?: 'LeadTransferChannelDeliveryOutput';
  channelId: Scalars['UUID']['output'];
  channelName: Scalars['String']['output'];
  deliveryStatus: DeliveryStatus;
  slackChannelId: Scalars['String']['output'];
};

export type LeadTransferClaimResultOutput = {
  __typename?: 'LeadTransferClaimResultOutput';
  code: LeadTransferOutcomeCode;
  request?: Maybe<LeadTransferRequestOutput>;
};

export type LeadTransferCreateResultOutput = {
  __typename?: 'LeadTransferCreateResultOutput';
  code: LeadTransferOutcomeCode;
  existingRequest?: Maybe<LeadTransferRequestOutput>;
  request?: Maybe<LeadTransferRequestOutput>;
};

export type LeadTransferDashboardStatsOutput = {
  __typename?: 'LeadTransferDashboardStatsOutput';
  avgClaimTimeSeconds?: Maybe<Scalars['Long']['output']>;
  claimedTodayCount: Scalars['Long']['output'];
  overdueCount: Scalars['Long']['output'];
  pendingCount: Scalars['Long']['output'];
};

export type LeadTransferEditResultOutput = {
  __typename?: 'LeadTransferEditResultOutput';
  code: LeadTransferOutcomeCode;
  request?: Maybe<LeadTransferRequestOutput>;
};

export type LeadTransferNoteOutput = {
  __typename?: 'LeadTransferNoteOutput';
  createdAt: Scalars['Instant']['output'];
  createdByAgent?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
};

export enum LeadTransferOutcomeCode {
  AlreadyClaimedByYou = 'ALREADY_CLAIMED_BY_YOU',
  Cancelled = 'CANCELLED',
  ClaimedBySomeoneElse = 'CLAIMED_BY_SOMEONE_ELSE',
  ClientHasAnotherOpenRequest = 'CLIENT_HAS_ANOTHER_OPEN_REQUEST',
  ClientNotReady = 'CLIENT_NOT_READY',
  ExistingPendingRequestFound = 'EXISTING_PENDING_REQUEST_FOUND',
  NotClaimed = 'NOT_CLAIMED',
  NotFound = 'NOT_FOUND',
  NotPending = 'NOT_PENDING',
  NotYourClaim = 'NOT_YOUR_CLAIM',
  NoChannelsProvided = 'NO_CHANNELS_PROVIDED',
  StaleGeneration = 'STALE_GENERATION',
  Success = 'SUCCESS',
  UnknownChannel = 'UNKNOWN_CHANNEL'
}

export enum LeadTransferPlanType {
  DentalVision = 'DENTAL_VISION',
  DualEligible = 'DUAL_ELIGIBLE',
  HospitalIndemnity = 'HOSPITAL_INDEMNITY',
  MedicareAdvantage = 'MEDICARE_ADVANTAGE',
  MedicareAdvantagePrescriptionDrug = 'MEDICARE_ADVANTAGE_PRESCRIPTION_DRUG',
  Medigap = 'MEDIGAP',
  OptionalSupplementalBenefits = 'OPTIONAL_SUPPLEMENTAL_BENEFITS',
  PartD = 'PART_D'
}

export type LeadTransferReportFilterInput = {
  assignedAgentIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  callbackDateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  callbackDateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  called?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['UUID']['input']>;
  channelIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  claimSource?: InputMaybe<ClaimSource>;
  claimSources?: InputMaybe<Array<ClaimSource>>;
  claimedByAgentId?: InputMaybe<Scalars['UUID']['input']>;
  claimedByAgentIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  clientSearch?: InputMaybe<Scalars['String']['input']>;
  createdFrom?: InputMaybe<Scalars['Instant']['input']>;
  createdTo?: InputMaybe<Scalars['Instant']['input']>;
  partnerKey?: InputMaybe<LeadPartnerKey>;
  planType?: InputMaybe<LeadTransferPlanType>;
  planTypes?: InputMaybe<Array<LeadTransferPlanType>>;
  requestedByAgentId?: InputMaybe<Scalars['UUID']['input']>;
  requestedByAgentIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  statusFilter?: InputMaybe<LeadReportStatusFilter>;
  statusFilters?: InputMaybe<Array<LeadReportStatusFilter>>;
  tagId?: InputMaybe<Scalars['UUID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  transferType?: InputMaybe<TransferType>;
  transferTypes?: InputMaybe<Array<TransferType>>;
};

export type LeadTransferRequestDetailOutput = {
  __typename?: 'LeadTransferRequestDetailOutput';
  channelDeliveries: Array<LeadTransferChannelDeliveryOutput>;
  request: LeadTransferRequestOutput;
  timeline: Array<ClaimEventOutput>;
};

export type LeadTransferRequestInput = {
  agreedOn?: InputMaybe<Scalars['String']['input']>;
  agreedOnConfirmed: Scalars['Boolean']['input'];
  callType: CallType;
  callbackDate?: InputMaybe<Scalars['LocalDate']['input']>;
  callbackTimeFrom?: InputMaybe<Scalars['String']['input']>;
  callbackTimeTo?: InputMaybe<Scalars['String']['input']>;
  clientViewId: Scalars['UUID']['input'];
  concern: Scalars['String']['input'];
  confirmSupersedeExisting: Scalars['Boolean']['input'];
  currentPlanTypes: Array<LeadTransferPlanType>;
  idempotencyKey?: InputMaybe<Scalars['UUID']['input']>;
  noteText?: InputMaybe<Scalars['String']['input']>;
  soaCompleted: Scalars['Boolean']['input'];
  transferType: TransferType;
};

export type LeadTransferRequestOutput = {
  __typename?: 'LeadTransferRequestOutput';
  agreedOnConfirmed: Scalars['Boolean']['output'];
  calendlyMeetingAttended?: Maybe<Scalars['Boolean']['output']>;
  callCompletedAt?: Maybe<Scalars['Instant']['output']>;
  callType: CallType;
  callbackDate?: Maybe<Scalars['LocalDate']['output']>;
  callbackTimeFrom?: Maybe<Scalars['String']['output']>;
  callbackTimeTo?: Maybe<Scalars['String']['output']>;
  called?: Maybe<Scalars['Boolean']['output']>;
  calledButOverdue: Scalars['Boolean']['output'];
  calledOverride?: Maybe<Scalars['Boolean']['output']>;
  callsCount?: Maybe<Scalars['String']['output']>;
  claimSource?: Maybe<ClaimSource>;
  claimedAt?: Maybe<Scalars['Instant']['output']>;
  claimedByAgentId?: Maybe<Scalars['UUID']['output']>;
  clientAggregateId?: Maybe<Scalars['UUID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientPhoneNumber?: Maybe<Scalars['String']['output']>;
  clientState?: Maybe<Scalars['String']['output']>;
  clientViewId: Scalars['UUID']['output'];
  concern: Scalars['String']['output'];
  createdAt: Scalars['Instant']['output'];
  currentPlanTypes: Array<LeadTransferPlanType>;
  escalationDueAt: Scalars['Instant']['output'];
  generation: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  isOverdue: Scalars['Boolean']['output'];
  notes: Array<LeadTransferNoteOutput>;
  overdueFlaggedAt?: Maybe<Scalars['Instant']['output']>;
  partnerKey?: Maybe<LeadPartnerKey>;
  partnerResolution: PartnerResolution;
  requestedByAgentId: Scalars['UUID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  status: LeadTransferStatus;
  tagIds: Array<Scalars['UUID']['output']>;
  transferType: TransferType;
  winningChannelId?: Maybe<Scalars['UUID']['output']>;
};

export type LeadTransferRequestPageOutput = {
  __typename?: 'LeadTransferRequestPageOutput';
  data: Array<LeadTransferRequestOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type LeadTransferRerouteResultOutput = {
  __typename?: 'LeadTransferRerouteResultOutput';
  code: LeadTransferOutcomeCode;
  request?: Maybe<LeadTransferRequestOutput>;
  unknownChannelId?: Maybe<Scalars['UUID']['output']>;
};

export type LeadTransferResendResultOutput = {
  __typename?: 'LeadTransferResendResultOutput';
  code: LeadTransferOutcomeCode;
  request?: Maybe<LeadTransferRequestOutput>;
};

export enum LeadTransferStatus {
  Cancelled = 'CANCELLED',
  Claimed = 'CLAIMED',
  Pending = 'PENDING'
}

export type LeadTransferUnclaimResultOutput = {
  __typename?: 'LeadTransferUnclaimResultOutput';
  assignmentRestored: Scalars['Boolean']['output'];
  code: LeadTransferOutcomeCode;
  request?: Maybe<LeadTransferRequestOutput>;
};

export enum LeadTransferUpdateEventType {
  CallCompleted = 'CALL_COMPLETED',
  CallLogged = 'CALL_LOGGED',
  Cancelled = 'CANCELLED',
  Claimed = 'CLAIMED',
  ClientStatusChanged = 'CLIENT_STATUS_CHANGED',
  Created = 'CREATED',
  Escalated = 'ESCALATED',
  Unclaimed = 'UNCLAIMED'
}

export type LeadTransferUpdateOutput = {
  __typename?: 'LeadTransferUpdateOutput';
  eventType: LeadTransferUpdateEventType;
  generation: Scalars['Int']['output'];
  occurredAt: Scalars['Instant']['output'];
  requestId: Scalars['UUID']['output'];
};

export enum LeadUpdateCode {
  CalledLeftVm = 'CALLED_LEFT_VM',
  ContactedSuccessfulCall = 'CONTACTED_SUCCESSFUL_CALL',
  Disqualified = 'DISQUALIFIED',
  Emailed = 'EMAILED',
  Other = 'OTHER',
  SubmittedApp = 'SUBMITTED_APP'
}

export enum LinkSlackAccountOutcome {
  AlreadyLinkedToAnotherAgent = 'ALREADY_LINKED_TO_ANOTHER_AGENT',
  InvalidOrExpiredState = 'INVALID_OR_EXPIRED_STATE',
  Success = 'SUCCESS'
}

export type ListCalendarEventsInput = {
  maxResults: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  timeMax?: InputMaybe<Scalars['Instant']['input']>;
  timeMin?: InputMaybe<Scalars['Instant']['input']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type ManagementReportAgentOutput = {
  __typename?: 'ManagementReportAgentOutput';
  agentId: Scalars['UUID']['output'];
  calls: Scalars['Int']['output'];
  contactRequests: Scalars['Int']['output'];
  contactRequestsDone: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  followUps: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  managerNotes: Scalars['Int']['output'];
  managerNotesDone: Scalars['Int']['output'];
  managerRequests: Scalars['Int']['output'];
  managerRequestsDone: Scalars['Int']['output'];
  prioritiesSet: Scalars['Int']['output'];
  sqls: Scalars['Int']['output'];
  submittedMtd: Scalars['Int']['output'];
};

export type ManagementReportCoachingOutput = {
  __typename?: 'ManagementReportCoachingOutput';
  contactRequests: Scalars['Int']['output'];
  fromOthers: Scalars['Int']['output'];
  managerNotes: Scalars['Int']['output'];
  priorities: Scalars['Int']['output'];
};

export type ManagementReportLedgerEntryOutput = {
  __typename?: 'ManagementReportLedgerEntryOutput';
  clientId: Scalars['UUID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  clientStatus?: Maybe<StatusDto>;
  detail?: Maybe<Scalars['String']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  doneAt?: Maybe<Scalars['Instant']['output']>;
  kind: ManagementReportLedgerKind;
  occurredAt: Scalars['Instant']['output'];
};

export enum ManagementReportLedgerKind {
  Call = 'CALL',
  Email = 'EMAIL',
  ManagerRequest = 'MANAGER_REQUEST',
  Note = 'NOTE',
  StatusChange = 'STATUS_CHANGE',
  TaskDone = 'TASK_DONE',
  Text = 'TEXT'
}

export enum ManagementReportRequestKind {
  AgentUpdate = 'AGENT_UPDATE',
  ContactRequest = 'CONTACT_REQUEST',
  ManagerNote = 'MANAGER_NOTE',
  ManagerUpdate = 'MANAGER_UPDATE',
  Priority = 'PRIORITY'
}

export type ManagementReportRequestOutput = {
  __typename?: 'ManagementReportRequestOutput';
  callRequired?: Maybe<Scalars['Boolean']['output']>;
  clientId: Scalars['UUID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  clientStatus?: Maybe<StatusDto>;
  detail?: Maybe<Scalars['String']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  doneAt?: Maybe<Scalars['Instant']['output']>;
  doneBy?: Maybe<Scalars['String']['output']>;
  kind: ManagementReportRequestKind;
  managerName?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['Instant']['output'];
};

export type ManagementReportTeamOutput = {
  __typename?: 'ManagementReportTeamOutput';
  agents: Array<ManagementReportAgentOutput>;
  coaching: ManagementReportCoachingOutput;
  lead: TimeclockTeamLeadOutput;
  teamId: Scalars['UUID']['output'];
  teamName: Scalars['String']['output'];
};

export type ManagerApprovalHistoryOutput = {
  __typename?: 'ManagerApprovalHistoryOutput';
  actionItemId: Scalars['UUID']['output'];
  actorId?: Maybe<Scalars['UUID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type ManagerApprovalRequestOutput = {
  __typename?: 'ManagerApprovalRequestOutput';
  actionItemId: Scalars['UUID']['output'];
  actionItemTitle: Scalars['String']['output'];
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  aiAttemptCount: Scalars['Int']['output'];
  aiLastReasoning?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['Instant']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submittedAt: Scalars['Instant']['output'];
};

export enum ManagerApprovalStatus {
  ManagerApproved = 'MANAGER_APPROVED',
  ManagerRejected = 'MANAGER_REJECTED',
  None = 'NONE',
  Pending = 'PENDING'
}

export type ManagerNoteItemOutput = {
  __typename?: 'ManagerNoteItemOutput';
  acknowledgedAt?: Maybe<Scalars['Instant']['output']>;
  acknowledgedByName?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  lastReply?: Maybe<ManagerNoteReplyOutput>;
  lastReplyAt?: Maybe<Scalars['Instant']['output']>;
  note: Scalars['String']['output'];
  noteId: Scalars['UUID']['output'];
  replyCount: Scalars['Int']['output'];
};

export type ManagerNoteReplyOutput = {
  __typename?: 'ManagerNoteReplyOutput';
  clientId: Scalars['UUID']['output'];
  createdAt: Scalars['Instant']['output'];
  createdByAgent?: Maybe<Scalars['UUID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  noteId: Scalars['UUID']['output'];
};

export enum ManagerNoteScope {
  Assigned = 'ASSIGNED',
  Authored = 'AUTHORED'
}

export enum ManagerNoteStatus {
  All = 'ALL',
  Handled = 'HANDLED',
  Open = 'OPEN'
}

export enum MedicareEnrollmentType {
  MaNew = 'MA_NEW',
  MaReplacement = 'MA_REPLACEMENT',
  MaUnlikeChange = 'MA_UNLIKE_CHANGE'
}

export type MedicareQuoteOutput = {
  __typename?: 'MedicareQuoteOutput';
  agentOffer?: Maybe<Scalars['Boolean']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  customAnswers?: Maybe<Scalars['String']['output']>;
  doctors: Array<DoctorViewOutput>;
  drugs: Array<DrugViewOutput>;
  filters?: Maybe<FiltersOutput>;
  pin?: Maybe<Scalars['String']['output']>;
  quoteId: Scalars['UUID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum MedigapEnrollmentAccessibleFormat {
  AccessibleScreenReader = 'ACCESSIBLE_SCREEN_READER',
  Audio = 'AUDIO',
  Braille = 'BRAILLE',
  LargePrint = 'LARGE_PRINT',
  OralOverThePhone = 'ORAL_OVER_THE_PHONE'
}

export type MedigapEnrollmentAddress = {
  __typename?: 'MedigapEnrollmentAddress';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  toRegular: Address;
  zip: Scalars['String']['output'];
};

export type MedigapEnrollmentAddressInput = {
  aptNumber: Scalars['String']['input'];
  city: Scalars['String']['input'];
  county: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type MedigapEnrollmentInput = {
  accessibleFormatPreference?: InputMaybe<MedigapEnrollmentAccessibleFormat>;
  age: Scalars['Int']['input'];
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  applicationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  cId?: InputMaybe<Scalars['String']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  effectiveDate: Scalars['LocalDate']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentType?: InputMaybe<MedigapEnrollmentType>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender: Gender;
  hospitalDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<MedigapEnrollmentAddressInput>;
  medicalDate?: InputMaybe<Scalars['LocalDate']['input']>;
  medicareNumber?: InputMaybe<Scalars['String']['input']>;
  medigapQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  naic: Scalars['String']['input'];
  pdpBidId?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<MedigapEnrollmentAddressInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planKey: Scalars['String']['input'];
  planName: MedigapEnrollmentPlanName;
  planYear?: InputMaybe<PlanYear>;
  preferredLanguage?: InputMaybe<MedigapEnrollmentPreferredLanguage>;
  started?: InputMaybe<Scalars['Instant']['input']>;
  tobacco: Scalars['Boolean']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MedigapEnrollmentOutput = {
  __typename?: 'MedigapEnrollmentOutput';
  accessibleFormatPreference?: Maybe<MedigapEnrollmentAccessibleFormat>;
  age: Scalars['Int']['output'];
  agentId?: Maybe<Scalars['UUID']['output']>;
  applicationDate?: Maybe<Scalars['LocalDate']['output']>;
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  effectiveDate: Scalars['LocalDate']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<MedigapEnrollmentType>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender: Gender;
  hospitalDate?: Maybe<Scalars['LocalDate']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<MedigapEnrollmentAddress>;
  medicalDate?: Maybe<Scalars['LocalDate']['output']>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medigapQuoteId?: Maybe<Scalars['UUID']['output']>;
  naic: Scalars['String']['output'];
  permanentAddress?: Maybe<MedigapEnrollmentAddress>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planKey?: Maybe<Scalars['String']['output']>;
  planName: MedigapEnrollmentPlanName;
  planYear?: Maybe<PlanYear>;
  preferredLanguage?: Maybe<MedigapEnrollmentPreferredLanguage>;
  started?: Maybe<Scalars['Instant']['output']>;
  status: MedigapEnrollmentStatus;
  tobacco: Scalars['Boolean']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export enum MedigapEnrollmentPlanName {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  Hdf = 'HDF',
  Hdg = 'HDG',
  I = 'I',
  K = 'K',
  L = 'L',
  M = 'M',
  MaCore = 'MA_CORE',
  MaSupp1 = 'MA_SUPP1',
  MaSupp1A = 'MA_SUPP1A',
  MnrExcs = 'MNR_EXCS',
  MnrPrev = 'MNR_PREV',
  MnrPta = 'MNR_PTA',
  MnrPtb = 'MNR_PTB',
  MnrUhc1 = 'MNR_UHC1',
  MnrUprv = 'MNR_UPRV',
  MnBasic = 'MN_BASIC',
  MnExtb = 'MN_EXTB',
  MnHded = 'MN_HDED',
  MnPbco = 'MN_PBCO',
  MnXbas = 'MN_XBAS',
  MnXbas2 = 'MN_XBAS2',
  N = 'N',
  WiBase = 'WI_BASE'
}

export enum MedigapEnrollmentPreferredLanguage {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  Spanish = 'SPANISH',
  Vietnamese = 'VIETNAMESE'
}

export enum MedigapEnrollmentStatus {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum MedigapEnrollmentType {
  MgGi = 'MG_GI',
  MgOep = 'MG_OEP',
  MgUnderwritten = 'MG_UNDERWRITTEN'
}

export enum MedigapEnrollmentViewAccessibleFormat {
  AccessibleScreenReader = 'ACCESSIBLE_SCREEN_READER',
  Audio = 'AUDIO',
  Braille = 'BRAILLE',
  LargePrint = 'LARGE_PRINT',
  OralOverThePhone = 'ORAL_OVER_THE_PHONE'
}

export type MedigapEnrollmentViewAddress = {
  __typename?: 'MedigapEnrollmentViewAddress';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export enum MedigapEnrollmentViewGender {
  F = 'F',
  M = 'M'
}

export type MedigapEnrollmentViewOutput = {
  __typename?: 'MedigapEnrollmentViewOutput';
  accessibleFormatPreference?: Maybe<MedigapEnrollmentViewAccessibleFormat>;
  age: Scalars['Int']['output'];
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  effectiveDate: Scalars['LocalDate']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender: MedigapEnrollmentViewGender;
  hospitalDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<MedigapEnrollmentViewAddress>;
  medicalDate?: Maybe<Scalars['LocalDate']['output']>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  naic: Scalars['String']['output'];
  pdpBidId?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<MedigapEnrollmentViewAddress>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName: Scalars['String']['output'];
  preferredLanguage?: Maybe<MedigapEnrollmentViewPreferredLanguage>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  status: MedigapEnrollmentViewStatus;
  tobacco: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
};

export enum MedigapEnrollmentViewPreferredLanguage {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  Spanish = 'SPANISH',
  Vietnamese = 'VIETNAMESE'
}

export enum MedigapEnrollmentViewStatus {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type MedigapFilterInput = {
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MedigapFilterStateBenefit {
  ForeignTravelEmergency = 'FOREIGN_TRAVEL_EMERGENCY',
  PartADeductible = 'PART_A_DEDUCTIBLE',
  PartBDeductible = 'PART_B_DEDUCTIBLE',
  PartBExcessCharges = 'PART_B_EXCESS_CHARGES',
  SkilledNursingFacilities = 'SKILLED_NURSING_FACILITIES'
}

export enum MedigapFilterStateGender {
  F = 'F',
  M = 'M'
}

export enum MedigapFilterStatePlanName {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  Hdf = 'HDF',
  Hdg = 'HDG',
  I = 'I',
  K = 'K',
  L = 'L',
  M = 'M',
  MaCore = 'MA_CORE',
  MaSupp1 = 'MA_SUPP1',
  MaSupp1A = 'MA_SUPP1A',
  MnrExcs = 'MNR_EXCS',
  MnrPrev = 'MNR_PREV',
  MnrPta = 'MNR_PTA',
  MnrPtb = 'MNR_PTB',
  MnrUhc1 = 'MNR_UHC1',
  MnrUprv = 'MNR_UPRV',
  MnBasic = 'MN_BASIC',
  MnExtb = 'MN_EXTB',
  MnHded = 'MN_HDED',
  MnPbco = 'MN_PBCO',
  MnXbas = 'MN_XBAS',
  N = 'N'
}

export type MedigapFilterStateViewOutput = {
  __typename?: 'MedigapFilterStateViewOutput';
  age: Scalars['Int']['output'];
  benefits?: Maybe<Array<MedigapFilterStateBenefit>>;
  companies?: Maybe<Array<Scalars['String']['output']>>;
  county?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  gender: MedigapFilterStateGender;
  id?: Maybe<Scalars['UUID']['output']>;
  monthlyPlanPremiumRanges?: Maybe<Array<Scalars['String']['output']>>;
  planCategory?: Maybe<Scalars['String']['output']>;
  planNames?: Maybe<Array<MedigapFilterStatePlanName>>;
  tobacco: Scalars['Boolean']['output'];
  zip: Scalars['String']['output'];
};

export type MedigapQuoteViewOutput = {
  __typename?: 'MedigapQuoteViewOutput';
  cId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['UUID']['output'];
  medigapFilterState?: Maybe<MedigapFilterStateViewOutput>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type MigrateAgentRawDigitsState = {
  __typename?: 'MigrateAgentRawDigitsState';
  error?: Maybe<Scalars['String']['output']>;
  irProcessRunning: Scalars['Boolean']['output'];
  processedCount: Scalars['Int']['output'];
};

export type MissedLunchCandidateOutput = {
  __typename?: 'MissedLunchCandidateOutput';
  agentId: Scalars['UUID']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  spanHours: Scalars['BigDecimal']['output'];
  unpaidBreakHours: Scalars['BigDecimal']['output'];
  workDate: Scalars['LocalDate']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeManagerNote: Scalars['Boolean']['output'];
  addClientFiles: Scalars['Boolean']['output'];
  addLeadManagerNote: LeadActionOutput;
  addTeamMember: TeamOutput;
  applyFollowUpSweep: FollowUpSweepApplyOutput;
  applyTeamScheduleForWeek: Scalars['Int']['output'];
  appointmentReminderAgentConfirmedButWillBeLateConfirmByCsr: Scalars['Boolean']['output'];
  appointmentReminderAgentIsMissingAppointmentConfirmByCsr: Scalars['Boolean']['output'];
  appointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgent: Scalars['Boolean']['output'];
  appointmentReminderCSRAcknowledgedAgentWillBeLateConfirmByAgent: Scalars['Boolean']['output'];
  appointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgent: Scalars['Boolean']['output'];
  appointmentReminderRequiredAgentConfirmationConfirm: Scalars['Boolean']['output'];
  appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgent: Scalars['Boolean']['output'];
  appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTime: Scalars['Boolean']['output'];
  appointmentReminderRequiredAgentConfirmationWillBeLate: Scalars['Boolean']['output'];
  appointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsr: Scalars['Boolean']['output'];
  appointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsr: Scalars['Boolean']['output'];
  appointmentReminderSuggestedToRescheduleAppointmentConfirmByAgent: Scalars['Boolean']['output'];
  approveManagerApprovalRequest: ManagerApprovalRequestOutput;
  approveRingMetricException: RingMetricExceptionOutput;
  archiveChannel: ChannelResultOutput;
  archiveCopilotConversation: Scalars['Boolean']['output'];
  assignLeadTransferRequest: LeadTransferClaimResultOutput;
  attemptResolveReconnect: ReconnectActionResult;
  bulkAttemptResolveReconnects: BulkReconnectResult;
  bulkResolveMissedLunch: Scalars['Int']['output'];
  bulkSetSchedule: BulkSetScheduleOutput;
  cancelLeadTransferRequest: LeadTransferCancelResultOutput;
  cancelPunchCorrection: Scalars['Boolean']['output'];
  cancelScheduleException: Scalars['Boolean']['output'];
  changeEnrollmentStatus?: Maybe<Scalars['UUID']['output']>;
  changeLeadDisposition: LeadActionOutput;
  changeMedigapEnrollmentStatus: Scalars['Boolean']['output'];
  changePdpEnrollmentStatus: Scalars['Boolean']['output'];
  checkPlatformCredentials: PlatformCredentialsOutput;
  choosePlatformDrugOption: Scalars['Boolean']['output'];
  claimAttempt: ClaimAttemptResultOutput;
  claimLeadTransferRequest: LeadTransferClaimResultOutput;
  clearFlexpaCache: Scalars['Boolean']['output'];
  clearScheduleOverride: Scalars['Boolean']['output'];
  clientCommunicationNoShow: Scalars['Boolean']['output'];
  completeAdminTask: AdminTaskResult;
  confirmScopeOfAppointment: Scalars['UUID']['output'];
  convertScheduleRequestToPunchFix: ScheduleExceptionRequestOutput;
  copyScheduleWeek: CopyScheduleWeekOutput;
  correctPunch: PunchOutput;
  createCalendarEvent: CalendarEventOutput;
  createChannel: ChannelResultOutput;
  createClientNote: Scalars['Boolean']['output'];
  createDepartment: DepartmentOutput;
  createLeadTransferRequest: LeadTransferCreateResultOutput;
  createOfflineConversionSyncProcess: OfflineConversionSyncProcessOutput;
  createScopeOfAppointment: Scalars['UUID']['output'];
  createTeam: TeamOutput;
  /** @deprecated Need to use saveUserProfile API */
  createUser: KeycloakUserOutput;
  cutoverAgentToGmailPushSync: CutoverAgentResult;
  deactivateDepartment: Scalars['Boolean']['output'];
  deactivateTimeclockProfile: Scalars['Boolean']['output'];
  decidePunchCorrection: PunchCorrectionRequestOutput;
  decideScheduleException: ScheduleExceptionRequestOutput;
  deferReconnect: DeferResult;
  deleteActionItem: Scalars['Boolean']['output'];
  deleteAgentEmail: Scalars['Boolean']['output'];
  deleteCalendarEvent: Scalars['Boolean']['output'];
  deleteChannel: ChannelResultOutput;
  deleteClientDocument: Scalars['Boolean']['output'];
  deleteClientFile: Scalars['Boolean']['output'];
  deleteClientNote: Scalars['Boolean']['output'];
  deleteClientsFromAnyGroup: Scalars['Boolean']['output'];
  deleteCompareOfferHistoryItem: Scalars['Boolean']['output'];
  deleteDepartment: Scalars['Boolean']['output'];
  deleteEmailTemplate: Scalars['Boolean']['output'];
  deleteEnrollment: Scalars['Boolean']['output'];
  deleteMedigapEnrollment: Scalars['Boolean']['output'];
  deleteOfflineConversionSyncProcess: Scalars['Boolean']['output'];
  deleteOfflineConversionSyncProcessBeforeDate: Scalars['Boolean']['output'];
  deletePdpEnrollment: Scalars['Boolean']['output'];
  deletePlatformCredentials: Scalars['Boolean']['output'];
  deletePunch: Scalars['Boolean']['output'];
  deletePurchasedProduct: Scalars['Boolean']['output'];
  deleteScheduleSegment: Scalars['Boolean']['output'];
  deleteTag: Scalars['Boolean']['output'];
  deleteTeam: Scalars['Boolean']['output'];
  deleteTestClient: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  dialClient: Scalars['Boolean']['output'];
  dismissRequiredAction: Scalars['Boolean']['output'];
  editLeadTransferRequest: LeadTransferEditResultOutput;
  editQaReview: CallQaOutput;
  emailMeMAPage: Scalars['Boolean']['output'];
  emailMeMedigapPage: Scalars['Boolean']['output'];
  enrollInTimeclock: TimeclockAgentProfileOutput;
  fixPunchCorrectionWithEdits: PunchCorrectionRequestOutput;
  generateFollowUpSweep: FollowUpSweepStartOutput;
  getRefreshToken: LoginResponse;
  linkAdviserWithClient: Scalars['Boolean']['output'];
  /** Link a roster patient to a client, covering every campaign that person appears in. */
  linkRosterPatient: RosterLinkOutput;
  loadScheduleRange: TimeclockScheduleJobOutput;
  login: LoginResponse;
  markAppointmentRequestAsDone: Scalars['Boolean']['output'];
  markRequiredActionAsDone: Scalars['Boolean']['output'];
  mergeClientsInOneGroup: Scalars['Boolean']['output'];
  mergeGroups: Scalars['Boolean']['output'];
  migrateAllEnrollmentsPlanNames: EnrollmentPlanNameMigrationResult;
  migrateEnrollmentsWithBrokenAgent: Scalars['Boolean']['output'];
  migrateY2YByClientId: Scalars['Boolean']['output'];
  openedScopeOfAppointment: Scalars['Boolean']['output'];
  overrideLeadTransferCalled: LeadTransferRequestOutput;
  patchClientPersonalInfo: Scalars['Boolean']['output'];
  punchTimeclock: PunchOutput;
  putTemporalData: Scalars['UUID']['output'];
  reactivateChannel: ChannelResultOutput;
  reactivateDepartment: DepartmentOutput;
  reactivateTimeclockProfile: Scalars['Boolean']['output'];
  reassignTeamLead: TeamOutput;
  rebuildTodaysReconnectSnapshots: Scalars['Boolean']['output'];
  recheckChannelSlackHealth: ChannelResultOutput;
  refreshDayPlan: Scalars['Boolean']['output'];
  refreshPreCallBriefing?: Maybe<PreCallBriefingOutput>;
  rejectManagerApprovalRequest: ManagerApprovalRequestOutput;
  rejectRingMetricException: RingMetricExceptionOutput;
  removeTeamMember: TeamOutput;
  renameCopilotConversation: Scalars['Boolean']['output'];
  renameTeam: TeamOutput;
  reorderPayroll: Scalars['Boolean']['output'];
  replyToManagerNote: Scalars['Boolean']['output'];
  requestCsrFollowUp: Scalars['Boolean']['output'];
  requestLeadContact: LeadActionOutput;
  requestManagerApproval: ManagerApprovalRequestOutput;
  requestPunchCorrection: PunchCorrectionRequestOutput;
  requestPunchEdit: PunchCorrectionRequestOutput;
  requestReconnectExcusal: RingMetricExceptionOutput;
  requestScheduleException: ScheduleExceptionRequestOutput;
  requestUrgentCall: Scalars['Boolean']['output'];
  rerouteLeadTransferRequest: LeadTransferRerouteResultOutput;
  resendLeadTransferRequest: LeadTransferResendResultOutput;
  resetPassword: Scalars['Boolean']['output'];
  resolveClientDocumentReview: ClientDocumentOutput;
  resolveMissedLunch: Scalars['Boolean']['output'];
  respondToCalendarEvent: CalendarEventOutput;
  retryClientPlatformSync: Scalars['Boolean']['output'];
  retrySlackInteraction: RetrySlackInteractionOutcome;
  saveActionItem: ActionItemOutput;
  saveAdvisorDetails: AdvisorDetailsOutput;
  saveAgent: Scalars['UUID']['output'];
  saveAgentGmailCode: Scalars['Boolean']['output'];
  saveAgentSlackCode: LinkSlackAccountOutcome;
  saveCallHistory: Scalars['UUID']['output'];
  saveChannelAttribution: Scalars['Boolean']['output'];
  saveClientTag: Scalars['Boolean']['output'];
  saveClientTrackingId: Scalars['Boolean']['output'];
  saveClientWatchers: Scalars['Boolean']['output'];
  saveCompareOfferHistoryItem: Scalars['Boolean']['output'];
  saveDisqualifiedReason: Scalars['Boolean']['output'];
  saveEmailTemplate: Scalars['UUID']['output'];
  saveEnrollment: Scalars['UUID']['output'];
  saveExpectedCloseDate: Scalars['Boolean']['output'];
  saveFlexpaToken: Scalars['Boolean']['output'];
  saveManagerNote: Scalars['Boolean']['output'];
  saveMedigapEnrollment: Scalars['UUID']['output'];
  savePdpEnrollment: PdpEnrollmentOutput;
  savePlatformCredentials: PlatformCredentialsOutput;
  savePreferredContactMethod: Scalars['Boolean']['output'];
  saveProductsClientAgreedToDiscuss: Scalars['Boolean']['output'];
  savePurchasedProduct: Scalars['UUID']['output'];
  saveStatus: SaveStatusResult;
  saveTag: Scalars['UUID']['output'];
  saveUserProfile: UserProfileSaveOutput;
  scheduleAiCall: Scalars['Boolean']['output'];
  scheduleAiCalls: BulkScheduleAiCallResult;
  sendClientSms: ClientSmsOutput;
  sendComparisonEmail: Scalars['Boolean']['output'];
  sendCopilotMessage: Scalars['Boolean']['output'];
  sendGreeting: Scalars['String']['output'];
  sendY2YEmail: Scalars['Boolean']['output'];
  setAdminFlagForAllEnrollmentsByClientId: Scalars['Boolean']['output'];
  setCalendlyAppointmentNoShow: Scalars['Boolean']['output'];
  setCanViewFloor: Scalars['Boolean']['output'];
  setClientUserId: Scalars['Boolean']['output'];
  setDefaultAgent: Scalars['Boolean']['output'];
  setDontDisturb: Scalars['Boolean']['output'];
  setFallbackChannel: ChannelResultOutput;
  setHealthInformationDisclosureCheck: Scalars['Boolean']['output'];
  setLeadPriority: LeadActionOutput;
  setNewPassword: Scalars['Boolean']['output'];
  setOwnHealthcareDecisionCheck: Scalars['Boolean']['output'];
  setPlatformSyncEnabled: PlatformCredentialsOutput;
  setRecordedLineAgreementCheck: Scalars['Boolean']['output'];
  setSOAAgreementCheck: Scalars['Boolean']['output'];
  setScheduleDay: Scalars['Boolean']['output'];
  setScheduleSegment: ScheduleSegmentOutput;
  setTPMOAgreementCheck: Scalars['Boolean']['output'];
  setUrgentCallRequested: Scalars['Boolean']['output'];
  startAICall: Scalars['Boolean']['output'];
  startAgentRawDigitsMigration: Scalars['Boolean']['output'];
  startTestCallFor30Seconds: Scalars['Boolean']['output'];
  stopAgentRawDigitsMigration: Scalars['Boolean']['output'];
  submitClientAdminPhotoVerification: ClientAdminPhotoVerificationResult;
  submitLeadTransferNote: LeadTransferCreateResultOutput;
  submitLeadUpdate: LeadActionOutput;
  syncClientEmails: SyncClientEmailsResult;
  syncGmailMessages: Scalars['Boolean']['output'];
  syncHawksoft: Scalars['Boolean']['output'];
  syncOfflineConversions: Scalars['Boolean']['output'];
  unclaimLeadTransferRequest: LeadTransferUnclaimResultOutput;
  /** Detach a roster patient from a client. Requires a reason; same authority as linking. */
  unlinkRosterPatient: RosterLinkOutput;
  updateCalendarEvent: CalendarEventOutput;
  updateCallingHours: CallingHours;
  updateChannel: ChannelResultOutput;
  updateClientNote: Scalars['Boolean']['output'];
  updateDepartment: DepartmentOutput;
  updateMyDisplayTimezone: Scalars['Boolean']['output'];
  updateNewLeadOutreachDelayMinutes: Scalars['Int']['output'];
  updateNewLeadOutreachEnabled: Scalars['Boolean']['output'];
  updateNewLeadSmsDelayMinutes: Scalars['Int']['output'];
  updateOfflineConversionSyncProcess: OfflineConversionSyncProcessOutput;
  updateRRStatus: Scalars['String']['output'];
  updateSendInBlueByEmail: Scalars['String']['output'];
  updateSmsOutreachEnabled: Scalars['Boolean']['output'];
  updateSources: Array<LeadSourceOutput>;
  updateTimeclockProfile: TimeclockAgentProfileOutput;
  updateVoiceAiExcludedTagIds: Array<Scalars['UUID']['output']>;
  updatedUserProfileByAdvisor: Scalars['Boolean']['output'];
  uploadAgentAvatar: Scalars['String']['output'];
  uploadClientDocument: ClientDocumentOutput;
  uploadFollowUpSweep: FollowUpSweepUploadOutput;
  /** Confirm a patient's date of birth. The agent asks the caller; the date is never shown. Rate limited and audited. */
  verifyRosterPatient: RosterVerificationOutput;
};


export type MutationAcknowledgeManagerNoteArgs = {
  noteId: Scalars['UUID']['input'];
};


export type MutationAddClientFilesArgs = {
  clientFiles: Array<ClientFileInput>;
  clientId: Scalars['UUID']['input'];
};


export type MutationAddLeadManagerNoteArgs = {
  clientId: Scalars['UUID']['input'];
  note: Scalars['String']['input'];
};


export type MutationAddTeamMemberArgs = {
  agentId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationApplyFollowUpSweepArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  gcsUri: Scalars['String']['input'];
};


export type MutationApplyTeamScheduleForWeekArgs = {
  breakMinutes?: InputMaybe<Scalars['Int']['input']>;
  end: Scalars['String']['input'];
  setAsRecurringPattern?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['String']['input'];
  teamId: Scalars['UUID']['input'];
  weekStart: Scalars['LocalDate']['input'];
  weekdays: Array<Scalars['Int']['input']>;
};


export type MutationAppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderAgentIsMissingAppointmentConfirmByCsrArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredAgentConfirmationConfirmArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredAgentConfirmationWillBeLateArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationApproveManagerApprovalRequestArgs = {
  actionItemId: Scalars['UUID']['input'];
};


export type MutationApproveRingMetricExceptionArgs = {
  exceptionId: Scalars['UUID']['input'];
};


export type MutationArchiveChannelArgs = {
  channelId: Scalars['UUID']['input'];
  confirm: Scalars['Boolean']['input'];
};


export type MutationArchiveCopilotConversationArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['String']['input'];
};


export type MutationAssignLeadTransferRequestArgs = {
  agentId: Scalars['UUID']['input'];
  expectedGeneration: Scalars['Int']['input'];
  requestId: Scalars['UUID']['input'];
};


export type MutationAttemptResolveReconnectArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  clientId: Scalars['UUID']['input'];
};


export type MutationBulkAttemptResolveReconnectsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  clientIds: Array<Scalars['UUID']['input']>;
};


export type MutationBulkResolveMissedLunchArgs = {
  agentIds: Array<Scalars['UUID']['input']>;
  decision: Scalars['String']['input'];
  workDate: Scalars['LocalDate']['input'];
};


export type MutationBulkSetScheduleArgs = {
  entries: Array<BulkScheduleEntryInput>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCancelLeadTransferRequestArgs = {
  requestId: Scalars['UUID']['input'];
};


export type MutationCancelPunchCorrectionArgs = {
  requestId: Scalars['UUID']['input'];
};


export type MutationCancelScheduleExceptionArgs = {
  requestId: Scalars['UUID']['input'];
};


export type MutationChangeEnrollmentStatusArgs = {
  enrollmentId: Scalars['UUID']['input'];
  status: EnrollmentStatusInput;
};


export type MutationChangeLeadDispositionArgs = {
  clientId: Scalars['UUID']['input'];
  disposition: LeadDisposition;
  disqualifiedReason?: InputMaybe<DisqualifiedReasonDto>;
  excuseReason?: InputMaybe<Scalars['String']['input']>;
  expectedCloseDate?: InputMaybe<Scalars['LocalDate']['input']>;
  nextContact?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationChangeMedigapEnrollmentStatusArgs = {
  enrollmentId: Scalars['UUID']['input'];
  status: MedigapEnrollmentStatus;
};


export type MutationChangePdpEnrollmentStatusArgs = {
  enrollmentId: Scalars['UUID']['input'];
  status: PdpEnrollmentStatus;
};


export type MutationCheckPlatformCredentialsArgs = {
  platform: SyncPlatform;
};


export type MutationChoosePlatformDrugOptionArgs = {
  alternative?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['UUID']['input'];
  option?: InputMaybe<PlatformDrugOptionInput>;
  packRxcui: Scalars['String']['input'];
  platform: SyncPlatform;
};


export type MutationClaimAttemptArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationClaimLeadTransferRequestArgs = {
  expectedGeneration: Scalars['Int']['input'];
  requestId: Scalars['UUID']['input'];
  winningChannelId: Scalars['UUID']['input'];
};


export type MutationClearScheduleOverrideArgs = {
  agentId: Scalars['UUID']['input'];
  date: Scalars['LocalDate']['input'];
};


export type MutationClientCommunicationNoShowArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationCompleteAdminTaskArgs = {
  actionItemId: Scalars['UUID']['input'];
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmScopeOfAppointmentArgs = {
  userInput: ScopeOfAppointmentUserInput;
};


export type MutationConvertScheduleRequestToPunchFixArgs = {
  action: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  operations?: InputMaybe<Array<PunchEditOperationInput>>;
  proposedEndTime?: InputMaybe<Scalars['String']['input']>;
  proposedStartTime?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['UUID']['input'];
};


export type MutationCopyScheduleWeekArgs = {
  agentIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  sourceWeekStart: Scalars['LocalDate']['input'];
  targetWeekStarts: Array<Scalars['LocalDate']['input']>;
};


export type MutationCorrectPunchArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  exceptionReason?: InputMaybe<Scalars['String']['input']>;
  punchId: Scalars['UUID']['input'];
  punchedAt?: InputMaybe<Scalars['Instant']['input']>;
};


export type MutationCreateCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  input: CreateCalendarEventInput;
};


export type MutationCreateChannelArgs = {
  input: ChannelInput;
};


export type MutationCreateClientNoteArgs = {
  adminTask?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['UUID']['input'];
  isManagerNote?: InputMaybe<Scalars['Boolean']['input']>;
  note: Scalars['String']['input'];
};


export type MutationCreateDepartmentArgs = {
  name: Scalars['String']['input'];
  payrollExport: Scalars['Boolean']['input'];
  unpaidAfterHours: Scalars['BigDecimal']['input'];
};


export type MutationCreateLeadTransferRequestArgs = {
  input: LeadTransferRequestInput;
};


export type MutationCreateOfflineConversionSyncProcessArgs = {
  input: OfflineConversionSyncProcessCreateInput;
};


export type MutationCreateScopeOfAppointmentArgs = {
  adminInput: ScopeOfAppointmentAdminInput;
};


export type MutationCreateTeamArgs = {
  departmentId: Scalars['UUID']['input'];
  leadAgentId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  input: KeycloakUserInput;
};


export type MutationCutoverAgentToGmailPushSyncArgs = {
  agentId: Scalars['UUID']['input'];
};


export type MutationDeactivateDepartmentArgs = {
  departmentId: Scalars['UUID']['input'];
};


export type MutationDeactivateTimeclockProfileArgs = {
  agentId: Scalars['UUID']['input'];
};


export type MutationDecidePunchCorrectionArgs = {
  decision: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['UUID']['input'];
};


export type MutationDecideScheduleExceptionArgs = {
  approvedEndTime?: InputMaybe<Scalars['String']['input']>;
  approvedStartTime?: InputMaybe<Scalars['String']['input']>;
  decision: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['UUID']['input'];
};


export type MutationDeferReconnectArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  clientId: Scalars['UUID']['input'];
  excuseReason?: InputMaybe<Scalars['String']['input']>;
  reasonCode: Scalars['String']['input'];
};


export type MutationDeleteActionItemArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteAgentEmailArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};


export type MutationDeleteChannelArgs = {
  channelId: Scalars['UUID']['input'];
};


export type MutationDeleteClientDocumentArgs = {
  documentId: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteClientFileArgs = {
  clientId: Scalars['UUID']['input'];
  link: Scalars['String']['input'];
};


export type MutationDeleteClientNoteArgs = {
  noteId: Scalars['UUID']['input'];
};


export type MutationDeleteClientsFromAnyGroupArgs = {
  clientIds: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteCompareOfferHistoryItemArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDepartmentArgs = {
  departmentId: Scalars['UUID']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteEnrollmentArgs = {
  enrollmentId: Scalars['UUID']['input'];
};


export type MutationDeleteMedigapEnrollmentArgs = {
  medigapEnrollmentId: Scalars['UUID']['input'];
};


export type MutationDeleteOfflineConversionSyncProcessArgs = {
  id: Scalars['Long']['input'];
};


export type MutationDeleteOfflineConversionSyncProcessBeforeDateArgs = {
  beforeDate: Scalars['LocalDate']['input'];
};


export type MutationDeletePdpEnrollmentArgs = {
  enrollmentId: Scalars['UUID']['input'];
};


export type MutationDeletePlatformCredentialsArgs = {
  platform: SyncPlatform;
};


export type MutationDeletePunchArgs = {
  punchId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDeletePurchasedProductArgs = {
  purchasedProductId: Scalars['UUID']['input'];
};


export type MutationDeleteScheduleSegmentArgs = {
  segmentId: Scalars['UUID']['input'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MutationDeleteTestClientArgs = {
  email: Scalars['String']['input'];
};


export type MutationDialClientArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationDismissRequiredActionArgs = {
  id: Scalars['String']['input'];
};


export type MutationEditLeadTransferRequestArgs = {
  input: EditLeadTransferRequestInput;
};


export type MutationEditQaReviewArgs = {
  airCallId: Scalars['Long']['input'];
  editedAuditSheet?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  overriddenScore?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEmailMeMaPageArgs = {
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  yearEmailMeMaPage?: InputMaybe<EmailMeMaPagePlanYear>;
};


export type MutationEmailMeMedigapPageArgs = {
  email: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationEnrollInTimeclockArgs = {
  agentId: Scalars['UUID']['input'];
  input: TimeclockAgentProfileInput;
};


export type MutationFixPunchCorrectionWithEditsArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  operations: Array<PunchEditOperationInput>;
  requestId: Scalars['UUID']['input'];
};


export type MutationGenerateFollowUpSweepArgs = {
  agents: Array<Scalars['String']['input']>;
};


export type MutationLinkAdviserWithClientArgs = {
  email: Scalars['String']['input'];
};


export type MutationLinkRosterPatientArgs = {
  clientId: Scalars['UUID']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationLoadScheduleRangeArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  end: Scalars['LocalDate']['input'];
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['LocalDate']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMarkAppointmentRequestAsDoneArgs = {
  appointmentRequestId: Scalars['UUID']['input'];
};


export type MutationMarkRequiredActionAsDoneArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationMergeClientsInOneGroupArgs = {
  clientIds: Array<Scalars['UUID']['input']>;
};


export type MutationMergeGroupsArgs = {
  groupIds: Array<Scalars['UUID']['input']>;
};


export type MutationMigrateEnrollmentsWithBrokenAgentArgs = {
  key: Scalars['String']['input'];
};


export type MutationMigrateY2YByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationOpenedScopeOfAppointmentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationOverrideLeadTransferCalledArgs = {
  calledOverride?: InputMaybe<Scalars['Boolean']['input']>;
  requestId: Scalars['UUID']['input'];
};


export type MutationPatchClientPersonalInfoArgs = {
  clientId: Scalars['UUID']['input'];
  drugDeliveryType?: InputMaybe<ClientDrugDeliveryType>;
  preferredDrugs?: InputMaybe<Array<PreferredDrugInput>>;
  preferredPharmacies?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPunchTimeclockArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  code: Scalars['String']['input'];
  exceptionReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPutTemporalDataArgs = {
  data: Scalars['String']['input'];
};


export type MutationReactivateChannelArgs = {
  channelId: Scalars['UUID']['input'];
};


export type MutationReactivateDepartmentArgs = {
  departmentId: Scalars['UUID']['input'];
};


export type MutationReactivateTimeclockProfileArgs = {
  agentId: Scalars['UUID']['input'];
};


export type MutationReassignTeamLeadArgs = {
  newLeadAgentId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationRecheckChannelSlackHealthArgs = {
  channelId: Scalars['UUID']['input'];
};


export type MutationRefreshDayPlanArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefreshPreCallBriefingArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationRejectManagerApprovalRequestArgs = {
  actionItemId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectRingMetricExceptionArgs = {
  exceptionId: Scalars['UUID']['input'];
  reviewNote: Scalars['String']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  agentId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationRenameCopilotConversationArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationRenameTeamArgs = {
  name: Scalars['String']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationReorderPayrollArgs = {
  agentIds: Array<Scalars['UUID']['input']>;
  departmentId: Scalars['UUID']['input'];
};


export type MutationReplyToManagerNoteArgs = {
  note: Scalars['String']['input'];
  noteId: Scalars['UUID']['input'];
};


export type MutationRequestCsrFollowUpArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationRequestLeadContactArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationRequestManagerApprovalArgs = {
  actionItemId: Scalars['UUID']['input'];
  photo?: InputMaybe<Scalars['Upload']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPunchCorrectionArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  agentId: Scalars['UUID']['input'];
  proposedEndTime: Scalars['String']['input'];
  proposedStartTime?: InputMaybe<Scalars['String']['input']>;
  punchIdsToRemove?: InputMaybe<Array<Scalars['UUID']['input']>>;
  reason: Scalars['String']['input'];
  workDate: Scalars['LocalDate']['input'];
};


export type MutationRequestPunchEditArgs = {
  agentId: Scalars['UUID']['input'];
  operations: Array<PunchEditOperationInput>;
  reason: Scalars['String']['input'];
  workDate: Scalars['LocalDate']['input'];
};


export type MutationRequestReconnectExcusalArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  clientId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRequestScheduleExceptionArgs = {
  agentId: Scalars['UUID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  reason: Scalars['String']['input'];
  requestType?: InputMaybe<Scalars['String']['input']>;
  requestedEndTime?: InputMaybe<Scalars['String']['input']>;
  slot?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  weekday?: InputMaybe<Scalars['Int']['input']>;
  workDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationRequestUrgentCallArgs = {
  urgentCallType: UrgentCallTypeDto;
};


export type MutationRerouteLeadTransferRequestArgs = {
  newChannelIds: Array<Scalars['UUID']['input']>;
  requestId: Scalars['UUID']['input'];
};


export type MutationResendLeadTransferRequestArgs = {
  expectedGeneration: Scalars['Int']['input'];
  requestId: Scalars['UUID']['input'];
};


export type MutationResetPasswordArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationResolveClientDocumentReviewArgs = {
  approve: Scalars['Boolean']['input'];
  documentId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveMissedLunchArgs = {
  agentId: Scalars['UUID']['input'];
  decision: Scalars['String']['input'];
  workDate: Scalars['LocalDate']['input'];
};


export type MutationRespondToCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  response: CalendarEventResponse;
};


export type MutationRetryClientPlatformSyncArgs = {
  clientId: Scalars['UUID']['input'];
  platform: SyncPlatform;
};


export type MutationRetrySlackInteractionArgs = {
  interactionId: Scalars['UUID']['input'];
};


export type MutationSaveActionItemArgs = {
  input: ActionItemInput;
};


export type MutationSaveAdvisorDetailsArgs = {
  input: AdvisorDetailsInput;
};


export type MutationSaveAgentArgs = {
  input: AgentInput;
};


export type MutationSaveAgentGmailCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationSaveAgentSlackCodeArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationSaveCallHistoryArgs = {
  input: CallHistoryInput;
};


export type MutationSaveChannelAttributionArgs = {
  clientId: Scalars['UUID']['input'];
  marketingCampaign?: InputMaybe<Scalars['String']['input']>;
  marketingSource?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveClientTagArgs = {
  input: ClientTagInput;
};


export type MutationSaveClientTrackingIdArgs = {
  input: ClientTrackingIdDtoInput;
};


export type MutationSaveClientWatchersArgs = {
  input: ClientWatcherInput;
};


export type MutationSaveCompareOfferHistoryItemArgs = {
  input: CompareOfferHistoryInput;
};


export type MutationSaveDisqualifiedReasonArgs = {
  disqualifiedReason: DisqualifiedReasonDto;
  id: Scalars['UUID']['input'];
};


export type MutationSaveEmailTemplateArgs = {
  emailTemplate: EmailTemplateDtoInput;
};


export type MutationSaveEnrollmentArgs = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  input: EnrollmentInput;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSaveExpectedCloseDateArgs = {
  expectedCloseDate: Scalars['LocalDate']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationSaveFlexpaTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationSaveManagerNoteArgs = {
  clientId: Scalars['UUID']['input'];
  managerNote: Scalars['String']['input'];
};


export type MutationSaveMedigapEnrollmentArgs = {
  input: MedigapEnrollmentInput;
};


export type MutationSavePdpEnrollmentArgs = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  input: PdpEnrollmentInput;
};


export type MutationSavePlatformCredentialsArgs = {
  input: PlatformCredentialsInput;
};


export type MutationSavePreferredContactMethodArgs = {
  clientId: Scalars['UUID']['input'];
  preferredContactMethod: PreferredContactMethodInput;
};


export type MutationSaveProductsClientAgreedToDiscussArgs = {
  clientId: Scalars['UUID']['input'];
  productsClientAgreedToDiscuss: ProductsClientAgreedToDiscussInput;
};


export type MutationSavePurchasedProductArgs = {
  input: PurchasedProductInput;
};


export type MutationSaveStatusArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  disqualifiedReason?: InputMaybe<DisqualifiedReasonDto>;
  excuseReason?: InputMaybe<Scalars['String']['input']>;
  followUpDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['UUID']['input'];
  status: StatusDto;
};


export type MutationSaveTagArgs = {
  input: TagInput;
};


export type MutationSaveUserProfileArgs = {
  input: UserProfileInput;
};


export type MutationScheduleAiCallArgs = {
  clientId: Scalars['UUID']['input'];
  scheduledFor: Scalars['Instant']['input'];
};


export type MutationScheduleAiCallsArgs = {
  clientIds: Array<Scalars['UUID']['input']>;
  scheduledFor: Scalars['Instant']['input'];
};


export type MutationSendClientSmsArgs = {
  body: Scalars['String']['input'];
  clientId: Scalars['UUID']['input'];
};


export type MutationSendComparisonEmailArgs = {
  clientId: Scalars['UUID']['input'];
  link: Scalars['String']['input'];
};


export type MutationSendCopilotMessageArgs = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  clientContext?: InputMaybe<CopilotClientContextInput>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  planPick?: InputMaybe<CopilotPlanPickInput>;
};


export type MutationSendGreetingArgs = {
  message: Scalars['String']['input'];
};


export type MutationSendY2YEmailArgs = {
  clientId: Scalars['UUID']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationSetAdminFlagForAllEnrollmentsByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetCalendlyAppointmentNoShowArgs = {
  id: Scalars['String']['input'];
  noShow: Scalars['Boolean']['input'];
};


export type MutationSetCanViewFloorArgs = {
  agentId: Scalars['UUID']['input'];
  canViewFloor: Scalars['Boolean']['input'];
};


export type MutationSetClientUserIdArgs = {
  clientId: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetDefaultAgentArgs = {
  agentId: Scalars['UUID']['input'];
};


export type MutationSetDontDisturbArgs = {
  dontDisturb: Scalars['Boolean']['input'];
};


export type MutationSetFallbackChannelArgs = {
  channelId: Scalars['UUID']['input'];
};


export type MutationSetHealthInformationDisclosureCheckArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetLeadPriorityArgs = {
  clientId: Scalars['UUID']['input'];
  priority: Scalars['Boolean']['input'];
};


export type MutationSetNewPasswordArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationSetOwnHealthcareDecisionCheckArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetPlatformSyncEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  platform: SyncPlatform;
};


export type MutationSetRecordedLineAgreementCheckArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetSoaAgreementCheckArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetScheduleDayArgs = {
  agentId: Scalars['UUID']['input'];
  applyToUpcomingDays?: InputMaybe<Scalars['Boolean']['input']>;
  breakMinutes?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  effectiveFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  weekday?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetScheduleSegmentArgs = {
  agentId: Scalars['UUID']['input'];
  code: Scalars['String']['input'];
  durationMinutes: Scalars['Int']['input'];
  slot?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['String']['input'];
  weekday?: InputMaybe<Scalars['Int']['input']>;
  workDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationSetTpmoAgreementCheckArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetUrgentCallRequestedArgs = {
  clientId: Scalars['UUID']['input'];
  urgentCallRequested: Scalars['Boolean']['input'];
};


export type MutationStartAiCallArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationStartAgentRawDigitsMigrationArgs = {
  key: Scalars['String']['input'];
};


export type MutationStartTestCallFor30SecondsArgs = {
  agentId: Scalars['UUID']['input'];
  airCallId?: InputMaybe<Scalars['Long']['input']>;
  clientId: Scalars['UUID']['input'];
};


export type MutationStopAgentRawDigitsMigrationArgs = {
  key: Scalars['String']['input'];
};


export type MutationSubmitClientAdminPhotoVerificationArgs = {
  actionItemId: Scalars['UUID']['input'];
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  photo: Scalars['Upload']['input'];
};


export type MutationSubmitLeadTransferNoteArgs = {
  input: SubmitLeadTransferNoteInput;
};


export type MutationSubmitLeadUpdateArgs = {
  clientId: Scalars['UUID']['input'];
  code: LeadUpdateCode;
  disqualifiedReason?: InputMaybe<DisqualifiedReasonDto>;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncClientEmailsArgs = {
  clientId: Scalars['UUID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncGmailMessagesArgs = {
  code: Scalars['String']['input'];
};


export type MutationSyncHawksoftArgs = {
  secret: Scalars['String']['input'];
};


export type MutationUnclaimLeadTransferRequestArgs = {
  expectedGeneration: Scalars['Int']['input'];
  requestId: Scalars['UUID']['input'];
};


export type MutationUnlinkRosterPatientArgs = {
  patientId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationUpdateCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  input: UpdateCalendarEventInput;
};


export type MutationUpdateCallingHoursArgs = {
  hours: CallingHoursInput;
};


export type MutationUpdateChannelArgs = {
  channelId: Scalars['UUID']['input'];
  input: ChannelInput;
};


export type MutationUpdateClientNoteArgs = {
  note: Scalars['String']['input'];
  noteId: Scalars['UUID']['input'];
};


export type MutationUpdateDepartmentArgs = {
  departmentId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  payrollExport?: InputMaybe<Scalars['Boolean']['input']>;
  unpaidAfterHours?: InputMaybe<Scalars['BigDecimal']['input']>;
};


export type MutationUpdateMyDisplayTimezoneArgs = {
  timezone: Scalars['String']['input'];
};


export type MutationUpdateNewLeadOutreachDelayMinutesArgs = {
  delayMinutes: Scalars['Int']['input'];
};


export type MutationUpdateNewLeadOutreachEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateNewLeadSmsDelayMinutesArgs = {
  delayMinutes: Scalars['Int']['input'];
};


export type MutationUpdateOfflineConversionSyncProcessArgs = {
  input: OfflineConversionSyncProcessUpdateInput;
};


export type MutationUpdateRrStatusArgs = {
  enabled: Scalars['Boolean']['input'];
  secret: Scalars['String']['input'];
};


export type MutationUpdateSendInBlueByEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateSmsOutreachEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateSourcesArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationUpdateTimeclockProfileArgs = {
  agentId: Scalars['UUID']['input'];
  input: TimeclockAgentProfileInput;
};


export type MutationUpdateVoiceAiExcludedTagIdsArgs = {
  tagIds: Array<Scalars['UUID']['input']>;
};


export type MutationUpdatedUserProfileByAdvisorArgs = {
  clientId: Scalars['UUID']['input'];
  input: UserProfileInputForAdviserInput;
};


export type MutationUploadAgentAvatarArgs = {
  img: Scalars['Upload']['input'];
};


export type MutationUploadClientDocumentArgs = {
  clientId: Scalars['UUID']['input'];
  documentType: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationUploadFollowUpSweepArgs = {
  sourceUri: Scalars['String']['input'];
  xlsxBase64: Scalars['String']['input'];
};


export type MutationVerifyRosterPatientArgs = {
  birthDate: Scalars['LocalDate']['input'];
  patientId: Scalars['String']['input'];
};

export type MyHoursExportOutput = {
  __typename?: 'MyHoursExportOutput';
  filename: Scalars['String']['output'];
  html: Scalars['String']['output'];
  label: Scalars['String']['output'];
  pasteAt: Scalars['String']['output'];
  totalPaidHours: Scalars['BigDecimal']['output'];
  totalScheduledHours: Scalars['BigDecimal']['output'];
  tsv: Scalars['String']['output'];
  xlsxBase64: Scalars['String']['output'];
};

export type MyHoursTotalsOutput = {
  __typename?: 'MyHoursTotalsOutput';
  totalBreakHours: Scalars['BigDecimal']['output'];
  totalLunchHours: Scalars['BigDecimal']['output'];
  totalPaidHours: Scalars['BigDecimal']['output'];
  totalScheduledHours: Scalars['BigDecimal']['output'];
};

export type NetworkInfoViewOutput = {
  __typename?: 'NetworkInfoViewOutput';
  carrierName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NewLeadsStatisticsOutput = {
  __typename?: 'NewLeadsStatisticsOutput';
  count: Scalars['Int']['output'];
  nerdWalletCount: Scalars['Int']['output'];
  oldestCreatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type OfflineConversionSyncProcessCreateInput = {
  clientId: Scalars['UUID']['input'];
  conversionTime: Scalars['Instant']['input'];
  eventName: EventName;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  oppref?: InputMaybe<Scalars['String']['input']>;
  platform: Platform;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type OfflineConversionSyncProcessFilterInput = {
  createdAtFrom?: InputMaybe<Scalars['Instant']['input']>;
  createdAtTo?: InputMaybe<Scalars['Instant']['input']>;
  eventName?: InputMaybe<EventName>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Platform>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfflineConversionSyncProcessOutput = {
  __typename?: 'OfflineConversionSyncProcessOutput';
  cId?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  conversionTime: Scalars['Instant']['output'];
  createdAt: Scalars['Instant']['output'];
  errorMsg?: Maybe<Scalars['String']['output']>;
  eventName: EventName;
  fbclid?: Maybe<Scalars['String']['output']>;
  gbraid?: Maybe<Scalars['String']['output']>;
  gclid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  msclkid?: Maybe<Scalars['String']['output']>;
  oppref?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  synced: Scalars['Boolean']['output'];
  uId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Instant']['output'];
  utmBrand?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
  version: Scalars['Long']['output'];
  wbraid?: Maybe<Scalars['String']['output']>;
};

export type OfflineConversionSyncProcessUpdateInput = {
  eventName?: InputMaybe<EventName>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  msclkid?: InputMaybe<Scalars['String']['input']>;
  oppref?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Platform>;
  utmBrand?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type OverdueItemOutput = {
  __typename?: 'OverdueItemOutput';
  clientId: Scalars['UUID']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  expectedCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  followUpDate?: Maybe<Scalars['LocalDate']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type PageInput = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type PageableActionItemOutput = {
  __typename?: 'PageableActionItemOutput';
  data: Array<ActionItemOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableAgentOutput = {
  __typename?: 'PageableAgentOutput';
  data: Array<AgentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableAttemptedLeadOutput = {
  __typename?: 'PageableAttemptedLeadOutput';
  data: Array<AttemptedLeadOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableCalendlyAppointmentsOutput = {
  __typename?: 'PageableCalendlyAppointmentsOutput';
  data: Array<AppointmentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableCallHistoryOutput = {
  __typename?: 'PageableCallHistoryOutput';
  data: Array<CallHistoryOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableClientSmsOutput = {
  __typename?: 'PageableClientSmsOutput';
  data: Array<ClientSmsOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableClientViewForAdviserOutput = {
  __typename?: 'PageableClientViewForAdviserOutput';
  data: Array<ClientViewForAdviserOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableClientViewListRepresentationOutput = {
  __typename?: 'PageableClientViewListRepresentationOutput';
  data: Array<ClientViewListRepresentationOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableEmailTemplateOutput = {
  __typename?: 'PageableEmailTemplateOutput';
  data: Array<EmailTemplateDto>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableEnrollmentListItemOutput = {
  __typename?: 'PageableEnrollmentListItemOutput';
  data: Array<EnrollmentListItemOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableEnrollmentOutput = {
  __typename?: 'PageableEnrollmentOutput';
  data: Array<EnrollmentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableMedigapEnrollmentOutput = {
  __typename?: 'PageableMedigapEnrollmentOutput';
  data: Array<MedigapEnrollmentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableOfflineConversionSyncProcessOutput = {
  __typename?: 'PageableOfflineConversionSyncProcessOutput';
  data: Array<OfflineConversionSyncProcessOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageablePdpEnrollmentOutput = {
  __typename?: 'PageablePdpEnrollmentOutput';
  data: Array<PdpEnrollmentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableQaAuditOutput = {
  __typename?: 'PageableQaAuditOutput';
  data: Array<QaCallRowOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableSlaOutput = {
  __typename?: 'PageableSLAOutput';
  data: Array<SlaOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableUserProfileOutput = {
  __typename?: 'PageableUserProfileOutput';
  data: Array<UserProfileOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PartnerApiUsageDto = {
  __typename?: 'PartnerAPIUsageDto';
  lastCreatedAt?: Maybe<Scalars['Instant']['output']>;
  totalCount: Scalars['Long']['output'];
};

export enum PartnerResolution {
  Organic = 'ORGANIC',
  Partner = 'PARTNER',
  Unresolved = 'UNRESOLVED'
}

export type PartnersApiUsageResult = {
  __typename?: 'PartnersAPIUsageResult';
  alpineDigitalGroup: PartnerApiUsageDto;
  leadEconomy: PartnerApiUsageDto;
  quinStreet: PartnerApiUsageDto;
  revriseMedia: PartnerApiUsageDto;
};

export type PayrollExportOutput = {
  __typename?: 'PayrollExportOutput';
  agentCount: Scalars['Int']['output'];
  dayCount: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  html: Scalars['String']['output'];
  label: Scalars['String']['output'];
  pasteAt: Scalars['String']['output'];
  pendingRequestCount: Scalars['Int']['output'];
  tsv: Scalars['String']['output'];
  xlsxBase64: Scalars['String']['output'];
};

export type PcpInfoViewOutput = {
  __typename?: 'PcpInfoViewOutput';
  id?: Maybe<Scalars['UUID']['output']>;
  networkDetails: Array<NetworkInfoViewOutput>;
  pcpId: Scalars['String']['output'];
};

export type PdpEnrollmentInput = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  applicationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  cId?: InputMaybe<Scalars['String']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentType?: InputMaybe<PdpEnrollmentType>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  insulinSavings?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  planName?: InputMaybe<Scalars['String']['input']>;
  planYear?: InputMaybe<PlanYear>;
  started?: InputMaybe<Scalars['Instant']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PdpEnrollmentOutput = {
  __typename?: 'PdpEnrollmentOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  applicationDate?: Maybe<Scalars['LocalDate']['output']>;
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  county?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<PdpEnrollmentType>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  insulinSavings?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planId: Scalars['String']['output'];
  planName?: Maybe<Scalars['String']['output']>;
  planYear?: Maybe<PlanYear>;
  started?: Maybe<Scalars['Instant']['output']>;
  status: PdpEnrollmentStatus;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum PdpEnrollmentStatus {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum PdpEnrollmentType {
  PdpNew = 'PDP_NEW',
  PdpReplacement = 'PDP_REPLACEMENT',
  PdpUnlikeChange = 'PDP_UNLIKE_CHANGE'
}

export type PdpEnrollmentViewOutput = {
  __typename?: 'PdpEnrollmentViewOutput';
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  createdAt: Scalars['Instant']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  insulinSavings?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planId: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type PdpFilterInput = {
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PdpQuoteOutput = {
  __typename?: 'PdpQuoteOutput';
  cId?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['UUID']['output'];
  insulinSavings?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Instant']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum PersonalField {
  DateOfBirth = 'DATE_OF_BIRTH',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Mbi = 'MBI',
  PartAEffectiveDate = 'PART_A_EFFECTIVE_DATE',
  PartBEffectiveDate = 'PART_B_EFFECTIVE_DATE',
  Phone = 'PHONE',
  Zip = 'ZIP'
}

export enum PersonalFieldSyncStatus {
  Failed = 'FAILED',
  KeptAgentValue = 'KEPT_AGENT_VALUE',
  Synced = 'SYNCED'
}

export type PersonalInfoFieldSyncOutput = {
  __typename?: 'PersonalInfoFieldSyncOutput';
  field: PersonalField;
  label: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: PersonalFieldSyncStatus;
};

export type PersonalInfoPlatformSyncOutput = {
  __typename?: 'PersonalInfoPlatformSyncOutput';
  fields: Array<PersonalInfoFieldSyncOutput>;
  message: Scalars['String']['output'];
  nextSyncAt?: Maybe<Scalars['Instant']['output']>;
  platform: SyncPlatform;
  status: DrugPlatformSyncStatus;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type PipelineBarOutput = {
  __typename?: 'PipelineBarOutput';
  cohorts: Array<PipelineSegmentOutput>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  segments: Array<PipelineSegmentOutput>;
  total: Scalars['Int']['output'];
};

export type PipelineClientFilterOutput = {
  __typename?: 'PipelineClientFilterOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Always null now; Submitted Apps uses enrolledByAgentId + enrollmentDate */
  applicationSubmitted?: Maybe<PipelineDateRangeOutput>;
  enrolledByAgentId?: Maybe<Scalars['UUID']['output']>;
  enrollmentDate?: Maybe<PipelineDateRangeOutput>;
  excludedTags: Array<Scalars['UUID']['output']>;
  followUpDate?: Maybe<PipelineDateRangeOutput>;
  range?: Maybe<PipelineDateRangeOutput>;
  statuses: Array<StatusDto>;
};

export type PipelineCohortLabelOutput = {
  __typename?: 'PipelineCohortLabelOutput';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type PipelineDateRangeOutput = {
  __typename?: 'PipelineDateRangeOutput';
  from: Scalars['Instant']['output'];
  to: Scalars['Instant']['output'];
};

export type PipelineOverviewOutput = {
  __typename?: 'PipelineOverviewOutput';
  agentId: Scalars['UUID']['output'];
  asOfDate: Scalars['LocalDate']['output'];
  bars: Array<PipelineBarOutput>;
  cohortKeys: Array<PipelineCohortLabelOutput>;
};

export type PipelineSegmentOutput = {
  __typename?: 'PipelineSegmentOutput';
  count: Scalars['Int']['output'];
  filter: PipelineClientFilterOutput;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type PlanSectionOutput = {
  __typename?: 'PlanSectionOutput';
  planId: Scalars['UUID']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  targetDate: Scalars['LocalDate']['output'];
  tasks: Array<PlanTaskOutput>;
};

export type PlanTaskOutput = {
  __typename?: 'PlanTaskOutput';
  actionItemId?: Maybe<Scalars['UUID']['output']>;
  actionVerb?: Maybe<Scalars['String']['output']>;
  airCallId?: Maybe<Scalars['Long']['output']>;
  calendarEventId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  done: Scalars['Boolean']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  floating: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  ordinal: Scalars['Int']['output'];
  reasonText?: Maybe<Scalars['String']['output']>;
  sla?: Maybe<Scalars['String']['output']>;
  slotEnd?: Maybe<Scalars['String']['output']>;
  slotStart?: Maybe<Scalars['String']['output']>;
  taskType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum PlanYear {
  Year2021 = 'Year2021',
  Year2022 = 'Year2022',
  Year2023 = 'Year2023',
  Year2024 = 'Year2024',
  Year2025 = 'Year2025',
  Year2026 = 'Year2026',
  Year2027 = 'Year2027'
}

export enum Platform {
  GoogleCaliburn = 'GOOGLE_CALIBURN',
  GoogleCoverright = 'GOOGLE_COVERRIGHT',
  MetaCoverright = 'META_COVERRIGHT',
  MicrosoftCaliburn = 'MICROSOFT_CALIBURN',
  MicrosoftCoverright = 'MICROSOFT_COVERRIGHT',
  OpenaiCoverright = 'OPENAI_COVERRIGHT',
  PendingAttribution = 'PENDING_ATTRIBUTION'
}

export type PlatformCredentialsInput = {
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
  platform: SyncPlatform;
};

export type PlatformCredentialsOutput = {
  __typename?: 'PlatformCredentialsOutput';
  checkedAt?: Maybe<Scalars['Instant']['output']>;
  login: Scalars['String']['output'];
  nextCheckAt?: Maybe<Scalars['Instant']['output']>;
  platform: SyncPlatform;
  status: PlatformCredentialsStatus;
  statusMessage?: Maybe<Scalars['String']['output']>;
  syncEnabled: Scalars['Boolean']['output'];
};

export enum PlatformCredentialsStatus {
  Checking = 'CHECKING',
  Invalid = 'INVALID',
  Unchecked = 'UNCHECKED',
  Unreachable = 'UNREACHABLE',
  Valid = 'VALID'
}

export type PlatformDrugIssueOutput = {
  __typename?: 'PlatformDrugIssueOutput';
  detail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  rxcui?: Maybe<Scalars['String']['output']>;
};

export type PlatformDrugOptionInput = {
  dose?: InputMaybe<Scalars['String']['input']>;
  drug: Scalars['String']['input'];
  packageText?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformDrugOptionOutput = {
  __typename?: 'PlatformDrugOptionOutput';
  dose?: Maybe<Scalars['String']['output']>;
  drug: Scalars['String']['output'];
  packageText?: Maybe<Scalars['String']['output']>;
};

export type PlatformDrugsSyncOutput = {
  __typename?: 'PlatformDrugsSyncOutput';
  failed: Array<PlatformDrugIssueOutput>;
  integrityDrugRows: Array<Scalars['String']['output']>;
  state: PlatformSyncScenarioOutput;
  synced: Array<PlatformSyncedDrugOutput>;
  warnings: Array<PlatformDrugIssueOutput>;
};

export type PlatformSyncScenarioOutput = {
  __typename?: 'PlatformSyncScenarioOutput';
  finishedAt?: Maybe<Scalars['Instant']['output']>;
  lastChangedAt: Scalars['Instant']['output'];
  message?: Maybe<Scalars['String']['output']>;
  nextAttemptAt?: Maybe<Scalars['Instant']['output']>;
  startedAt?: Maybe<Scalars['Instant']['output']>;
  status: PlatformSyncStatus;
};

export enum PlatformSyncStatus {
  Failed = 'FAILED',
  NotRunning = 'NOT_RUNNING',
  Partial = 'PARTIAL',
  Process = 'PROCESS',
  Successful = 'SUCCESSFUL'
}

export type PlatformSyncedDrugOutput = {
  __typename?: 'PlatformSyncedDrugOutput';
  alreadyPresent: Scalars['Boolean']['output'];
  integrityDrug: Scalars['String']['output'];
  integrityPackage?: Maybe<Scalars['String']['output']>;
  integrityQuantity?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rxcui?: Maybe<Scalars['String']['output']>;
};

export type PreCallBriefingOutput = {
  __typename?: 'PreCallBriefingOutput';
  briefJson?: Maybe<Scalars['String']['output']>;
  callSummaries?: Maybe<Array<Scalars['String']['output']>>;
  context?: Maybe<Array<Scalars['String']['output']>>;
  emailsSummary?: Maybe<Array<Scalars['String']['output']>>;
  notesSummary?: Maybe<Array<Scalars['String']['output']>>;
  talkingPoints?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type PreferredContactMethodInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PreferredDrugInput = {
  dosageRxcui: Scalars['String']['input'];
  frequency: CalcDrugFrequencyPeriodInput;
  productRxcui: Scalars['String']['input'];
  purchaseFrequency: FrequencyPeriodInput;
  quantity: Scalars['BigDecimal']['input'];
};

export type PreferredDrugViewOutput = {
  __typename?: 'PreferredDrugViewOutput';
  dosageRxcui: Scalars['String']['output'];
  frequency: CalcDrugFrequencyPeriodViewOutput;
  platformSyncs: Array<DrugPlatformSyncOutput>;
  productRxcui: Scalars['String']['output'];
  purchaseFrequency: FrequencyPeriodViewOutput;
  quantity: Scalars['BigDecimal']['output'];
};

export enum PreferredLanguageDto {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  Spanish = 'SPANISH',
  Vietnamese = 'VIETNAMESE'
}

export type PriorityPoolNextTierOutput = {
  __typename?: 'PriorityPoolNextTierOutput';
  closesNeeded: Scalars['Int']['output'];
  minCount: Scalars['Int']['output'];
  payoutUsd: Scalars['Int']['output'];
};

export type PriorityPoolTagOutput = {
  __typename?: 'PriorityPoolTagOutput';
  category?: Maybe<Scalars['String']['output']>;
  partnerTag: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PriorityPoolTierOutput = {
  __typename?: 'PriorityPoolTierOutput';
  minCount: Scalars['Int']['output'];
  totalPayoutUsd: Scalars['Int']['output'];
};

export type ProductsClientAgreedToDiscussInput = {
  dentalAndOrVisionPlans?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalIndemnityPlans?: InputMaybe<Scalars['Boolean']['input']>;
  medicareAdvantagePlans?: InputMaybe<Scalars['Boolean']['input']>;
  medicareAdvantagePrescriptionDrugPlans?: InputMaybe<Scalars['Boolean']['input']>;
  medicareSupplementInsurancePlans?: InputMaybe<Scalars['Boolean']['input']>;
  optionalSupplementalBenefits?: InputMaybe<Scalars['Boolean']['input']>;
  standAlonePrescriptionDrugPlans?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductsClientAgreedToDiscussOutput = {
  __typename?: 'ProductsClientAgreedToDiscussOutput';
  dentalAndOrVisionPlans?: Maybe<Scalars['Boolean']['output']>;
  hospitalIndemnityPlans?: Maybe<Scalars['Boolean']['output']>;
  medicareAdvantagePlans?: Maybe<Scalars['Boolean']['output']>;
  medicareAdvantagePrescriptionDrugPlans?: Maybe<Scalars['Boolean']['output']>;
  medicareSupplementInsurancePlans?: Maybe<Scalars['Boolean']['output']>;
  optionalSupplementalBenefits?: Maybe<Scalars['Boolean']['output']>;
  standAlonePrescriptionDrugPlans?: Maybe<Scalars['Boolean']['output']>;
};

export type ProfileAttributeInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum ProfileOption {
  CreateEnrollment = 'CREATE_ENROLLMENT',
  RegisterUser = 'REGISTER_USER',
  RequestCall = 'REQUEST_CALL',
  SetAttributes = 'SET_ATTRIBUTES',
  UnsupportedZip = 'UNSUPPORTED_ZIP'
}

export enum ProfileSource {
  AgentIntake = 'AGENT_INTAKE',
  ApplicationOnboarding = 'APPLICATION_ONBOARDING',
  B2B = 'B2B',
  BlueInk = 'BLUE_INK',
  CallRequest = 'CALL_REQUEST',
  DrugOptimizer = 'DRUG_OPTIMIZER',
  EnrollmentForm = 'ENROLLMENT_FORM',
  FinancialAdvisor = 'FINANCIAL_ADVISOR',
  ForbesOnboarding = 'FORBES_ONBOARDING',
  MaMarketplace = 'MA_MARKETPLACE',
  MedicarecOnboarding = 'MEDICAREC_ONBOARDING',
  MgMarketplace = 'MG_MARKETPLACE',
  OutOfService = 'OUT_OF_SERVICE',
  PdpMarketplace = 'PDP_MARKETPLACE',
  RenegadeOnboarding = 'RENEGADE_ONBOARDING',
  ScheduleOnboarding = 'SCHEDULE_ONBOARDING',
  ShortForm = 'SHORT_FORM',
  UhcOnboarding = 'UHC_ONBOARDING',
  UserFlowV1 = 'USER_FLOW_V1',
  UserFlowV1_5 = 'USER_FLOW_V1_5',
  UserFlowV2 = 'USER_FLOW_V2'
}

export type ProgressOutput = {
  __typename?: 'ProgressOutput';
  clientId?: Maybe<Scalars['UUID']['output']>;
  done: Scalars['Boolean']['output'];
  feature: Scalars['String']['output'];
  phase: Scalars['String']['output'];
  phaseLabel: Scalars['String']['output'];
  phaseOrdinal: Scalars['Int']['output'];
  phaseTotal: Scalars['Int']['output'];
};

export type PunchCorrectionRequestOperationOutput = {
  __typename?: 'PunchCorrectionRequestOperationOutput';
  id: Scalars['UUID']['output'];
  operation: Scalars['String']['output'];
  proposedCode?: Maybe<Scalars['String']['output']>;
  proposedPunchedAt: Scalars['Instant']['output'];
  resultingPunchId?: Maybe<Scalars['UUID']['output']>;
  targetPunchId?: Maybe<Scalars['UUID']['output']>;
};

export type PunchCorrectionRequestOutput = {
  __typename?: 'PunchCorrectionRequestOutput';
  action: Scalars['String']['output'];
  agentFirstName: Scalars['String']['output'];
  agentId: Scalars['UUID']['output'];
  agentLastName: Scalars['String']['output'];
  canDecide: Scalars['Boolean']['output'];
  dayPunches?: Maybe<Array<PunchOutput>>;
  decidedAt?: Maybe<Scalars['Instant']['output']>;
  decidedBy?: Maybe<Scalars['UUID']['output']>;
  decisionNote?: Maybe<Scalars['String']['output']>;
  flags: Array<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  operations: Array<PunchCorrectionRequestOperationOutput>;
  proposedEndAt?: Maybe<Scalars['Instant']['output']>;
  proposedStartAt?: Maybe<Scalars['Instant']['output']>;
  punchIdsToRemove: Array<Scalars['UUID']['output']>;
  reason: Scalars['String']['output'];
  requestedAt: Scalars['Instant']['output'];
  requestedBy: Scalars['UUID']['output'];
  requestedByFirstName: Scalars['String']['output'];
  requestedByLastName: Scalars['String']['output'];
  resultingEndPunchId?: Maybe<Scalars['UUID']['output']>;
  resultingStartPunchId?: Maybe<Scalars['UUID']['output']>;
  status: Scalars['String']['output'];
  timezoneAtRequest: Scalars['String']['output'];
  validationWarning?: Maybe<Scalars['String']['output']>;
  workDate: Scalars['LocalDate']['output'];
};

export type PunchEditDayOutput = {
  __typename?: 'PunchEditDayOutput';
  punches: Array<PunchOutput>;
  timezone: Scalars['String']['output'];
};

export type PunchEditOperationInput = {
  operation: Scalars['String']['input'];
  proposedCode?: InputMaybe<Scalars['String']['input']>;
  proposedTime?: InputMaybe<Scalars['String']['input']>;
  targetPunchId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PunchEditPreviewDayEntryOutput = {
  __typename?: 'PunchEditPreviewDayEntryOutput';
  changeKind: Scalars['String']['output'];
  code: Scalars['String']['output'];
  previousCode?: Maybe<Scalars['String']['output']>;
  previousPunchedAt?: Maybe<Scalars['Instant']['output']>;
  punchId?: Maybe<Scalars['UUID']['output']>;
  punchedAt: Scalars['Instant']['output'];
};

export type PunchEditPreviewOutput = {
  __typename?: 'PunchEditPreviewOutput';
  after: Array<PunchEditPreviewDayEntryOutput>;
  before: Array<PunchEditPreviewDayEntryOutput>;
  needsLunchReviewAfter: Scalars['Boolean']['output'];
  needsLunchReviewBefore: Scalars['Boolean']['output'];
  paidHoursAfter?: Maybe<Scalars['BigDecimal']['output']>;
  paidHoursBefore?: Maybe<Scalars['BigDecimal']['output']>;
  timezone: Scalars['String']['output'];
  utcOffset: Scalars['String']['output'];
  workDate: Scalars['LocalDate']['output'];
};

export type PunchOutput = {
  __typename?: 'PunchOutput';
  agentId: Scalars['UUID']['output'];
  code: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isException: Scalars['Boolean']['output'];
  punchedAt: Scalars['Instant']['output'];
};

export type PurchasedProductInput = {
  clientId: Scalars['UUID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isPrimaryPerson: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  type: CoverRightProductDto;
};

export type PurchasedProductOutput = {
  __typename?: 'PurchasedProductOutput';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isPrimaryPerson: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  type: CoverRightProductDto;
};

export type QaCallRowOutput = {
  __typename?: 'QaCallRowOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  airCallId: Scalars['Long']['output'];
  callDate?: Maybe<Scalars['Instant']['output']>;
  clientId: Scalars['UUID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  dispositionClass: Scalars['String']['output'];
  effectiveScore?: Maybe<Scalars['Int']['output']>;
  isEnrollmentCall: Scalars['Boolean']['output'];
  wasOverridden: Scalars['Boolean']['output'];
};

export type QaCategoryDeltaOutput = {
  __typename?: 'QaCategoryDeltaOutput';
  category: Scalars['String']['output'];
  delta: Scalars['Int']['output'];
  groupA: Scalars['Int']['output'];
  groupB: Scalars['Int']['output'];
};

export type QaCategoryStatOutput = {
  __typename?: 'QaCategoryStatOutput';
  callsApplicable: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  pointsLost: Scalars['Int']['output'];
};

export type QaCompareGroupInput = {
  agentIds: Array<Scalars['UUID']['input']>;
  label: Scalars['String']['input'];
};

export type QaCompareGroupOutput = {
  __typename?: 'QaCompareGroupOutput';
  label: Scalars['String']['output'];
  report: AgentQaReportOutput;
};

export type QaCompareOutput = {
  __typename?: 'QaCompareOutput';
  comparison?: Maybe<QaComparisonOutput>;
  groups: Array<QaCompareGroupOutput>;
};

export type QaComparisonOutput = {
  __typename?: 'QaComparisonOutput';
  categoryDeltas: Array<QaCategoryDeltaOutput>;
  questionDeltas: Array<QaQuestionDeltaOutput>;
  scoreDelta: Scalars['Float']['output'];
};

export type QaQuestionDeltaOutput = {
  __typename?: 'QaQuestionDeltaOutput';
  delta: Scalars['Float']['output'];
  groupAFailRate: Scalars['Float']['output'];
  groupBFailRate: Scalars['Float']['output'];
  questionId: Scalars['String']['output'];
};

export type QaQuestionOutput = {
  __typename?: 'QaQuestionOutput';
  answer: Scalars['String']['output'];
  category: Scalars['String']['output'];
  deductionApplied: Scalars['Int']['output'];
  evidence?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maxDeduction: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  sourceAirCallId?: Maybe<Scalars['String']['output']>;
};

export type QaQuestionPerAgentOutput = {
  __typename?: 'QaQuestionPerAgentOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  failRate: Scalars['Float']['output'];
};

export type QaQuestionPerformanceOutput = {
  __typename?: 'QaQuestionPerformanceOutput';
  excludedNA: Scalars['Int']['output'];
  failRate: Scalars['Float']['output'];
  perAgent: Array<QaQuestionPerAgentOutput>;
  pointsLost: Scalars['Int']['output'];
  questionId: Scalars['String']['output'];
  totalApplicable: Scalars['Int']['output'];
  trend: Array<QaTrendPointOutput>;
};

export type QaQuestionStatOutput = {
  __typename?: 'QaQuestionStatOutput';
  applicableCount: Scalars['Int']['output'];
  failCount: Scalars['Int']['output'];
  failRate: Scalars['Float']['output'];
  question: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export type QaSummaryOutput = {
  __typename?: 'QaSummaryOutput';
  averageScore: Scalars['Float']['output'];
  bestScore?: Maybe<Scalars['Int']['output']>;
  callsScored: Scalars['Int']['output'];
  enrollmentCalls: Scalars['Int']['output'];
  trend: Array<QaTrendPointOutput>;
  worstScore?: Maybe<Scalars['Int']['output']>;
};

export type QaTrendPointOutput = {
  __typename?: 'QaTrendPointOutput';
  averageScore: Scalars['Float']['output'];
  callsScored: Scalars['Int']['output'];
  periodStart: Scalars['Instant']['output'];
};

export type Query = {
  __typename?: 'Query';
  actionItem: ActionItemOutput;
  actionItems: PageableActionItemOutput;
  actionItemsByClientId: Array<ActionItemOutput>;
  activeAppointmentRequestByClientId?: Maybe<AppointmentRequestOutput>;
  activeAppointmentRequests: Array<AppointmentRequestOutput>;
  advisorDetails?: Maybe<AdvisorDetailsOutput>;
  affiliationPartnerships: Array<AffiliationPartnershipOutput>;
  agentAssignedToClient: AgentViewOutput;
  agentAvailabilityInsights: SchedulingInsightsOutput;
  agentByContext: AgentOutput;
  agentById: AgentOutput;
  agentCurrentClientsMetrics: Array<AgentCurrentClientsMetricsOutput>;
  agentGmailAuthUrl: Scalars['String']['output'];
  agentGmailMessages: AgentEmailPageOutput;
  agentPerformanceAnalytics: Array<AgentPerformanceMetricOutput>;
  agentRankingsLeaderboard: Array<AgentRankingLeaderboardOutput>;
  agentSlackAuthUrl: Scalars['String']['output'];
  agentWorkingHours: Array<AgentWorkingHoursOutput>;
  agents: PageableAgentOutput;
  allEnrollments: PageableEnrollmentListItemOutput;
  assignmentHistory: Array<AssignmentHistoryOutput>;
  attemptedLeads: PageableAttemptedLeadOutput;
  availableAgents: Array<AgentViewOutput>;
  calendarEvent: CalendarEventOutput;
  calendarEvents: CalendarEventsOutput;
  calendarFreeBusy: Array<FreeBusyOutput>;
  calendlyAppointmentsByAgent: PageableCalendlyAppointmentsOutput;
  calendlyInvitee: InviteePersonalInfoOutput;
  callHistoryAIAnalysis?: Maybe<CallHistoryAiAnalysisOutput>;
  callHistoryAIAnalysisByClient: Array<CallHistoryAiAnalysisOutput>;
  callHistoryByAirCallId?: Maybe<CallHistoryOutput>;
  callHistoryItems: PageableCallHistoryOutput;
  callbacksForDay: CallbackDayOutput;
  callingHours: CallingHours;
  channel: ChannelOutput;
  channels: Array<ChannelOutput>;
  checkUserExistenceByEmail: Scalars['Boolean']['output'];
  claimAttemptReport: ClaimAttemptEventPageOutput;
  clientAttributeHistory: Array<ClientAttributeChange>;
  clientCalendlyAppointments: Array<AppointmentOutput>;
  clientDeclinableDrugAnswers: Array<DeclinableDrugAnswerViewOutput>;
  clientDocumentPreview: ClientDocumentPreviewOutput;
  clientDocumentReviewQueue: Array<ClientDocumentOutput>;
  clientDocuments: Array<ClientDocumentOutput>;
  clientGroupByClientId?: Maybe<ClientGroupOutput>;
  clientIdByProfileId: Scalars['UUID']['output'];
  clientLeadSources: Array<LeadSourceOutput>;
  clientMedigapEnrollments: Array<MedigapEnrollmentOutput>;
  clientPdpEnrollments: Array<PdpEnrollmentOutput>;
  clientPlatformSync?: Maybe<ClientPlatformSyncOutput>;
  clientSmsMessages: PageableClientSmsOutput;
  clientUnderwritingAnswers: Array<UnderwritingAnswerViewOutput>;
  clientUnderwritingNotes: Array<UnderwritingClientNoteViewOutput>;
  clientViewById?: Maybe<ClientViewOutput>;
  clientViewByPin?: Maybe<ClientViewOutput>;
  clientViewCounters: ClientViewCountersOutput;
  clientViewForAdviser?: Maybe<ClientViewForAdviserOutput>;
  clientViews: PageableClientViewListRepresentationOutput;
  clientViewsForAdviser: PageableClientViewForAdviserOutput;
  compareOfferHistory: Array<CompareOfferHistoryOutput>;
  contacted: PageableClientViewListRepresentationOutput;
  continueDrugCostActivationLinkSyncCustomerIo: Scalars['Boolean']['output'];
  continueSyncCustomerIo: Scalars['Boolean']['output'];
  copilotConversation: CopilotConversationDetailOutput;
  correctTimesRequestsForReview: Array<CorrectTimesReviewItemOutput>;
  csrCalendlyAppointments: Array<AppointmentOutput>;
  csrTrackingReport: Array<CsrTrackingReportOutput>;
  departments: Array<DepartmentOutput>;
  drugCostActivationLink: Scalars['String']['output'];
  drugCostsStatusMessage?: Maybe<Scalars['String']['output']>;
  emailTemplate: EmailTemplateDto;
  emailTemplates: PageableEmailTemplateOutput;
  enrollments: PageableEnrollmentOutput;
  flexpaFHIRResource: Scalars['String']['output'];
  followUpSweepFile: FollowUpSweepFileOutput;
  followUps: PageableClientViewListRepresentationOutput;
  followUpsFuture: PageableClientViewListRepresentationOutput;
  getDailyRingsState: DailyRingsState;
  getMyEnrollment?: Maybe<EnrollmentOutput>;
  getMyMedigapEnrollments?: Maybe<MedigapEnrollmentOutput>;
  gmailMessage: AgentEmailOutput;
  gmailMessagesByEmail: Array<AgentEmailOutput>;
  hasEnrollments: Scalars['Boolean']['output'];
  isAgentGmailSetUp: Scalars['Boolean']['output'];
  isAgentOnGmailPushSync: Scalars['Boolean']['output'];
  isAgentSlackLinked: Scalars['Boolean']['output'];
  isFlexpaConnected: Scalars['Boolean']['output'];
  isPhoneValid: Scalars['Boolean']['output'];
  isReplayAssignmentHistoryRunning: Scalars['Boolean']['output'];
  leadHistory: LeadHistoryOutput;
  leadManagement: LeadManagementOutput;
  leadManagerSummary: LeadManagerSummaryOutput;
  leadTransferDashboardStats: LeadTransferDashboardStatsOutput;
  leadTransferReport: LeadTransferRequestPageOutput;
  leadTransferRequest: LeadTransferRequestOutput;
  leadTransferRequestDetail: LeadTransferRequestDetailOutput;
  managementReport: Array<ManagementReportTeamOutput>;
  managementReportLedger: Array<ManagementReportLedgerEntryOutput>;
  managementReportRequests: Array<ManagementReportRequestOutput>;
  managerApprovalHistory: Array<ManagerApprovalHistoryOutput>;
  managerApprovalRequests: Array<ManagerApprovalRequestOutput>;
  managerNoteReplies: Array<ManagerNoteReplyOutput>;
  managerNotes: Array<ManagerNoteItemOutput>;
  medigapEnrollments: PageableMedigapEnrollmentOutput;
  migrateAgentRawDigitsState: MigrateAgentRawDigitsState;
  missedLunchCandidates: Array<MissedLunchCandidateOutput>;
  missingAppTotal: Scalars['Long']['output'];
  myActiveSqlsByMonth: Array<AgentSqlMonthOutput>;
  myClientId: Scalars['UUID']['output'];
  myCommissionByMonth: Array<AgentCommissionMonthOutput>;
  myComplianceGaps: Array<ComplianceGapOutput>;
  myCopilotConversations: CopilotConversationPageOutput;
  myDisplayTimezone?: Maybe<Scalars['String']['output']>;
  myEnrollments: Array<EnrollmentListItemOutput>;
  myEnrollmentsByMonth: Array<AgentEnrollmentBucketOutput>;
  myFuToSqlConversionByMonth: Array<AgentFuToSqlConversionOutput>;
  myHoursByDay: Array<DailyHoursOutput>;
  myHoursExport: MyHoursExportOutput;
  myHoursTotals: MyHoursTotalsOutput;
  myPriorityPoolStanding?: Maybe<AgentPriorityPoolStandingOutput>;
  myProjectedClosesCohorts: Array<AgentProjectedClosesCohortOutput>;
  mySqlToAppConversionByMonth: Array<AgentSqlToAppConversionOutput>;
  myTeamRoster: Array<TeamMemberStatusOutput>;
  myTimeclockProfile?: Maybe<TimeclockAgentProfileOutput>;
  myTimeclockStatus?: Maybe<PunchOutput>;
  myUpcomingFollowUps: AgentUpcomingFollowUpsOutput;
  nerdWalletUserProfile?: Maybe<UserProfileOutput>;
  newLeadOutreachDelayMinutes: Scalars['Int']['output'];
  newLeadOutreachEnabled: Scalars['Boolean']['output'];
  newLeadSmsDelayMinutes: Scalars['Int']['output'];
  offlineConversionSyncProcesses: PageableOfflineConversionSyncProcessOutput;
  overtimeWatch: Array<AgentOvertimeOutput>;
  paidVsScheduled: Array<WeeklyHoursOutput>;
  partnersAPIUsage: PartnersApiUsageResult;
  payrollExport: PayrollExportOutput;
  pdpEnrollment: PdpEnrollmentOutput;
  pdpEnrollments: PageablePdpEnrollmentOutput;
  pendingLeadTransferRequests: Array<LeadTransferRequestOutput>;
  pipelineOverview: PipelineOverviewOutput;
  platformCredentials?: Maybe<PlatformCredentialsOutput>;
  preCallBriefing?: Maybe<PreCallBriefingOutput>;
  previewPunchEdit: PunchEditPreviewOutput;
  priorityPoolStandings: Array<AgentPriorityPoolStandingOutput>;
  punchCorrectionRequests: Array<PunchCorrectionRequestOutput>;
  punchEditDay: PunchEditDayOutput;
  punchesForAgentAndDate: Array<PunchOutput>;
  pushTemporalData?: Maybe<Scalars['String']['output']>;
  qaAgentReports: Array<AgentQaReportOutput>;
  qaAudits: PageableQaAuditOutput;
  qaByAgent: AgentQaReportOutput;
  qaByClient: ClientQaReportOutput;
  qaCompare: QaCompareOutput;
  qaQuestionPerformance: QaQuestionPerformanceOutput;
  recentScheduleLoads: Array<ScheduleLoadHistoryOutput>;
  replayAssignmentHistoryProcessedCount: Scalars['Int']['output'];
  ringMetricExceptions: Array<RingMetricExceptionOutput>;
  ringsDayDetail: RingsDayDetailOutput;
  ringsHistory: Array<RingsHistoryDay>;
  /** Partner roster identities currently linked to this client. */
  rosterLinksForClient: Array<RosterLinkedIdentityOutput>;
  /** Search a partner roster by phone, or by last name plus a first name or ZIP. Never browses. */
  rosterSearch: Array<RosterCandidateOutput>;
  runClientDrugCostJob: Scalars['Boolean']['output'];
  runReplayAssignmentHistory: Scalars['Boolean']['output'];
  runReplayAssignmentHistoryForClient: Scalars['Boolean']['output'];
  salesLeaderboard: Array<SalesLeaderboardAgentOutput>;
  salesQualified: PageableClientViewListRepresentationOutput;
  salesQualifiedFuture: PageableClientViewListRepresentationOutput;
  sameDayFollowUpCount: Scalars['Long']['output'];
  scheduleExceptionRequests: Array<ScheduleExceptionRequestOutput>;
  scheduledAiCallsByClientId: Array<ScheduledAiCallOutput>;
  scopeOfAppointment?: Maybe<ScopeOfAppointmentOutput>;
  searchCopilotConversations: CopilotSearchPageOutput;
  sendInBlueHistoryByEmail: SendInBlueContactWithHistory;
  shortenedCostActivationLink?: Maybe<Scalars['String']['output']>;
  smsOutreachEnabled: Scalars['Boolean']['output'];
  startSyncCustomerIo: Scalars['Boolean']['output'];
  startSyncDrugCostActivationLinkCustomerIo: Scalars['Boolean']['output'];
  stopDrugCostActivationLinkSyncCustomerIo: Scalars['Boolean']['output'];
  stopSyncCpausedustomerIo: Scalars['Boolean']['output'];
  syncDrugCostActivationLinkByClientId: Scalars['Boolean']['output'];
  syncedCountSyncCustomerIo: Scalars['Int']['output'];
  syncedDrugCostActivationLinkCountSyncCustomerIo: Scalars['Int']['output'];
  tag: TagOutput;
  tags: Array<TagOutput>;
  teams: Array<TeamOutput>;
  timeclockAuditLog: TimeclockAuditPageOutput;
  timeclockPeople: Array<TimeclockPersonOutput>;
  timeclockProfile?: Maybe<TimeclockAgentProfileOutput>;
  timeclockScheduleJob: TimeclockScheduleJobOutput;
  timeclockScheduleJobs: Array<TimeclockScheduleJobOutput>;
  timelineForDate: Array<AgentTimelineOutput>;
  timelineSummaryByDepartment: Array<DepartmentTimelineSummaryOutput>;
  timelineSummaryForDate: TimelineSummaryOutput;
  todaysOutboundCallbacks: Array<LeadTransferRequestOutput>;
  userProfile?: Maybe<UserProfileOutput>;
  userProfiles: PageableUserProfileOutput;
  voiceAiExcludedTagIds: Array<Scalars['UUID']['output']>;
  weeklySchedule: WeeklyScheduleOutput;
  workScheduleExport: WorkScheduleExportOutput;
};


export type QueryActionItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryActionItemsArgs = {
  filter: ActionItemFilterInput;
  pageInput: PageInput;
  sort?: InputMaybe<ActionItemSortInput>;
};


export type QueryActionItemsByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryActiveAppointmentRequestByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryAgentAssignedToClientArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryAgentAvailabilityInsightsArgs = {
  agentEmails: Array<Scalars['String']['input']>;
  date: Scalars['LocalDate']['input'];
  minBlockMinutes: Scalars['Int']['input'];
};


export type QueryAgentByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAgentCurrentClientsMetricsArgs = {
  filter: AgentCurrentClientsMetricsFilterInput;
};


export type QueryAgentGmailMessagesArgs = {
  agentId: Scalars['UUID']['input'];
  page: PageInput;
};


export type QueryAgentPerformanceAnalyticsArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryAgentWorkingHoursArgs = {
  agentEmail: Scalars['String']['input'];
};


export type QueryAgentsArgs = {
  filter: AgentFilterInput;
  page: PageInput;
  sort?: InputMaybe<AgentSortInput>;
};


export type QueryAllEnrollmentsArgs = {
  filter: AllEnrollmentsFilterInput;
  page: PageInput;
};


export type QueryAssignmentHistoryArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryAttemptedLeadsArgs = {
  filter: AttemptedLeadFilterInput;
  pageInput: PageInput;
  sort?: InputMaybe<AttemptedLeadSortInput>;
};


export type QueryCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};


export type QueryCalendarEventsArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  input: ListCalendarEventsInput;
};


export type QueryCalendarFreeBusyArgs = {
  agentEmails: Array<Scalars['String']['input']>;
  timeMax: Scalars['Instant']['input'];
  timeMin: Scalars['Instant']['input'];
};


export type QueryCalendlyAppointmentsByAgentArgs = {
  agentId: Scalars['UUID']['input'];
  filter: CalendlyAppointmentsFilterInput;
  pageInput: PageInput;
  sort: CalendlyAppointmentsSortInput;
};


export type QueryCalendlyInviteeArgs = {
  eventUrl: Scalars['String']['input'];
  inviteeUrl: Scalars['String']['input'];
};


export type QueryCallHistoryAiAnalysisArgs = {
  callHistory: Scalars['UUID']['input'];
};


export type QueryCallHistoryAiAnalysisByClientArgs = {
  client: Scalars['UUID']['input'];
};


export type QueryCallHistoryByAirCallIdArgs = {
  airCallId: Scalars['Long']['input'];
};


export type QueryCallHistoryItemsArgs = {
  clientId: Scalars['UUID']['input'];
  page: PageInput;
};


export type QueryCallbacksForDayArgs = {
  date: Scalars['LocalDate']['input'];
};


export type QueryChannelArgs = {
  channelId: Scalars['UUID']['input'];
};


export type QueryChannelsArgs = {
  includeInactive: Scalars['Boolean']['input'];
};


export type QueryCheckUserExistenceByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryClaimAttemptReportArgs = {
  filter: ClaimAttemptReportFilterInput;
  page: PageInput;
};


export type QueryClientAttributeHistoryArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientCalendlyAppointmentsArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientDeclinableDrugAnswersArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientDocumentPreviewArgs = {
  documentId: Scalars['UUID']['input'];
};


export type QueryClientDocumentsArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientGroupByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientIdByProfileIdArgs = {
  profileId: Scalars['UUID']['input'];
};


export type QueryClientLeadSourcesArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientMedigapEnrollmentsArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientPdpEnrollmentsArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientPlatformSyncArgs = {
  clientId: Scalars['UUID']['input'];
  platform: SyncPlatform;
};


export type QueryClientSmsMessagesArgs = {
  clientId: Scalars['UUID']['input'];
  page: PageInput;
};


export type QueryClientUnderwritingAnswersArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientUnderwritingNotesArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientViewByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryClientViewByPinArgs = {
  pin: Scalars['String']['input'];
};


export type QueryClientViewCountersArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryClientViewForAdviserArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientViewsArgs = {
  filterInput?: InputMaybe<ClientViewFilterInput>;
  pageInput: PageInput;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryClientViewsForAdviserArgs = {
  filterInput?: InputMaybe<ClientViewFilterInput>;
  pageInput: PageInput;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryCompareOfferHistoryArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryContactedArgs = {
  agentId: Scalars['UUID']['input'];
  pageInput: PageInput;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryContinueDrugCostActivationLinkSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryContinueSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryCopilotConversationArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryCsrCalendlyAppointmentsArgs = {
  agentId: Scalars['UUID']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryCsrTrackingReportArgs = {
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryDepartmentsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDrugCostActivationLinkArgs = {
  shortenedUrl: Scalars['String']['input'];
};


export type QueryEmailTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEmailTemplatesArgs = {
  pageInput: PageInput;
};


export type QueryEnrollmentsArgs = {
  input?: InputMaybe<EnrollmentFilterInput>;
  page: PageInput;
};


export type QueryFlexpaFhirResourceArgs = {
  resourceName: Scalars['String']['input'];
};


export type QueryFollowUpSweepFileArgs = {
  gcsUri: Scalars['String']['input'];
};


export type QueryFollowUpsArgs = {
  agentId: Scalars['UUID']['input'];
  excludedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageInput: PageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryFollowUpsFutureArgs = {
  agentId: Scalars['UUID']['input'];
  excludedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageInput: PageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryGetDailyRingsStateArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryGmailMessageArgs = {
  messageId: Scalars['String']['input'];
};


export type QueryGmailMessagesByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryIsAgentGmailSetUpArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryIsAgentOnGmailPushSyncArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryIsAgentSlackLinkedArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryIsPhoneValidArgs = {
  phone: Scalars['String']['input'];
};


export type QueryIsReplayAssignmentHistoryRunningArgs = {
  key: Scalars['String']['input'];
};


export type QueryLeadHistoryArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryLeadManagementArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryLeadManagerSummaryArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryLeadTransferReportArgs = {
  filter: LeadTransferReportFilterInput;
  page: PageInput;
};


export type QueryLeadTransferRequestArgs = {
  requestId: Scalars['UUID']['input'];
};


export type QueryLeadTransferRequestDetailArgs = {
  requestId: Scalars['UUID']['input'];
};


export type QueryManagementReportArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  windowDays: Scalars['Int']['input'];
};


export type QueryManagementReportLedgerArgs = {
  agentId: Scalars['UUID']['input'];
  windowDays: Scalars['Int']['input'];
};


export type QueryManagementReportRequestsArgs = {
  agentId: Scalars['UUID']['input'];
  windowDays: Scalars['Int']['input'];
};


export type QueryManagerApprovalHistoryArgs = {
  actionItemId: Scalars['UUID']['input'];
};


export type QueryManagerApprovalRequestsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<ManagerApprovalStatus>;
};


export type QueryManagerNoteRepliesArgs = {
  noteId: Scalars['UUID']['input'];
};


export type QueryManagerNotesArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  scope: ManagerNoteScope;
  status: ManagerNoteStatus;
  windowDays: Scalars['Int']['input'];
};


export type QueryMedigapEnrollmentsArgs = {
  filter?: InputMaybe<MedigapFilterInput>;
  page: PageInput;
};


export type QueryMigrateAgentRawDigitsStateArgs = {
  key: Scalars['String']['input'];
};


export type QueryMissedLunchCandidatesArgs = {
  date: Scalars['LocalDate']['input'];
};


export type QueryMyActiveSqlsByMonthArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMyCommissionByMonthArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMyComplianceGapsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMyCopilotConversationsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryMyEnrollmentsByMonthArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMyFuToSqlConversionByMonthArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMyHoursByDayArgs = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type QueryMyHoursExportArgs = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type QueryMyHoursTotalsArgs = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type QueryMyPriorityPoolStandingArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMyProjectedClosesCohortsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMySqlToAppConversionByMonthArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMyUpcomingFollowUpsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryNerdWalletUserProfileArgs = {
  nerdWalletId: Scalars['String']['input'];
};


export type QueryOfflineConversionSyncProcessesArgs = {
  filter?: InputMaybe<OfflineConversionSyncProcessFilterInput>;
  page: PageInput;
};


export type QueryOvertimeWatchArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  weekOf: Scalars['LocalDate']['input'];
};


export type QueryPaidVsScheduledArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  weekOf?: InputMaybe<Scalars['LocalDate']['input']>;
  weeks?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnersApiUsageArgs = {
  key: Scalars['String']['input'];
};


export type QueryPayrollExportArgs = {
  departmentId: Scalars['UUID']['input'];
  periodEnd?: InputMaybe<Scalars['LocalDate']['input']>;
  periodStart: Scalars['LocalDate']['input'];
};


export type QueryPdpEnrollmentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPdpEnrollmentsArgs = {
  filter?: InputMaybe<PdpFilterInput>;
  page: PageInput;
};


export type QueryPipelineOverviewArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryPlatformCredentialsArgs = {
  platform: SyncPlatform;
};


export type QueryPreCallBriefingArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryPreviewPunchEditArgs = {
  agentId: Scalars['UUID']['input'];
  operations: Array<PunchEditOperationInput>;
  workDate: Scalars['LocalDate']['input'];
};


export type QueryPunchCorrectionRequestsArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPunchEditDayArgs = {
  agentId: Scalars['UUID']['input'];
  workDate: Scalars['LocalDate']['input'];
};


export type QueryPunchesForAgentAndDateArgs = {
  agentId: Scalars['UUID']['input'];
  date: Scalars['LocalDate']['input'];
};


export type QueryPushTemporalDataArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryQaAgentReportsArgs = {
  filter?: InputMaybe<CallQaFilterInput>;
};


export type QueryQaAuditsArgs = {
  filter?: InputMaybe<CallQaFilterInput>;
  page: PageInput;
};


export type QueryQaByAgentArgs = {
  agentId: Scalars['UUID']['input'];
  filter?: InputMaybe<CallQaFilterInput>;
};


export type QueryQaByClientArgs = {
  clientId: Scalars['UUID']['input'];
  filter?: InputMaybe<CallQaFilterInput>;
};


export type QueryQaCompareArgs = {
  filter?: InputMaybe<CallQaFilterInput>;
  groups: Array<QaCompareGroupInput>;
};


export type QueryQaQuestionPerformanceArgs = {
  filter?: InputMaybe<CallQaFilterInput>;
  questionId: Scalars['String']['input'];
};


export type QueryRecentScheduleLoadsArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryReplayAssignmentHistoryProcessedCountArgs = {
  key: Scalars['String']['input'];
};


export type QueryRingMetricExceptionsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRingsDayDetailArgs = {
  agentId: Scalars['UUID']['input'];
  date: Scalars['LocalDate']['input'];
};


export type QueryRingsHistoryArgs = {
  agentId: Scalars['UUID']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryRosterLinksForClientArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryRosterSearchArgs = {
  input: RosterSearchInput;
};


export type QueryRunClientDrugCostJobArgs = {
  key: Scalars['String']['input'];
};


export type QueryRunReplayAssignmentHistoryArgs = {
  key: Scalars['String']['input'];
};


export type QueryRunReplayAssignmentHistoryForClientArgs = {
  clientId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
};


export type QuerySalesQualifiedArgs = {
  agentId: Scalars['UUID']['input'];
  excludedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageInput: PageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QuerySalesQualifiedFutureArgs = {
  agentId: Scalars['UUID']['input'];
  excludedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageInput: PageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QuerySameDayFollowUpCountArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryScheduleExceptionRequestsArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScheduledAiCallsByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryScopeOfAppointmentArgs = {
  soaId: Scalars['UUID']['input'];
};


export type QuerySearchCopilotConversationsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QuerySendInBlueHistoryByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryShortenedCostActivationLinkArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryStartSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryStartSyncDrugCostActivationLinkCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryStopDrugCostActivationLinkSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryStopSyncCpausedustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QuerySyncDrugCostActivationLinkByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
  requestKey: Scalars['String']['input'];
};


export type QuerySyncedCountSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QuerySyncedDrugCostActivationLinkCountSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryTagArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTeamsArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTimeclockAuditLogArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  page: PageInput;
  since?: InputMaybe<Scalars['Instant']['input']>;
  until?: InputMaybe<Scalars['Instant']['input']>;
};


export type QueryTimeclockPeopleArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimeclockProfileArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryTimeclockScheduleJobArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTimelineForDateArgs = {
  date: Scalars['LocalDate']['input'];
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTimelineSummaryByDepartmentArgs = {
  date: Scalars['LocalDate']['input'];
};


export type QueryTimelineSummaryForDateArgs = {
  date: Scalars['LocalDate']['input'];
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTodaysOutboundCallbacksArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserProfilesArgs = {
  filterInput?: InputMaybe<UserProfileFilterInput>;
  page: PageInput;
};


export type QueryWeeklyScheduleArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  monday: Scalars['LocalDate']['input'];
};


export type QueryWorkScheduleExportArgs = {
  departmentId: Scalars['UUID']['input'];
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  weekStart: Scalars['LocalDate']['input'];
  weeks?: InputMaybe<Scalars['Int']['input']>;
};

export type RrViewBusyAgentOutput = {
  __typename?: 'RRViewBusyAgentOutput';
  agentId: Scalars['UUID']['output'];
  assignedToClient: Scalars['Boolean']['output'];
  dontDisturb: Scalars['Boolean']['output'];
  excluded: Scalars['Boolean']['output'];
  onACall: Scalars['Boolean']['output'];
};

export type RrViewOutput = {
  __typename?: 'RRViewOutput';
  busy: Array<RrViewBusyAgentOutput>;
  inActiveQueue: Array<Scalars['UUID']['output']>;
  offline: Array<Scalars['UUID']['output']>;
  tasksWaitingPool: Array<AgentCallAgendaTaskInPoolOutput>;
};

export enum Rating {
  None = 'NONE',
  R1 = 'R1',
  R1_5 = 'R1_5',
  R2 = 'R2',
  R2_5 = 'R2_5',
  R3 = 'R3',
  R3_5 = 'R3_5',
  R4 = 'R4',
  R4_5 = 'R4_5',
  R5 = 'R5'
}

export type ReconnectActionResult = {
  __typename?: 'ReconnectActionResult';
  confirmation?: Maybe<Scalars['String']['output']>;
  credited: Scalars['Boolean']['output'];
  guard?: Maybe<GuardResult>;
  ring: ReconnectsRingState;
};

export type ReconnectItemOutput = {
  __typename?: 'ReconnectItemOutput';
  aiReason?: Maybe<Scalars['String']['output']>;
  channelsToday: Array<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  daysSinceLastContact?: Maybe<Scalars['Int']['output']>;
  deferredToday: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  followUpDate?: Maybe<Scalars['LocalDate']['output']>;
  group: Scalars['String']['output'];
  hint?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  resolvedToday: Scalars['Boolean']['output'];
  ruleMatched?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  urgencyTier: Scalars['String']['output'];
};

export type ReconnectsRingState = {
  __typename?: 'ReconnectsRingState';
  closed: Scalars['Boolean']['output'];
  done: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  overflowCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RejectedDocumentItemOutput = {
  __typename?: 'RejectedDocumentItemOutput';
  clientId: Scalars['UUID']['output'];
  documentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  reviewedAt?: Maybe<Scalars['Instant']['output']>;
  verificationReasoning?: Maybe<Scalars['String']['output']>;
};

export enum RejectionReason {
  AlreadyScheduled = 'ALREADY_SCHEDULED',
  ClientNotFound = 'CLIENT_NOT_FOUND',
  NoPhoneNumber = 'NO_PHONE_NUMBER',
  RecentlyCalled = 'RECENTLY_CALLED'
}

export enum RequestStatusDto {
  Complete = 'COMPLETE',
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS'
}

export type RequiredActionOutput = {
  __typename?: 'RequiredActionOutput';
  createdAt: Scalars['Instant']['output'];
  detailsJson: Scalars['String']['output'];
  done: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export enum RetrySlackInteractionOutcome {
  NotFailed = 'NOT_FAILED',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type RingMetricExceptionOutput = {
  __typename?: 'RingMetricExceptionOutput';
  agentId: Scalars['UUID']['output'];
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  exceptionType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  metricDate: Scalars['LocalDate']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<Scalars['UUID']['output']>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['Instant']['output']>;
  reviewedBy?: Maybe<Scalars['UUID']['output']>;
  status: Scalars['String']['output'];
};

export type RingsDayAdminTaskOutput = {
  __typename?: 'RingsDayAdminTaskOutput';
  clientName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Instant']['output']>;
  completionMethod?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type RingsDayDetailOutput = {
  __typename?: 'RingsDayDetailOutput';
  adminTasksCompleted: Array<RingsDayAdminTaskOutput>;
  callsCount: Scalars['Int']['output'];
  date: Scalars['LocalDate']['output'];
  excusals: Array<RingMetricExceptionOutput>;
  reconnectCredits: Array<RingsDayReconnectOutput>;
  reconnectMisses: Array<RingsDayReconnectOutput>;
  scheduled: Scalars['Boolean']['output'];
  wrapUpItems: Array<RingsDayWrapUpItemOutput>;
};

export type RingsDayReconnectOutput = {
  __typename?: 'RingsDayReconnectOutput';
  channels?: Maybe<Array<Scalars['String']['output']>>;
  clientId: Scalars['UUID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
};

export type RingsDayWrapUpItemOutput = {
  __typename?: 'RingsDayWrapUpItemOutput';
  clientId: Scalars['UUID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  itemType: Scalars['String']['output'];
  resolution?: Maybe<Scalars['String']['output']>;
  resolutionLabel?: Maybe<Scalars['String']['output']>;
  resolved: Scalars['Boolean']['output'];
  resolvedAt?: Maybe<Scalars['Instant']['output']>;
};

export type RingsHistoryDay = {
  __typename?: 'RingsHistoryDay';
  adminRing?: Maybe<RingsHistoryRingState>;
  allRingsClosed?: Maybe<Scalars['Boolean']['output']>;
  callsRing?: Maybe<RingsHistoryRingState>;
  date: Scalars['LocalDate']['output'];
  reconnectsRing?: Maybe<RingsHistoryRingState>;
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  streak?: Maybe<Scalars['Int']['output']>;
};

export type RingsHistoryRingState = {
  __typename?: 'RingsHistoryRingState';
  closed: Scalars['Boolean']['output'];
  done: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RosterCandidateOutput = {
  __typename?: 'RosterCandidateOutput';
  /** True when this patient is already linked to a client. The agent should open that client, not create a second one. */
  alreadyLinked: Scalars['Boolean']['output'];
  /** Campaigns this person appears in. A person on two rosters is still one person and one link. */
  campaigns: Array<Scalars['String']['output']>;
  /** False when the partner holds no date of birth, so the challenge could never pass. One bit, and it stops an agent burning attempts on something unwinnable. */
  canVerify: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedClientId?: Maybe<Scalars['UUID']['output']>;
  /** Which partner's roster this candidate came from. Only `aledade` exists today. */
  partner: Scalars['String']['output'];
  /** The partner's PERSON identifier, stable across campaigns. Not the task id. */
  patientId: Scalars['String']['output'];
  /** Last four digits only, for confirming against the number that rang. */
  phoneLast4?: Maybe<Scalars['String']['output']>;
  /** Town of the practice's primary location. A patient cannot be pinned to a location from the roster alone. */
  practiceCity?: Maybe<Scalars['String']['output']>;
  /** The practice this patient belongs to -- the natural verification question. */
  practiceName?: Maybe<Scalars['String']['output']>;
  practiceState?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** The result of linking or unlinking a roster patient. */
export type RosterLinkOutput = {
  __typename?: 'RosterLinkOutput';
  /** Null after an unlink. */
  clientId?: Maybe<Scalars['UUID']['output']>;
  patientId: Scalars['String']['output'];
  /** Every task id covered. One per campaign the person appears in -- all of them are linked at once, or later campaigns silently go unreported. */
  taskIds: Array<Scalars['String']['output']>;
};

/** A possible match on a partner roster, showing only what is needed to recognise the caller. */
export type RosterLinkedIdentityOutput = {
  __typename?: 'RosterLinkedIdentityOutput';
  /** Campaigns this person appears in. One link covers every campaign they are on. */
  campaigns: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** When the link was made, so a stale match is visible as one. */
  linkedAt?: Maybe<Scalars['Instant']['output']>;
  /** Who asserted the match. The link is a human judgement and names its author. */
  linkedBy?: Maybe<Scalars['String']['output']>;
  /** Which partner's roster this identity belongs to. Only `aledade` exists today. */
  partner: Scalars['String']['output'];
  /** The partner's PERSON identifier, stable across campaigns. */
  patientId: Scalars['String']['output'];
  practiceCity?: Maybe<Scalars['String']['output']>;
  practiceName?: Maybe<Scalars['String']['output']>;
  practiceState?: Maybe<Scalars['String']['output']>;
  /** The partner task ids this link covers -- one per campaign participation. */
  taskIds: Array<Scalars['String']['output']>;
};

/** What the partner holds for a patient whose identity has just been confirmed. */
export type RosterPatientDetailsOutput = {
  __typename?: 'RosterPatientDetailsOutput';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** Safe to return now: the caller just proved they know it. */
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Null when the address is shared by more than one patient, since a placeholder must never be prefilled into our record. */
  identifyingEmail?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** M, F or U as the partner records it. */
  sex?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Criteria for finding a patient on a partner roster. At least one identifying combination is required. */
export type RosterSearchInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Ten digits. Punctuation and a leading country code are stripped before matching. */
  phone?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** The result of a date-of-birth challenge. */
export type RosterVerificationOutput = {
  __typename?: 'RosterVerificationOutput';
  /** Attempts left for this agent against this patient in the current window. Zero means the next attempt is refused. */
  attemptsRemaining: Scalars['Int']['output'];
  /** The partner's own record of this person, returned ONLY on a successful challenge. */
  details?: Maybe<RosterPatientDetailsOutput>;
  patientId: Scalars['String']['output'];
  /** True when the date given matches the roster. A false is the check working, not an error. */
  verified: Scalars['Boolean']['output'];
};

export type SlaFilterInput = {
  agent?: InputMaybe<Scalars['UUID']['input']>;
  excludeBadNumber?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDoNotCall?: InputMaybe<Scalars['Boolean']['input']>;
  excludeNotAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  justNerdWallet?: InputMaybe<Scalars['Boolean']['input']>;
  range?: InputMaybe<DateRangeInput>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  within2Hours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SlaOutput = {
  __typename?: 'SLAOutput';
  agent?: Maybe<AgentViewOutput>;
  callsCount: Scalars['Int']['output'];
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  firstCallAgentName?: Maybe<Scalars['String']['output']>;
  firstCallAt?: Maybe<Scalars['Instant']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  secondCallAgentName?: Maybe<Scalars['String']['output']>;
  secondCallAt?: Maybe<Scalars['Instant']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: StatusDto;
  successfulCallsCount: Scalars['Int']['output'];
  tags: Array<AssignedTagViewOutput>;
};

export type SlaSummaryOutput = {
  __typename?: 'SLASummaryOutput';
  oldestCreatedAt?: Maybe<Scalars['Instant']['output']>;
  total: Scalars['Long']['output'];
};

export enum SnpType {
  CSnp = 'C_SNP',
  DSnp = 'D_SNP',
  ISnp = 'I_SNP'
}

export type SalesLeaderboardAgentOutput = {
  __typename?: 'SalesLeaderboardAgentOutput';
  agentId: Scalars['UUID']['output'];
  aircallStatus?: Maybe<Scalars['String']['output']>;
  avgTalkSecondsInboundToday?: Maybe<Scalars['Float']['output']>;
  avgTalkSecondsOutboundToday?: Maybe<Scalars['Float']['output']>;
  callsToday: Scalars['Int']['output'];
  closesThisMonth: Scalars['Int']['output'];
  closesToday: Scalars['Int']['output'];
  hoursWorkedToday?: Maybe<Scalars['BigDecimal']['output']>;
  ibTakenToday: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  newLeadBlockNow: Scalars['Boolean']['output'];
  obDialsToday: Scalars['Int']['output'];
  onShiftNow: Scalars['Boolean']['output'];
  warmTransfersClaimedToday: Scalars['Int']['output'];
};

export type SaveStatusResult = {
  __typename?: 'SaveStatusResult';
  confirmation?: Maybe<Scalars['String']['output']>;
  guard?: Maybe<GuardResult>;
  ringReview?: Maybe<RingMetricExceptionOutput>;
  success: Scalars['Boolean']['output'];
};

export type ScheduleAiCallGuard = {
  __typename?: 'ScheduleAiCallGuard';
  code: RejectionReason;
  message: Scalars['String']['output'];
};

export type ScheduleAiCallResult = {
  __typename?: 'ScheduleAiCallResult';
  clientId: Scalars['UUID']['output'];
  guard?: Maybe<ScheduleAiCallGuard>;
  scheduled: Scalars['Boolean']['output'];
};

export type ScheduleDayOutput = {
  __typename?: 'ScheduleDayOutput';
  approvedExceptionRequestId?: Maybe<Scalars['UUID']['output']>;
  breaks: Array<ScheduleSegmentOutput>;
  date: Scalars['LocalDate']['output'];
  endTime?: Maybe<Scalars['LocalTime']['output']>;
  isOverride: Scalars['Boolean']['output'];
  lunchApprovedExceptionRequestId?: Maybe<Scalars['UUID']['output']>;
  lunchMinutes?: Maybe<Scalars['Int']['output']>;
  lunchSegmentId?: Maybe<Scalars['UUID']['output']>;
  lunchStart?: Maybe<Scalars['LocalTime']['output']>;
  overrideSource?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['LocalTime']['output']>;
  unpaidBreakHours?: Maybe<Scalars['BigDecimal']['output']>;
};

export type ScheduleExceptionRequestOutput = {
  __typename?: 'ScheduleExceptionRequestOutput';
  agentFirstName: Scalars['String']['output'];
  agentId: Scalars['UUID']['output'];
  agentLastName: Scalars['String']['output'];
  canDecide: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  dayPunches?: Maybe<Array<PunchOutput>>;
  decidedAt?: Maybe<Scalars['Instant']['output']>;
  decidedBy?: Maybe<Scalars['UUID']['output']>;
  decisionNote?: Maybe<Scalars['String']['output']>;
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  flags: Array<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  reason: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  requestedAt?: Maybe<Scalars['Instant']['output']>;
  requestedBy: Scalars['UUID']['output'];
  requestedByFirstName: Scalars['String']['output'];
  requestedByLastName: Scalars['String']['output'];
  requestedEndTime?: Maybe<Scalars['LocalTime']['output']>;
  slot: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['LocalTime']['output']>;
  status: Scalars['String']['output'];
  validationWarning?: Maybe<Scalars['String']['output']>;
  weekday?: Maybe<Scalars['Int']['output']>;
  workDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type ScheduleLoadHistoryOutput = {
  __typename?: 'ScheduleLoadHistoryOutput';
  fromDate: Scalars['LocalDate']['output'];
  id: Scalars['UUID']['output'];
  loadedAt: Scalars['Instant']['output'];
  loadedBy: Scalars['UUID']['output'];
  loadedByFirstName: Scalars['String']['output'];
  loadedByLastName: Scalars['String']['output'];
  replaced: Scalars['Boolean']['output'];
  rowsWritten: Scalars['Int']['output'];
  toDate: Scalars['LocalDate']['output'];
};

export type ScheduleSegmentOutput = {
  __typename?: 'ScheduleSegmentOutput';
  agentId: Scalars['UUID']['output'];
  approvedExceptionRequestId?: Maybe<Scalars['UUID']['output']>;
  code: Scalars['String']['output'];
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  slot: Scalars['Int']['output'];
  startTime: Scalars['LocalTime']['output'];
  weekday?: Maybe<Scalars['Int']['output']>;
  workDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type ScheduledAiCallOutput = {
  __typename?: 'ScheduledAiCallOutput';
  callCompletedAt?: Maybe<Scalars['Instant']['output']>;
  callHistoryId?: Maybe<Scalars['UUID']['output']>;
  callStatus?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  requestedBy: Scalars['UUID']['output'];
  scheduledFor: Scalars['Instant']['output'];
  status: ScheduledAiCallStatus;
  triggeredAt?: Maybe<Scalars['Instant']['output']>;
};

export enum ScheduledAiCallStatus {
  Cancelled = 'CANCELLED',
  Dialing = 'DIALING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Triggered = 'TRIGGERED'
}

export type ScheduledSmsOutput = {
  __typename?: 'ScheduledSmsOutput';
  cadenceDay: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  scheduledFor: Scalars['Instant']['output'];
  sentAt?: Maybe<Scalars['Instant']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  status: ScheduledSmsStatus;
};

export enum ScheduledSmsStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sending = 'SENDING',
  Sent = 'SENT',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN'
}

export type SchedulingInsightsOutput = {
  __typename?: 'SchedulingInsightsOutput';
  agents: Array<AgentAvailabilityOutput>;
  busiestHourBusyCount: Scalars['Int']['output'];
  busiestHourUtc?: Maybe<Scalars['Int']['output']>;
};

export type ScopeOfAppointmentAdminInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ScopeOfAppointmentOutput = {
  __typename?: 'ScopeOfAppointmentOutput';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum ScopeOfAppointmentStatusDto {
  Opened = 'OPENED',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export type ScopeOfAppointmentUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SendInBlueContactWithHistory = {
  __typename?: 'SendInBlueContactWithHistory';
  history: Array<Maybe<SendInBlueHistoryItem>>;
};

export type SendInBlueHistoryItem = {
  __typename?: 'SendInBlueHistoryItem';
  date: Scalars['Instant']['output'];
  fromEmail: Scalars['String']['output'];
  status: SendInBlueHistoryStatus;
  subject: Scalars['String']['output'];
  toEmail: Scalars['String']['output'];
};

export enum SendInBlueHistoryStatus {
  Blocked = 'BLOCKED',
  Clicks = 'CLICKS',
  Delivered = 'DELIVERED',
  Invalid = 'INVALID',
  Opened = 'OPENED',
  Unsubscribed = 'UNSUBSCRIBED'
}

export enum SlackChannelHealth {
  Archived = 'ARCHIVED',
  Connected = 'CONNECTED',
  NeedsInvite = 'NEEDS_INVITE',
  NotFound = 'NOT_FOUND',
  Unknown = 'UNKNOWN'
}

export enum SmsDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SqlIntentOutput = {
  __typename?: 'SqlIntentOutput';
  score: Scalars['Float']['output'];
  scorecardVersion: Scalars['String']['output'];
  scoredAt: Scalars['Instant']['output'];
  signals: Array<SqlIntentSignalOutput>;
  tier: SqlIntentTier;
};

export type SqlIntentSignalOutput = {
  __typename?: 'SqlIntentSignalOutput';
  airCallId?: Maybe<Scalars['Long']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  occurredAt?: Maybe<Scalars['Instant']['output']>;
  points: Scalars['Float']['output'];
  quote?: Maybe<Scalars['String']['output']>;
};

export enum SqlIntentTier {
  High = 'HIGH',
  Low = 'LOW',
  Warm = 'WARM'
}

export enum Status {
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  Attempted = 'ATTEMPTED',
  Contacted = 'CONTACTED',
  Disenrolled = 'DISENROLLED',
  Disqualified = 'DISQUALIFIED',
  Draft = 'DRAFT',
  Duplicated = 'DUPLICATED',
  FollowUp = 'FOLLOW_UP',
  NotYetEngaged = 'NOT_YET_ENGAGED',
  OutOfService = 'OUT_OF_SERVICE',
  SalesQualified = 'SALES_QUALIFIED',
  Test = 'TEST'
}

export enum StatusDto {
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  Attempted = 'ATTEMPTED',
  Contacted = 'CONTACTED',
  Disenrolled = 'DISENROLLED',
  Disqualified = 'DISQUALIFIED',
  Draft = 'DRAFT',
  Duplicated = 'DUPLICATED',
  FollowUp = 'FOLLOW_UP',
  NotYetEngaged = 'NOT_YET_ENGAGED',
  OutOfService = 'OUT_OF_SERVICE',
  SalesQualified = 'SALES_QUALIFIED',
  Test = 'TEST'
}

export enum StatusOutput {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type SubmitLeadTransferNoteInput = {
  agreedOnConfirmed: Scalars['Boolean']['input'];
  callType: CallType;
  callbackDate?: InputMaybe<Scalars['LocalDate']['input']>;
  callbackTimeFrom?: InputMaybe<Scalars['String']['input']>;
  callbackTimeTo?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['UUID']['input'];
  concern: Scalars['String']['input'];
  confirmSupersedeExisting: Scalars['Boolean']['input'];
  currentPlanTypes: Array<LeadTransferPlanType>;
  idempotencyKey?: InputMaybe<Scalars['UUID']['input']>;
  soaCompleted: Scalars['Boolean']['input'];
  transferType: TransferType;
};

export type Subscription = {
  __typename?: 'Subscription';
  agentCallAgenda: AgentCallAgendaOutput;
  agentCallAgendaWholeState: CurrentAgentCallAgendaStateOutput;
  appointments: Array<AppointmentOutput>;
  ariaCopilot: AriaCopilotOutput;
  calendarEventUpdates: CalendarEventUpdateOutput;
  claimedWindowReminder: LeadTransferAgentNotificationOutput;
  clientCard: ClientViewOutput;
  clientSmsUpdates: ClientSmsOutput;
  dashboardView: DashboardSectionOutput;
  greetings: Scalars['String']['output'];
  leadClaimUpdates: LeadTransferUpdateOutput;
  leadManagementEvents: LeadManagementEventOutput;
  myTeamRosterUpdates: Array<TeamMemberStatusOutput>;
  newLeadsStatistics: NewLeadsStatisticsOutput;
  ping: Scalars['Long']['output'];
  punchCorrectionRequestUpdates: Array<PunchCorrectionRequestOutput>;
  requiredActions: Array<RequiredActionOutput>;
  scheduleExceptionRequestUpdates: Array<ScheduleExceptionRequestOutput>;
  slaCallbackSummary: SlaSummaryOutput;
  slas: PageableSlaOutput;
  testSubscriptionError: Scalars['Long']['output'];
  timeclockScheduleJobUpdates: TimeclockScheduleJobOutput;
  urgentCallRequests: Array<UrgentRequestCallOutput>;
  weeklyScheduleUpdates: WeeklyScheduleOutput;
};


export type SubscriptionAppointmentsArgs = {
  agentId: Scalars['UUID']['input'];
};


export type SubscriptionAriaCopilotArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionCalendarEventUpdatesArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionClientCardArgs = {
  data: ClientDetailsSubscriptionInput;
};


export type SubscriptionClientSmsUpdatesArgs = {
  clientId: Scalars['UUID']['input'];
  since?: InputMaybe<Scalars['Instant']['input']>;
};


export type SubscriptionDashboardViewArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionLeadManagementEventsArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionMyTeamRosterUpdatesArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionPunchCorrectionRequestUpdatesArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionScheduleExceptionRequestUpdatesArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionSlaCallbackSummaryArgs = {
  filter: SlaFilterInput;
};


export type SubscriptionSlasArgs = {
  filter: SlaFilterInput;
  pageInput: PageInput;
};


export type SubscriptionTimeclockScheduleJobUpdatesArgs = {
  id: Scalars['UUID']['input'];
};


export type SubscriptionWeeklyScheduleUpdatesArgs = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  monday: Scalars['LocalDate']['input'];
};

export type SyncClientEmailsResult = {
  __typename?: 'SyncClientEmailsResult';
  message?: Maybe<Scalars['String']['output']>;
  started: Scalars['Boolean']['output'];
};

export enum SyncPlatform {
  Integrity = 'INTEGRITY'
}

export type TagAssignedToClientInput = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['Instant']['input']>;
  id: Scalars['UUID']['input'];
};

export type TagInput = {
  aiDescription?: InputMaybe<Scalars['String']['input']>;
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type TagOutput = {
  __typename?: 'TagOutput';
  aiDescription?: Maybe<Scalars['String']['output']>;
  aiEnabled?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type TagViewOutput = {
  __typename?: 'TagViewOutput';
  aiEnabled?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type TeamMemberStatusOutput = {
  __typename?: 'TeamMemberStatusOutput';
  agentId: Scalars['UUID']['output'];
  canViewFloor: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  departmentId: Scalars['UUID']['output'];
  firstName: Scalars['String']['output'];
  isException: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  role: UserRole;
  since?: Maybe<Scalars['Instant']['output']>;
  timeclockRank: TimeclockRank;
};

export type TeamOutput = {
  __typename?: 'TeamOutput';
  departmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  lead: TimeclockTeamLeadOutput;
  members: Array<TimeclockTeamLeadOutput>;
  name: Scalars['String']['output'];
};

export type TimeclockAgentProfileInput = {
  canViewFloor: Scalars['Boolean']['input'];
  departmentId: Scalars['UUID']['input'];
  hiredOn?: InputMaybe<Scalars['LocalDate']['input']>;
  onFloor: Scalars['Boolean']['input'];
  payrollOrder?: InputMaybe<Scalars['Int']['input']>;
  timeclockRank: TimeclockRank;
  timezone: Scalars['String']['input'];
  unpaidBreakHours: Scalars['BigDecimal']['input'];
};

export type TimeclockAgentProfileOutput = {
  __typename?: 'TimeclockAgentProfileOutput';
  agentId: Scalars['UUID']['output'];
  canViewFloor: Scalars['Boolean']['output'];
  departmentId: Scalars['UUID']['output'];
  hiredOn?: Maybe<Scalars['LocalDate']['output']>;
  onFloor: Scalars['Boolean']['output'];
  payrollOrder?: Maybe<Scalars['Int']['output']>;
  timeclockRank: TimeclockRank;
  timezone: Scalars['String']['output'];
  unpaidBreakHours: Scalars['BigDecimal']['output'];
};

export type TimeclockAuditLogOutput = {
  __typename?: 'TimeclockAuditLogOutput';
  action: Scalars['String']['output'];
  actorId?: Maybe<Scalars['UUID']['output']>;
  afterJson?: Maybe<Scalars['String']['output']>;
  beforeJson?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Instant']['output'];
  departmentId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  subjectAgentId?: Maybe<Scalars['UUID']['output']>;
};

export type TimeclockAuditPageOutput = {
  __typename?: 'TimeclockAuditPageOutput';
  data: Array<TimeclockAuditLogOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type TimeclockPersonOutput = {
  __typename?: 'TimeclockPersonOutput';
  active: Scalars['Boolean']['output'];
  agentId: Scalars['UUID']['output'];
  canViewFloor: Scalars['Boolean']['output'];
  departmentId: Scalars['UUID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  hiredOn?: Maybe<Scalars['LocalDate']['output']>;
  lastName: Scalars['String']['output'];
  payrollOrder?: Maybe<Scalars['Int']['output']>;
  reportsTo: Array<TimeclockTeamLeadOutput>;
  role: UserRole;
  timeclockRank: TimeclockRank;
};

export enum TimeclockRank {
  Agent = 'AGENT',
  Manager = 'MANAGER',
  SuperManager = 'SUPER_MANAGER',
  TeamLead = 'TEAM_LEAD'
}

export type TimeclockScheduleJobOutput = {
  __typename?: 'TimeclockScheduleJobOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  completedAt?: Maybe<Scalars['Instant']['output']>;
  createdAt: Scalars['Instant']['output'];
  daysGenerated: Scalars['Int']['output'];
  end?: Maybe<Scalars['LocalDate']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  overwrite: Scalars['Boolean']['output'];
  skippedNoTemplate: Scalars['Int']['output'];
  start: Scalars['LocalDate']['output'];
  status: Scalars['String']['output'];
};

export type TimeclockTeamLeadOutput = {
  __typename?: 'TimeclockTeamLeadOutput';
  agentId: Scalars['UUID']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type TimelineSegmentOutput = {
  __typename?: 'TimelineSegmentOutput';
  code: Scalars['String']['output'];
  end?: Maybe<Scalars['Instant']['output']>;
  isException: Scalars['Boolean']['output'];
  start: Scalars['Instant']['output'];
};

export enum TimelineStatus {
  Absent = 'ABSENT',
  Done = 'DONE',
  LeftEarly = 'LEFT_EARLY',
  NoShow = 'NO_SHOW',
  Off = 'OFF',
  RunningOver = 'RUNNING_OVER',
  Stale = 'STALE',
  Unscheduled = 'UNSCHEDULED',
  Upcoming = 'UPCOMING',
  Working = 'WORKING'
}

export type TimelineSummaryOutput = {
  __typename?: 'TimelineSummaryOutput';
  absent: Scalars['Int']['output'];
  off: Scalars['Int']['output'];
  onShift: Scalars['Int']['output'];
  unclosed: Scalars['Int']['output'];
};

export enum TrackingIdTypeDto {
  Google = 'GOOGLE',
  Opix = 'OPIX'
}

export enum TransferType {
  RequestedOutbound = 'REQUESTED_OUTBOUND',
  WarmTransfer = 'WARM_TRANSFER'
}

export type UnderwritingAnswerViewOutput = {
  __typename?: 'UnderwritingAnswerViewOutput';
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['Instant']['output']>;
  answeredByEmail?: Maybe<Scalars['String']['output']>;
  carrierDisplayName?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<Scalars['String']['output']>;
  filterName?: Maybe<Scalars['String']['output']>;
  naic: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['UUID']['output'];
  questionText: Scalars['String']['output'];
};

export type UnderwritingClientNoteViewOutput = {
  __typename?: 'UnderwritingClientNoteViewOutput';
  answeredAt?: Maybe<Scalars['Instant']['output']>;
  answeredByEmail?: Maybe<Scalars['String']['output']>;
  carrierDisplayName?: Maybe<Scalars['String']['output']>;
  filterName?: Maybe<Scalars['String']['output']>;
  naic: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type UpdateCalendarEventInput = {
  attendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  colorId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['Instant']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderMinutes?: InputMaybe<Scalars['Int']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime?: InputMaybe<Scalars['Instant']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export enum UrgentCallTypeDto {
  AsSoonAsPossible = 'AS_SOON_AS_POSSIBLE',
  ThisAfternoon = 'THIS_AFTERNOON',
  ThisMorning = 'THIS_MORNING'
}

export type UrgentRequestCallOutput = {
  __typename?: 'UrgentRequestCallOutput';
  clientId: Scalars['UUID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  urgentCallType?: Maybe<UrgentCallTypeDto>;
};

export type UserProfileFilterInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  adviserEmail?: InputMaybe<Scalars['String']['input']>;
  adviserName?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  aptNumber?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<ProfileAttributeInput>>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  bookingFor?: InputMaybe<Scalars['String']['input']>;
  cId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  countyName?: InputMaybe<Scalars['String']['input']>;
  eligibleName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrolled?: InputMaybe<Scalars['String']['input']>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<FormName>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasNoPreferredDoctors?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoPreferredPharmacies?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoPrescriptionsDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicareNumber?: InputMaybe<Scalars['String']['input']>;
  medicarePartAStartedAt?: InputMaybe<Scalars['String']['input']>;
  medicarePartBStartedAt?: InputMaybe<Scalars['String']['input']>;
  medigapQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  oppref?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<ProfileOption>>;
  pdpQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  planTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  profileId?: InputMaybe<Scalars['UUID']['input']>;
  quoteId?: InputMaybe<Scalars['UUID']['input']>;
  retireIn3Months?: InputMaybe<Scalars['String']['input']>;
  soaAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<ProfileSource>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RequestStatusDto>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  uId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  utmBrand?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileInputForAdviserInput = {
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  countyName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileOutput = {
  __typename?: 'UserProfileOutput';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  aptNumber?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  bookingFor?: Maybe<Scalars['String']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  eligibleName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasNoPreferredDoctors?: Maybe<Scalars['Boolean']['output']>;
  hasNoPreferredPharmacies?: Maybe<Scalars['Boolean']['output']>;
  hasNoPrescriptionsDrugs?: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medicarePartAStartedAt?: Maybe<Scalars['String']['output']>;
  medicarePartBStartedAt?: Maybe<Scalars['String']['output']>;
  medigapQuoteId?: Maybe<Scalars['UUID']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  planTypes?: Maybe<Array<Scalars['String']['output']>>;
  profileId: Scalars['UUID']['output'];
  quoteId?: Maybe<Scalars['UUID']['output']>;
  retireIn3Months?: Maybe<Scalars['String']['output']>;
  soaAgreement?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserProfileSaveOutput = {
  __typename?: 'UserProfileSaveOutput';
  clientId?: Maybe<Scalars['UUID']['output']>;
  enrollmentId?: Maybe<Scalars['UUID']['output']>;
  profileId: Scalars['UUID']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
  userToken?: Maybe<UserToken>;
};

export enum UserRole {
  /** @deprecated this is legacy role for agent. todo - use ROLE_AGENT instead */
  RoleAdmin = 'ROLE_ADMIN',
  RoleAdviser = 'ROLE_ADVISER',
  RoleAgentManager = 'ROLE_AGENT_MANAGER',
  RoleCsr = 'ROLE_CSR',
  RoleCsrManager = 'ROLE_CSR_MANAGER',
  RoleNone = 'ROLE_NONE',
  RoleSuperAdmin = 'ROLE_SUPER_ADMIN',
  RoleTechStaff = 'ROLE_TECH_STAFF',
  RoleUnauthorized = 'ROLE_UNAUTHORIZED',
  RoleUser = 'ROLE_USER'
}

export type UserToken = {
  __typename?: 'UserToken';
  accessToken: Scalars['String']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type WeeklyHoursOutput = {
  __typename?: 'WeeklyHoursOutput';
  actualHours: Scalars['BigDecimal']['output'];
  agentId: Scalars['UUID']['output'];
  breakHours: Scalars['BigDecimal']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lunchHours: Scalars['BigDecimal']['output'];
  otFlag: Scalars['Boolean']['output'];
  scheduledHours: Scalars['BigDecimal']['output'];
  weekStart: Scalars['LocalDate']['output'];
};

export type WeeklyScheduleAgentOutput = {
  __typename?: 'WeeklyScheduleAgentOutput';
  agentId: Scalars['UUID']['output'];
  canEdit: Scalars['Boolean']['output'];
  days: Array<ScheduleDayOutput>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type WeeklyScheduleOutput = {
  __typename?: 'WeeklyScheduleOutput';
  agents: Array<WeeklyScheduleAgentOutput>;
  canApplyTeamSchedule: Scalars['Boolean']['output'];
  canLoad: Scalars['Boolean']['output'];
  horizonEnd?: Maybe<Scalars['LocalDate']['output']>;
  horizonStart?: Maybe<Scalars['LocalDate']['output']>;
  maxLoadDays: Scalars['Int']['output'];
  weekLoaded: Scalars['Boolean']['output'];
};

export type WorkScheduleExportOutput = {
  __typename?: 'WorkScheduleExportOutput';
  agentCount: Scalars['Int']['output'];
  dayCount: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  html: Scalars['String']['output'];
  label: Scalars['String']['output'];
  pasteAt: Scalars['String']['output'];
  tsv: Scalars['String']['output'];
  xlsxBase64: Scalars['String']['output'];
};

export type WrapUpClientOutput = {
  __typename?: 'WrapUpClientOutput';
  clientId: Scalars['UUID']['output'];
  csrHandOffPending: Scalars['Boolean']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type WrapUpDoneOutput = {
  __typename?: 'WrapUpDoneOutput';
  clientId: Scalars['UUID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  itemType: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  resolutionLabel?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['Instant']['output']>;
};

export type WrapUpSectionOutput = {
  __typename?: 'WrapUpSectionOutput';
  completed: Array<WrapUpDoneOutput>;
  done: Scalars['Int']['output'];
  expiredCloseDate: Array<WrapUpClientOutput>;
  expiredNextContact: Array<WrapUpClientOutput>;
  missingApplicationPdf: Array<WrapUpClientOutput>;
  missingEnrollmentRecord: Array<WrapUpClientOutput>;
  total: Scalars['Int']['output'];
  undispositioned: Array<WrapUpClientOutput>;
};
